/* ==========================================================================
   CASEMIRA, LE PANIER                                    C4, vague 1, 30/08/26
   --------------------------------------------------------------------------
   Un seul fichier pour DEUX surfaces : le tiroir (feuille basse sous 1000 px,
   panneau de 480 px au-dessus) et la page /cart. Les deux rendent les memes
   snippets Liquid et sont pilotees par le meme code.

   VAGUE 13, LOT F (03/09) : LE SERVEUR NE FAIT PLUS QUE CONFIRMER. Le
   chronometre (`CHRONO-V13.md`) a montre que les 430 ms de `POST /cart/add`
   sont du temps de SERVEUR, incompressible et identique en 4G bridee. Ce qui
   se gagne est donc CE QUE LE TIROIR MONTRE PENDANT CE TEMPS : le pied entier
   et le bloc d'offre s'ecrivent des le clic, a partir d'un panier FICTIF (§ 5)
   passe au meme code de rendu que le panier reel (§ 3 bis). Quand `cart-update`
   arrive, il reecrit les memes chiffres.

   CE QUE CE FICHIER REMPLACE. `assets/cart.js` du theme Hyper ouvrait le
   tiroir en trois temps : un `fetch` d'ajout, un second `fetch` de la SECTION
   entiere (Rendering API), puis une transition de 600 ms sur le panneau et de
   800 ms sur le voile. Mesure du 30/08 sur le preview reel, telephone : le
   panneau etait POSE a 1 543 ms apres le clic. Ici, le tiroir s'ouvre AVANT
   le reseau, avec la ligne deja peinte a partir de ce que la page sait deja,
   et le serveur ne fait que confirmer.

   LES HUIT SECTIONS
     § 0  jetons, argent, requetes
     § 1  le controleur : ouvrir, fermer, verrou, calques, historique, focus
     § 2  le geste
     § 3  le rendu, depuis `/cart.js` et rien d'autre
     § 3b le pied, et le SEUL total (vague 13, lot F)
     § 4  les actions : quantite, suppression et « Annuler », format, code
     § 5  l'ajout qui se ressent
     § 6  la date de livraison
     § 7  l'offre duo, le code pose sans saisie et la rangee de complements
     § 8  le test A/B : le bras, l'attribut de panier, les quatre evenements
     § 9  `<cart-drawer>`, l'element de compatibilite

   CE QUI EST REPRIS AILLEURS, ET ASSUME COMME TEL. La mecanique de geste est
   celle de la feuille de filtres de la collection (`casemira-collection.js`,
   vague 21) : memes seuils, meme fenetre de vitesse de 90 ms, meme regle du
   `touchmove` NON PASSIF, et surtout la meme lecon - la propriete du geste ne
   se pose JAMAIS sur `<html>`, sinon le style de tout le document est
   invalide a chaque image (35 ms par pas mesures le 30/08 avant correction).
   Le verrou de defilement est celui du lecteur video, mot pour mot.
   ========================================================================== */

(function () {
  'use strict';

  /* ══════════════════════════════════════════════════════════════════════
     § 0. JETONS, ARGENT, REQUETES
     ══════════════════════════════════════════════════════════════════════ */

  var root = document.documentElement;

  /* Les seuils du geste, identiques a ceux de la feuille de filtres. */
  var DRAG_SLOP = 6; /* px : en deca, c'est un tap                          */
  var DRAG_DISTANCE = 80; /* px : au-dela, on ferme                         */
  var DRAG_VELOCITY = 0.5; /* px/ms : un geste vif vaut une longue distance */
  var DRAG_WINDOW = 90; /* ms : la vitesse se lit sur un lancer, pas sur    */
  /*                            tout le geste                               */
  var DRAG_RUBBER = 56; /* px : course maximale a contresens                */
  var DRAG_RUBBER_F = 0.15; /* le facteur de la vague 21 : un geste de      */
  /*                            112 px ne remonte la feuille que de 18 px   */

  var UNDO_MS = 3000; /* la fenetre d'annulation apres une suppression      */
  var DESKTOP = 1000; /* px : la frontiere feuille / tiroir                 */

  var KL_MIN = 3500; /* bornes Klarna, recopiees des gabarits de fiche      */
  var KL_MAX = 300000; // 18/09 : plafond releve a 3 000 EUR (Klarna 3x accepte 2 140 EUR au checkout FR et DE, test reel)

  /* 17/09 · bornes du « Paiement en 4X » de PayPal France, recopiees du pied
     (`snippets/casemira-cart-pied.liquid`) comme les deux precedentes : 20 EUR
     a 3 000 EUR. Elles ne servent QUE si Liquid a rendu la ligne francaise ;
     hors de France le noeud n'existe pas et rien ne les lit.                */
  var PP_MIN = 2000;
  var PP_MAX = 300000;

  function desktop() {
    return window.innerWidth >= DESKTOP;
  }

  function $(sel, ctx) {
    return (ctx || document).querySelector(sel);
  }

  function $$(sel, ctx) {
    return Array.prototype.slice.call((ctx || document).querySelectorAll(sel));
  }

  /* ── ★ VAGUE R1 (04/09) · LES PHRASES, ET ELLES NE SONT PLUS ICI ───────
     Ce fichier ecrivait trente-trois phrases francaises en dur, dont cinq
     etaient DEJA ecrites en Liquid a cote (la ligne de panier, le pack) : le
     serveur peignait la premiere image en francais traduit, le script
     repeignait la suivante en francais code en dur, et une boutique anglaise
     aurait vu le mot changer au premier `cart-update`.

     LA TABLE EST LUE UNE SEULE FOIS, ICI, au chargement du module. Ni a chaque
     rendu, ni a chaque ligne : `ligneHTML` tourne une fois par article et les
     chronos du tiroir se mesurent en dixiemes de milliseconde.

     LE REPLI EST CODE, TOUJOURS. Une cle absente du fichier de locale fait
     rendre a `| t` la chaine « Translation missing: ... » et une zone jamais
     remplie reste `{}` : le repli garantit qu'aucun ecran n'affiche
     `undefined` pendant qu'une vague est en cours. C'est la regle du § 3 de
     `CONVENTION.md`, sans exception.

     LES INTERPOLATIONS voyagent en jeton entre crochets (`[produit]`, `[code]`,
     `[n]`), pose par `casemira-js-strings.liquid` et remplace par `avec()`. */
  var S = (window.FoxTheme && FoxTheme.casemira && FoxTheme.casemira.panier) || {};

  function avec(gabarit, jeton, valeur) {
    return String(gabarit).split('[' + jeton + ']').join(valeur);
  }

  /* ── L'argent ───────────────────────────────────────────────────────────
     Le format vient de la boutique (`shop.money_format`, pose en JSON par le
     pied) : ecrire « x,xx € » en dur ici ferait une seconde verite le jour ou
     la boutique changera de devise. L'algorithme est celui de Shopify, celui
     que tous les themes embarquent.

     ── R11b (05/09) · LE FORMAT SUIT LA LANGUE, ET SES SOURCES SONT RANGEES ──
     `shop.money_format` est UNIQUE pour la boutique : il ecrivait « 1.234,56 € »
     sur /en pendant que le reste de la page disait « €1,234.56 ». La table des
     formats par langue est `snippets/cm-prix.liquid` (R11), et elle arrive ici
     par TROIS portes qui disent toutes la meme chose depuis R11b :

       1. `FoxTheme.casemira.prix.format`, le pont de `casemira-js-strings` ;
       2. `FoxTheme.settings.moneyFormat`, deja localise par `js-variables` ;
       3. `CFG.money`, le JSON du pied, localise par `casemira-cart-pied`.

     L'ORDRE COMPTE, meme si les trois concordent : le JSON du pied est du HTML,
     et le HTML d'un tiroir peut avoir ete mis en cache avant R11b. Les deux
     premieres sources sont ecrites a chaque chargement de page. L'ALGORITHME,
     lui, ne change pas d'une ligne : il applique le gabarit qu'on lui donne. */
  /* ── i18n 06/09 · LES APPELS AJAX PARLENT LA LANGUE DE LA PAGE ──────────────
     `/cart.js`, `/cart/add.js`, `/cart/change.js` et `/products/<handle>.js`
     repondent dans la langue de la boutique (francais) quand on les appelle a la
     racine : sur /en le tiroir ecrivait « Rectangulaire », « Speciale ». Prefixes par
     `Shopify.routes.root` (« /en/ » sur un sous-dossier de langue, « / » sinon), les
     memes points de terminaison rendent les titres et valeurs d'option traduits. */
  var RACINE = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  if (RACINE.charAt(RACINE.length - 1) !== '/') RACINE += '/';

  var MONNAIE_REPLI = '{{amount_with_space_separator}} €';
  var CFG = { money: MONNAIE_REPLI, livraison: '%date%', portMin: 10000 };
  try {
    var cfgEl = $('[data-cmk-config]');
    if (cfgEl) CFG = JSON.parse(cfgEl.textContent);
  } catch (e) {
    /* on garde le repli */
  }

  function gabarit() {
    var P = (window.FoxTheme && FoxTheme.casemira && FoxTheme.casemira.prix) || {};
    if (P.format) return P.format;
    if (window.FoxTheme && FoxTheme.settings && FoxTheme.settings.moneyFormat) {
      return FoxTheme.settings.moneyFormat;
    }
    return CFG.money || MONNAIE_REPLI;
  }

  /* Les variantes sans centimes que Shopify definit. Un jeton absent de cette
     table (`amount_with_apostrophe_separator`) garde ses centimes plutot que
     d'inventer un format. */
  var SANS_CENTIMES = {
    amount: 'amount_no_decimals',
    amount_with_comma_separator: 'amount_no_decimals_with_comma_separator',
    amount_with_space_separator: 'amount_no_decimals_with_space_separator'
  };

  /* LE SYMBOLE N'EST PAS ECRIT EN DUR (R11b) : il se lit sur le gabarit, en
     lui retirant son jeton et ses espaces. Un changement de devise le suit. */
  function symboleMonnaie() {
    var sym = gabarit()
      .replace(/<[^>]*>/g, '')
      .replace(/\{\{\s*\w+\s*\}\}/, '')
      .replace(/\s/g, '');
    return sym || '€';
  }

  function gabaritSansZeros() {
    var P = (window.FoxTheme && FoxTheme.casemira && FoxTheme.casemira.prix) || {};
    if (P.format_sans_zeros) return P.format_sans_zeros;
    var fmt = gabarit();
    var jeton = /\{\{\s*(\w+)\s*\}\}/.exec(fmt);
    var court = jeton && SANS_CENTIMES[jeton[1]];
    return court ? fmt.replace(jeton[1], court) : fmt;
  }

  function pad(n, w) {
    var s = String(n);
    while (s.length < w) s = '0' + s;
    return s;
  }

  function groupe(nombre, sep) {
    return nombre.replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + sep);
  }

  function eur(cents) {
    return eurFmt(cents, gabarit());
  }

  function eurFmt(cents, fmt) {
    var v = (cents || 0) / 100;
    fmt = fmt || '';
    var placeholder = /\{\{\s*(\w+)\s*\}\}/.exec(fmt);
    var nom = placeholder ? placeholder[1] : 'amount_with_space_separator';
    var dec = nom.indexOf('no_decimals') > -1 ? 0 : 2;
    var brut = v.toFixed(dec);
    var parts = brut.split('.');
    var ent = parts[0];
    var frac = parts[1] || '';
    var sepMille = ' ';
    var sepDec = ',';
    if (nom.indexOf('comma_separator') > -1) {
      sepMille = '.';
    } else if (nom.indexOf('apostrophe_separator') > -1) {
      sepMille = "'";
    } else if (nom.indexOf('space_separator') > -1) {
      sepMille = ' ';
    } else {
      sepMille = ',';
      sepDec = '.';
    }
    var val = groupe(ent, sepMille) + (dec ? sepDec + pad(frac, 2) : '');
    return fmt.replace(/\{\{\s*\w+\s*\}\}/, val);
  }

  /* Le montant Klarna. Il ecrivait « 16,34 € » A LA MAIN : virgule decimale et
     symbole codes en dur, donc « 16,34 € » aussi sur /en, sous un total deja
     ecrit « €49.00 ». Il passe desormais par le meme gabarit que tout le reste,
     dans sa variante SANS DECIMALES quand le montant est rond : c'est ce que
     rend `money_without_trailing_zeros` cote Liquid, sur la meme ligne, avant
     que le script ne repeigne.

     LE RENDU FRANCAIS NE BOUGE PAS sur la plage ou cette ligne existe : Klarna
     est borne a 1 500 €, la mensualite vaut donc au plus 500 € et ne porte
     jamais de separateur de milliers. « 16,34 € » et « 20 € » s'ecrivent
     exactement comme avant. */
  function klarnaMoney(cents) {
    var rond = ((cents || 0) % 100) === 0;
    return eurFmt(cents, rond ? gabaritSansZeros() : gabarit());
  }

  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  /* ── ★ LOT K (03/09, 19 h 55) · L'ORDINAL FRANCAIS, EN EXPOSANT ─────────
     RAPH : « au lieu de 2E, mets-moi le eme en format francais ». La ligne
     forte du bandeau est en PETITES CAPITALES (`.cmk__off-t b`) : « 2e » s'y
     peint « 2E ». La typographie francaise ecrit « 2ᵉ », le chiffre suivi de
     sa terminaison EN EXPOSANT ; « 2ème » est l'usage courant et il est
     fautif, mais si Raph l'ecrit dans le reglage, « ème » passera en exposant
     de la meme facon.

     C'EST LE PENDANT EXACT DU FILTRE LIQUID `casemira-exposant.liquid`, et
     les deux doivent rendre la MEME chose : Liquid ecrit le bandeau au
     chargement, ce script le REECRIT des que le panier change (`majTete`,
     `majSousTitre`). Un seul des deux qui composerait l'exposant ferait
     clignoter la typographie au premier ajout.

     ON ECHAPPE AVANT D'INSERER, JAMAIS L'INVERSE. Le titre vient d'un reglage
     libre de l'editeur de theme et les gabarits voyagent en attribut : ce sont
     des chaines de TEXTE, et elles le restent. `esc()` les rend inertes, et
     seul le `<sup>` que nous ajoutons ensuite est du HTML. C'est la seule
     raison pour laquelle `innerHTML` est ecrit ici plutot que `textContent`.

     LES TERMINAISONS SONT ESSAYEES DE LA PLUS LONGUE A LA PLUS COURTE : une
     alternance d'expression reguliere s'arrete au PREMIER membre qui tombe, et
     « e » place avant « ème » rendrait « 2ᵉme ». La sentinelle de fin refuse
     une lettre ou un chiffre juste apres.

     ★ VAGUE R1 (04/09) · ET LA REGLE EST BORNEE AU FRANCAIS. Les terminaisons
     ci-dessous sont des mots francais. Hors du francais elles trouvent d'autres
     mots : l'allemand « 2er » (Zweier) rendrait « 2ᵉʳ », et le neerlandais
     « 2e », qui est deja la forme correcte, se verrait mis en exposant sans
     qu'on l'ait demande. Meme borne que le filtre Liquid
     `snippets/casemira-exposant.liquid`, qui teste `request.locale.iso_code` :
     les deux chemins doivent rendre la meme chose dans chaque langue, sinon la
     typographie clignote au premier ajout. Hors francais, le texte ressort
     ECHAPPE et intact. */
  var EXPOSANT_MOTIF = /(\d)(èmes|ères|ème|ère|ers|es|er|e)(?![A-Za-zÀ-ÖØ-öø-ÿ0-9])/g;
  var EXPOSANT_FR = String((window.Shopify && window.Shopify.locale) || '')
    .toLowerCase()
    .slice(0, 2) === 'fr';

  function exposant(s) {
    if (!EXPOSANT_FR) return esc(s);
    return esc(s).replace(EXPOSANT_MOTIF, function (tout, chiffre, suffixe) {
      return chiffre + '<sup class="cmk__exp">' + suffixe + '</sup>';
    });
  }

  /* Le seul point d'ecriture des textes composes du bandeau. */
  function poseExposant(el, texte) {
    if (el) el.innerHTML = exposant(texte);
  }

  function post(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    }).then(function (r) {
      return r.json().then(function (j) {
        if (!r.ok) throw j;
        return j;
      });
    });
  }

  function panierFrais() {
    return fetch(RACINE + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) {
      return r.json();
    });
  }

  /* Le compteur de l'en-tete est un `<cart-count>` du theme, abonne au bus
     `cart-update`. On publie donc sur ce bus plutot que d'ecrire dans le DOM :
     quatre scripts Casemira ecrivent aujourd'hui `textContent = item_count` a
     la main et cassent au passage la regle « 99+ » et le `hidden` a zero. */
  var moiMeme = false;

  function publier(cart) {
    try {
      if (window.FoxTheme && FoxTheme.pubsub) {
        moiMeme = true;
        FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, { cart: cart });
        moiMeme = false;
      }
    } catch (e) {
      moiMeme = false;
    }
  }

  /* ══════════════════════════════════════════════════════════════════════
     § 1. LE CONTROLEUR
     ══════════════════════════════════════════════════════════════════════ */

  var scene = null; /* `<cart-drawer>` ou, sur /cart, la colonne de page   */
  var estTiroir = false;
  var ouvert = false;
  var pousse = false; /* une entree d'historique nous appartient           */
  var popAttendu = false;
  var revenirA = null; /* l'element qui reprend le focus a la fermeture    */
  var dernierPanier = null;

  function sheet() {
    return scene ? $('[data-cmk-sheet]', scene) : null;
  }

  function corps() {
    return scene ? $('[data-cmk-body]', scene) : null;
  }

  function dire(texte) {
    var live = scene ? $('[data-cmk-live]', scene) : null;
    if (live) live.textContent = texte;
  }

  /* ── Le verrou de defilement ────────────────────────────────────────────
     `overflow` sur la racine, jamais `position: fixed` sur `body`, qui
     perdrait la position de lecture. La largeur de la barre de defilement est
     mesuree : sans elle, la page sauterait de quelques pixels sur les
     machines qui en affichent une. */
  /* ── VAGUE 5 : LA LARGEUR DE LA BARRE EST MESUREE UNE FOIS, PAS AU CLIC ──
     Elle l'etait DANS `ouvre()`, juste apres `classList.add('cmk-open')` : une
     lecture de `root.clientWidth` a cet instant force le navigateur a
     recalculer le style ET la mise en page de TOUT le document avec la classe
     fraichement posee, avant de rendre la main. Et l'ecriture qui suivait
     (`--cmk-sbw` sur la RACINE) invalidait le style du document entier une
     seconde fois - le defaut exact que la feuille du panier interdit deja
     pendant le geste, et qui etait commis a l'ouverture.

     MESURE DU 31/08, processeur bride x6 (le telephone reel) : l'ecouteur de
     clic du panier coutait 101 ms a lui seul, et le navigateur ne peut peindre
     la premiere image du mouvement qu'a la FIN de la tache du clic. La feuille
     arrivait donc a l'ecran deja aux trois quarts montee : « animation
     d'ouverture absente ».

     La largeur ne depend que de la fenetre : elle se mesure au demarrage et a
     chaque redimensionnement, jamais sur le chemin du clic. */
  var sbwPose = false;

  function mesureLaBarre() {
    if (root.classList.contains('cmk-locked')) return;
    var sbw = window.innerWidth - root.clientWidth;
    root.style.setProperty('--cmk-sbw', sbw + 'px');
    sbwPose = true;
  }

  window.addEventListener('resize', function () {
    mesureLaBarre();
  });

  function verrouille() {
    if (!sbwPose) mesureLaBarre();
    root.classList.add('cmk-locked');
  }

  function deverrouille() {
    root.classList.remove('cmk-locked');
  }

  /* ── L'historique ───────────────────────────────────────────────────────
     Sans cela, le premier reflexe d'un visiteur pris dans une feuille plein
     ecran (retour Android, glissement depuis le bord sur iOS) le fait QUITTER
     la page. On empile donc une entree a l'ouverture. */
  /* ON N'EMPILE PAS PAR-DESSUS UNE ENTREE QUI N'EST PAS A NOUS, ET LA RECETTE
     DU 05/09 (r7-surcouche.mjs, controle D1) DIT POURQUOI. Le guide des tailles
     empile lui aussi (`casemira-guide-tiroir.js`, § « L'historique »), et son
     `popstate` se referme sur tout pop qu'il n'a pas demande TANT QU'IL TIENT
     UNE ENTREE. Guide ouvert d'abord, panier ouvert par-dessus : fermer le
     panier a la croix appelait `history.back()`, le guide voyait passer le pop
     et se refermait avec lui, sans que personne le lui ait demande. La classe
     `cm-over` etait alors retiree A BON DROIT - plus personne ne la tenait -
     mais le visiteur perdait le guide sous son panier.

     C'est le MIROIR EXACT de la garde que `casemira-guide-tiroir.js` pose deja
     sur `cmk-open` pour l'ordre inverse. Tant que `cmg-lock` est la, le guide
     tient deja une entree : on la lui laisse, et le geste de retour refermera
     les deux d'un coup, chacun par son propre `popstate`. Le panier reste
     refermable a la croix, a Echap et au voile, ce qui n'empile ni ne depile
     rien. Le premier des deux a s'ouvrir empile toujours : la paire ne peut
     pas se retrouver sans entree.

     Les deux guides sont nommes : celui des fiches couloir
     (`casemira-guide-tiroir.js`) et celui des fiches HORS couloir
     (`casemira-guide-tailles.js`, R5). Ils ont la meme paire empile/depile et
     le meme `popstate`, donc exactement le meme defaut dans le meme ordre.
     Leurs gardes a eux ne nomment que `cmk-open`, que nous retirons
     synchroniquement : c'est ici, du cote du panier, que le miroir se pose.

     ON LIT `cmg-ouvert` / `cmt-ouvert`, ET SURTOUT PAS `cmg-lock` / `cmt-lock`.
     La revue du tour 2 a trouve la casse, et elle etait atteignable au doigt :
     les classes de VERROU ne partent que dans le `fin()` differe des guides,
     `dureeSortie() + 40` ms - 460 ms en pratique - apres la fermeture logique.
     Un visiteur qui ferme le guide au voile puis tape l'icone panier dans la
     foulee, deux touchers naturels au meme endroit, tombait sur un panier qui
     voyait encore le verrou, n'empilait pas, et dont le geste de retour
     QUITTAIT LA PAGE. Les marques `-ouvert` sont posees et retirees en tete de
     `ouvre` et de `ferme`, avant tout differe : elles disent l'etat de la
     machine, la ou les marques `-lock` disent l'occupation de l'ecran.

     DEUX ROLES, DEUX MARQUES, ET ON NE LES MELANGE PAS : `cmg-lock` et
     `cmt-lock` restent reservees a l'arbitrage de `cm-over` - ou il FAUT tenir
     pendant la sortie, sans quoi le bandeau de consentement se rallume au
     milieu du mouvement. C'est le meme raisonnement qui donne deux reponses
     opposees a deux questions differentes. */
  /* ── L'ADRESSE APRES LA SORTIE, ET IL Y A DEUX SORTIES ───────────────────
     Motif de `casemira-guide-tailles.js` (G3.4) et de `casemira-guide-tiroir.js`,
     porte ici a l'identique. Notre entree est empilee avec l'adresse du moment,
     et d'autres scripts la reecrivent par `replaceState` SUR NOTRE ENTREE, pas
     sur la precedente : `?variant=` du selecteur de format
     (`casemira-size-picker.js` l.870), `#avis` de l'ancre douce de la fiche
     (`casemira-pdp-reskin.js` l.558). Les deux sorties rendaient donc l'adresse
     d'avant, alors que la page affiche encore l'autre.
       · sortie que NOUS demandons (croix, voile, Echap) : `urlSortie`, retenue
         avant `history.back()`, reposee sur l'entree d'arrivee ;
       · GESTE DE RETOUR : l'adresse a deja recule quand `popstate` arrive, donc
         on ne peut plus la lire ; `urlVivante` la garde depuis l'empilage.
     Le tiroir panier ne reecrit jamais l'adresse pendant qu'il est ouvert (rien
     ici n'appelle `replaceState`, et la page derriere est inerte) : la relever a
     l'empilage suffit, la ou les deux guides la relevent aussi a chaque dessin.
     Dans les deux cas `replaceState` : aucune entree ajoutee, `history.state`
     repasse tel quel, le geste de retour suivant quitte toujours la page. */
  var urlSortie = '';   /* l'adresse d'avant NOTRE `history.back()`         */
  var urlVivante = '';  /* l'adresse tant que notre entree est empilee      */

  function empile() {
    if (pousse) return;
    if (root.classList.contains('cmg-ouvert') || root.classList.contains('cmt-ouvert')) return;
    try {
      history.pushState({ cmkCart: 1 }, '', location.href);
      pousse = true;
      urlVivante = location.href;
    } catch (e) {
      pousse = false;
      /* PAS D'ENTREE, PAS D'ADRESSE RETENUE. Les deux vont ensemble, et c'est
         le premier des trois chemins de purge (avec `depile()` et la branche
         du geste de retour) : `urlVivante` ne doit jamais survivre a
         l'ouverture qui l'a relevee. */
      urlVivante = '';
    }
  }

  function depile() {
    if (!pousse) return;
    pousse = false;
    popAttendu = true;
    urlSortie = location.href;
    urlVivante = '';
    try {
      history.back();
    } catch (e) {
      popAttendu = false;
      urlSortie = '';
    }
  }

  window.addEventListener('popstate', function () {
    if (popAttendu) {
      popAttendu = false;
      if (urlSortie && location.href !== urlSortie) {
        try { history.replaceState(history.state, '', urlSortie); } catch (e) {}
      }
      urlSortie = '';
      return;
    }
    if (ouvert) {
      /* `pousse` EN TETE DE LA GARDE, ET CE N'EST PAS DECORATIF. Le panier peut
         etre ouvert SANS entree a lui : quand un guide tenait deja la sienne,
         `empile()` lui a laisse (garde `cmg-ouvert` / `cmt-ouvert` juste
         au-dessus). Le pop est alors CELUI DU GUIDE ; notre entree n'existe
         pas, l'entree d'arrivee n'est pas la notre, et il n'y a aucune adresse
         a y reposer. Les deux guides obtiennent la meme chose par leur
         `if (!pousse) return` en amont ; ici la garde est portee par la
         restitution elle-meme, parce que le panier, lui, se referme sur TOUT
         pop qu'il n'a pas demande, entree ou pas - c'est ce que dit le pave
         « L'historique », et ce comportement de fermeture ne change pas. */
      if (pousse && urlVivante && location.href !== urlVivante) {
        try { history.replaceState(history.state, '', urlVivante); } catch (e) {}
      }
      urlVivante = '';
      pousse = false;
      ferme(true);
    }
  });

  /* ── VAGUE 5 : DEUX TEMPS, ET LE PREMIER NE CONTIENT QUE LE MOUVEMENT ────
     Un navigateur ne peint RIEN avant la fin de la tache en cours. Tout ce qui
     est fait dans l'ecouteur de clic retarde donc, milliseconde pour
     milliseconde, la premiere image de la montee - et la transition, elle, a
     deja commence a compter. Le premier temps ne contient plus que ce qui
     CHANGE L'IMAGE ; le second, joue a l'image suivante, contient tout ce qui
     ne se voit pas : l'historique, le focus, les compteurs, l'observateur.

     CHRONOS DU 31/08 SUR LE PREVIEW REEL, ET ILS DISENT AUSSI CE QUE CE
     CORRECTIF NE PEUT PAS FAIRE. Notre ecouteur passe de 30,9 ms a moins de
     0,2 (le plancher d'enregistrement de la sonde) sur une machine de bureau,
     et de 101,3 ms a la meme chose sous un processeur bride x6. La premiere
     image du mouvement, elle, passe de 123 a 117 ms sur la machine de bureau,
     mediane de trois ouvertures - le budget de 120 ms est tenu. Sous un
     processeur bride x6 elle reste a 438 ms contre 458 : la tache du clic y
     est remplie par les pixels web de Shopify, un ecouteur du theme et le
     gestionnaire de soumission du formulaire d'ajout, et un navigateur ne peut
     pas peindre au milieu d'une tache. Ce qui NOUS appartenait est parti. */
  /* UNE IMAGE `requestAnimationFrame` NE SUFFIT PAS, ET LA PREMIERE MESURE L'A
     MONTRE. Le rappel d'un `requestAnimationFrame` s'execute AU DEBUT de
     l'etape de rendu, donc AVANT la peinture de cette image : y mettre le
     travail differe le replacait exactement la ou il genait, une image plus
     loin. Mesure du 31/08, processeur bride x6 : la premiere image du
     mouvement etait passee de 458 a 574 ms, et il n'en restait qu'UNE.

     La forme juste est `requestAnimationFrame` PUIS `setTimeout` : le rappel
     de l'image sert seulement a attendre l'etape de rendu, et la tache du
     `setTimeout` ne peut se placer qu'APRES la peinture qui la suit. */
  function apresLImage(fn) {
    if (typeof requestAnimationFrame !== 'function') {
      setTimeout(fn, 0);
      return;
    }
    requestAnimationFrame(function () {
      setTimeout(fn, 0);
    });
  }

  /* UN JETON PAR OUVERTURE, ET IL EST NECESSAIRE. Le second temps est une
     tache differee : entre le moment ou elle est posee et celui ou elle
     s'execute, la feuille peut avoir ete FERMEE puis ROUVERTE (un glissement
     de fermeture suivi d'un clic, deux dixiemes de seconde). Un simple
     `if (!ouvert) return` laisserait alors passer la tache de la PREMIERE
     ouverture pendant la SECONDE, et `drawer_open` partirait deux fois pour
     une seule ouverture. Le jeton dit « cette tache appartient-elle encore a
     l'ouverture qui l'a posee ». */
  var jetonOuverture = 0;

  /* ── LE FOCUS POSÉ PAR LE SCRIPT, SANS ANNEAU AU DOIGT ──────────────────
     Correctif du 28/10, 17 h (retour de Raphaël sur l'aperçu réel, iPhone) :
     « un rond autour de la croix du tiroir, puis autour de l'icône panier
     quand le focus y revient ». Les deux focus sont voulus (la sortie à
     l'ouverture, le déclencheur à la fermeture) ; c'est leur DESSIN qui ne
     l'est pas. Safari iOS fait correspondre `:focus-visible` à un focus posé
     par script quand rien n'avait le focus avant (un toucher ne focalise pas
     un lien), et l'anneau doré du thème se dessine.

     La règle : la modalité de la DERNIÈRE interaction décide. Une touche du
     clavier (hors raccourcis) passe en mode clavier et l'anneau reste, comme
     il le doit ; un pointeur ou un toucher passe en mode pointeur, et
     l'élément focalisé par le script porte `cm-focus-muet` (casemira-cart.css
     § 14) jusqu'à sa sortie du focus ou jusqu'à la première touche du
     clavier. `focusVisible` est passé aussi pour les moteurs qui le lisent. */
  var modaliteClavier = false;

  function leveLeMuet() {
    $$('.cm-focus-muet').forEach(function (el) {
      el.classList.remove('cm-focus-muet');
    });
  }

  document.addEventListener(
    'keydown',
    function (event) {
      if (event.metaKey || event.ctrlKey || event.altKey) return;
      modaliteClavier = true;
      leveLeMuet();
    },
    true
  );

  ['pointerdown', 'mousedown', 'touchstart'].forEach(function (type) {
    document.addEventListener(
      type,
      function () {
        modaliteClavier = false;
      },
      { capture: true, passive: true }
    );
  });

  function focusDiscret(el) {
    if (!el || typeof el.focus !== 'function') return;
    if (!modaliteClavier) {
      el.classList.add('cm-focus-muet');
      var retire = function () {
        el.classList.remove('cm-focus-muet');
        el.removeEventListener('blur', retire);
      };
      el.addEventListener('blur', retire);
    }
    try {
      el.focus({ preventScroll: true, focusVisible: modaliteClavier });
    } catch (e) {
      /* l'element a pu disparaitre */
    }
  }

  function ouvre(depuis) {
    if (!estTiroir || !scene) return;
    if (ouvert) return;
    revenirA = depuis || document.activeElement;
    ouvert = true;
    jetonOuverture++;
    var monJeton = jetonOuverture;
    /* PREMIER TEMPS : l'image. Trois classes, un attribut, un `inert` retire.
       Aucune lecture de geometrie, aucune ecriture sur la racine. */
    root.classList.add('cmk-open');
    /* `cm-over` est le nom generique de « une surcouche plein ecran est
       ouverte » (`casemira-tokens.css`) : le lanceur du chat, son teaser et
       le bandeau de consentement s'effacent tant qu'elle vit. */
    root.classList.add('cm-over');
    /* Le verrou reste au premier temps, et il le faut : une image de
       defilement de la page derriere se verrait. Il ne coute plus qu'une
       classe. */
    verrouille();
    scene.setAttribute('data-cmk-open', '');
    var s = sheet();
    if (s) s.removeAttribute('inert');
    /* § 8 : le denominateur du test. Le drapeau « offre vue » retombe ici,
       pour qu'une ouverture ne puisse porter qu'un `offer_shown`. */
    vuEnvoye = false;
    /* Casemira 28/10/2026 (offre de novembre) : la jauge des paliers se
       remplit à chaque ouverture (bascule de classe, aucune lecture de
       géométrie) et `jauge_affichee` part. */
    jaugeALOuverture();

    /* SECOND TEMPS : tout ce qui ne se voit pas. */
    apresLImage(function () {
      if (!ouvert || monJeton !== jetonOuverture) return;
      empile();
      /* Le focus part sur la croix : c'est la sortie, et c'est le premier
         element du panneau. Il part APRES la premiere image : un focus pose
         sur un element encore hors du cadre fait defiler la page dans
         certains moteurs, et il coute un recalcul de style. */
      var x = $('[data-cmk-close]', scene);
      if (x) focusDiscret(x);
      document.dispatchEvent(new CustomEvent('cmk:open'));
      surveilleLOffre();
      /* VAGUE 13 : le tiroir ferme vit hors du cadre ; ses rangees defilantes
         ne se mesurent utilement qu'une fois la feuille en place. */
      prevoisLesFondus();
      mesure('drawer_open');
    });
  }

  /* ON NE RETIRE QUE CE QU'ON A POSE, ET SEULEMENT SI PLUS PERSONNE NE LA
     TIENT. `cm-over` est partagee par cinq surcouches. Le panier la retirait
     en aveugle a la fermeture : si une autre surcouche vivait encore - le
     guide des tailles ouvert par-dessus le panier depuis la colonne d'achat,
     la mini-fiche d'une collection d'ou l'on vient d'ajouter au panier, le
     tiroir de navigation, la recherche - le bandeau de consentement et la
     pastille de chat se rallumaient PAR-DESSUS elle. C'est la faute deja
     corrigee dans `casemira-c6-loupe.js` (vague 4, § « ON NE RETIRE PAS
     cm-over SI QUELQU'UN D'AUTRE LA REVENDIQUE »), `casemira-c6-tiroir.js`
     (vague R1) et `casemira-guide-tiroir.js` (C5, 05/09) ; meme forme ici.

     Les revendicateurs sont NOMMES un par un, et pas devines par un selecteur
     large : la lecon de la vague 4 est qu'un selecteur trop large
     (`.drawer[open]`) laisse `cm-over` posee pour toujours, et qu'un bandeau
     de consentement qu'on oublie de RALLUMER est un defaut plus grave que
     l'inverse. On ne nomme donc que ce qui pose reellement `cm-over` :
       · `cmq-locked`, la mini-fiche des collections (`casemira-collection-plus.js`) ;
       · `cmg-lock`, le guide des tailles des fiches couloir (`casemira-guide-tiroir.js`) ;
       · `search-open` / `search-is-open`, la recherche predictive du theme ;
       · `menu-drawer[open]`, le tiroir de navigation.
     `cmk-open` est notre propre marque : elle n'a rien a faire ici, et elle
     part de toute facon AVANT l'interrogation, juste en dessous. Le lecteur
     video passe par `csm-video-open`, qui a sa propre paire de regles dans les
     tokens : il n'est pas concerne. */
  function quelquUnDAutreLaTient() {
    return (
      root.classList.contains('cmq-locked') ||
      root.classList.contains('cmg-lock') ||
      /* `cmt-lock`, le guide des tailles des fiches HORS couloir (`casemira-guide-tailles.js`, ajout R5, 05/09) ; */
      root.classList.contains('cmt-lock') ||
      document.body.classList.contains('search-open') ||
      document.body.classList.contains('search-is-open') ||
      !!document.querySelector('menu-drawer[open]')
    );
  }

  function ferme(depuisHistorique) {
    if (!estTiroir || !ouvert) return;
    ouvert = false;
    /* `cmk-open` part D'ABORD : c'est la marque par laquelle les autres
       arbitres nous reconnaissent, et l'interroger en la portant encore ferait
       du panier son propre revendicateur. */
    root.classList.remove('cmk-open');
    if (!quelquUnDAutreLaTient()) root.classList.remove('cm-over');
    /* Le geste part avec la feuille : la classe quitte la SCENE et la
       propriete quitte le PANNEAU, tant que les deux sont encore la. */
    gesteRepose();
    deverrouille();
    scene.removeAttribute('data-cmk-open');
    var s = sheet();
    if (s) s.setAttribute('inert', '');
    if (!depuisHistorique) depile();
    if (revenirA && document.contains(revenirA)) focusDiscret(revenirA);
    revenirA = null;
    document.dispatchEvent(new CustomEvent('cmk:close'));
  }

  /* ── Le piege a focus ───────────────────────────────────────────────────
     Ecrit ici plutot qu'emprunte a `FoxTheme.a11y` : le tiroir est le seul
     calque de ce fichier, la regle tient en dix lignes, et une dependance de
     moins est une panne de moins. */
  document.addEventListener('keydown', function (event) {
    if (!ouvert) return;
    if (event.key === 'Escape') {
      event.preventDefault();
      ferme();
      return;
    }
    if (event.key !== 'Tab') return;
    var s = sheet();
    if (!s) return;
    var f = $$(
      'a[href], button:not([disabled]), input:not([disabled]), select, textarea, [tabindex]:not([tabindex="-1"])',
      s
    ).filter(function (el) {
      return el.offsetWidth > 0 || el.offsetHeight > 0;
    });
    if (!f.length) return;
    var premier = f[0];
    var dernier = f[f.length - 1];
    if (event.shiftKey && document.activeElement === premier) {
      event.preventDefault();
      dernier.focus();
    } else if (!event.shiftKey && document.activeElement === dernier) {
      event.preventDefault();
      premier.focus();
    }
  });

  /* ══════════════════════════════════════════════════════════════════════
     § 2. LE GESTE
     ----------------------------------------------------------------------
     Sur telephone la feuille descend, sur ordinateur le tiroir part vers la
     droite : c'est le MEME code, seul l'axe change. Trois zones l'arment - la
     poignee (qui porte aussi le titre et la croix), le voile, et le corps
     defilant quand il est deja en haut.

     La propriete personnalisee est posee sur le PANNEAU et la classe sur la
     SCENE. Jamais sur `<html>` : une propriete personnalisee est HERITEE, et
     la reposer sur la racine invalide le style de tout le document a chaque
     image du geste. C'est le defaut mesure a 35 ms par pas sur la feuille de
     filtres le 30/08 ; il n'est pas refait ici.
     ══════════════════════════════════════════════════════════════════════ */

  var glisse = false;
  var arme = false;
  var idPointeur = null;
  var d0 = 0; /* la coordonnee de depart sur l'axe du geste                */
  var t0 = 0;
  var trace = [];
  var bouge = false;

  function axe() {
    return desktop() ? 'x' : 'y';
  }

  function coord(x, y) {
    return axe() === 'x' ? x : y;
  }

  function echantillon(d, t) {
    trace.push({ d: d, t: t });
    while (trace.length > 2 && t - trace[0].t > DRAG_WINDOW) trace.shift();
  }

  function vitesse(d, t) {
    var a = trace.length ? trace[0] : { d: d0, t: t0 };
    return (d - a.d) / Math.max(1, t - a.t);
  }

  function decalage(dd) {
    if (dd >= 0) return dd;
    /* A contresens : elastique COURT. Un facteur de 0,5 poussait la feuille
       de 56 px pleins pour un geste de 112, donc la croix et la poignee sous
       l'encoche (retour de Raph du 30/08 sur la mini-fiche). */
    return Math.max(-DRAG_RUBBER, dd * DRAG_RUBBER_F);
  }

  function gesteArme() {
    if (scene) scene.classList.add('cmk-drag');
    var s = sheet();
    if (s) s.style.willChange = 'transform';
  }

  function gesteBouge(dd) {
    var s = sheet();
    if (!s) return;
    s.style.setProperty(axe() === 'x' ? '--cmk-dx' : '--cmk-dy', Math.round(dd) + 'px');
  }

  function gesteRepose() {
    if (scene) scene.classList.remove('cmk-drag');
    var s = sheet();
    if (s) {
      s.style.removeProperty('--cmk-dy');
      s.style.removeProperty('--cmk-dx');
      s.style.willChange = '';
    }
  }

  function debut(cible, x, y, t, id, capture, type) {
    if (glisse) return true;
    bouge = false;
    if (!ouvert || !estTiroir) return false;
    if (!cible || typeof cible.closest !== 'function') return false;

    /* UN GESTE NE PART JAMAIS D'UNE COMMANDE, ET CE N'EST PAS UN DETAIL.
       Premiere passe : la croix etait DANS la poignee, donc un appui dessus
       armait le geste ET posait `setPointerCapture` sur le panneau. Or la
       capture de pointeur DEPLACE LA CIBLE DU `click` : l'evenement etait
       dispatche sur le panneau, plus sur le bouton, et le tiroir ne se
       fermait pas. Mesure du 30/08 sur le preview : la croix restait sans
       effet aux trois largeurs, en Chromium comme en WebKit, alors que le
       geste, Echap et le voile fonctionnaient tous les trois.
       Un appui sur un bouton, un lien ou un champ n'arme donc plus rien. */
    if (cible.closest('button, a[href], input, select, textarea, [role="button"]')) return false;

    /* ★ LOT I · LE VOILE N'ARME AUCUN GESTE A LA SOURIS, ET C'EST CE QUI
       REND SA FERMETURE
       ──────────────────────────────────────────────────────────────────────
       RAPH, 03/09 A 16 h, ORDINATEUR : « il faut que le panier se ferme avec le
       meme effet d'ouverture/fermeture quand on clique en dehors ».

       LA SONDE DIT PIRE QUE CA (`v13i-mesure.log`, 1440 x 900) : un clic NET
       sur le voile ne fermait RIEN du tout. La croix et Echap fermaient bien,
       avec leur transition de `transform` de 150 ms ; le voile, lui, rendait
       `ferme=false` et zero transition.

       LA CAUSE EST LA CAPTURE DE POINTEUR, ET C'EST EXACTEMENT LE DEFAUT DEJA
       CORRIGE SUR LA CROIX A LA VAGUE 1 (voir la note juste au-dessus). Un
       appui sur le voile armait le geste, donc posait `setPointerCapture` sur
       le PANNEAU ; or la capture DEPLACE LA CIBLE DU `click`, qui etait donc
       dispatche sur le panneau et non sur le voile. Le test
       `t.closest('[data-cmk-veil]')` de l'ecouteur de clic ne trouvait plus
       rien, et personne n'appelait `ferme()`.

       ET UN SECOND PIEGE ATTENDAIT DERRIERE : des que la souris derive de plus
       de 6 px entre l'appui et le relachement - ce que fait une main - `bouge`
       passe a vrai, et l'ecouteur de clic refuse alors de fermer pour ne pas
       prendre un glissement annule pour un tap.

       LA CORRECTION EST DE NE PAS ARMER DU TOUT. Glisser le VOILE pour fermer
       est un geste de DOIGT : au doigt, la feuille suit la main et c'est la
       moitie de l'affordance d'une feuille basse. A la souris, ce geste
       n'existe pas - on clique a cote, c'est tout. Le voile ne devient donc une
       poignee que pour le doigt et le stylet. La poignee de tete
       (`[data-cmk-grab]`), elle, ne change pas : rien n'y est cliquable, sa
       capture ne vole donc aucun clic.

       CE QUE CELA REND, MESURE : le clic dehors repasse par `ferme()`, donc par
       la MEME transition de 150 ms que la croix, Echap et le geste. Les quatre
       chemins n'en font plus qu'un. */
    var surVoile = !!cible.closest('[data-cmk-veil]');
    if (surVoile && type === 'mouse') return false;
    /* ★ LOT I · ET LA RANGEE N'ARME RIEN NON PLUS A LA SOURIS. Le lot I y pose
       un glisser-deposer horizontal (§ « la rangee a la souris ») ; sur
       ordinateur, l'axe de la feuille est LUI AUSSI horizontal. Sans cette
       ligne, tirer la rangee vers la droite ferait partir le TIROIR. Au doigt
       rien ne change : l'axe de la feuille y est vertical, un glissement de
       rangee ne l'a jamais concerne, et une descente partie d'une carte doit
       continuer a pouvoir refermer la feuille. */
    if (type === 'mouse' && cible.closest('[data-cmk-off-r]')) return false;
    var surPoignee = !!cible.closest('[data-cmk-grab]') || surVoile;
    var scroller = corps();
    var surCorps = !surPoignee && scroller && scroller.contains(cible);
    if (!surPoignee && !surCorps) return false;
    if (surCorps && scroller.scrollTop > 0) return false;

    glisse = true;
    arme = surPoignee;
    idPointeur = id;
    d0 = coord(x, y);
    t0 = t;
    trace.length = 0;
    echantillon(d0, t);
    if (surPoignee) {
      gesteArme();
      if (capture && sheet()) {
        try {
          sheet().setPointerCapture(id);
        } catch (e) {
          /* capture refusee : le geste marche quand meme */
        }
      }
    }
    return true;
  }

  function decide(x, y, capture) {
    if (!glisse) return false;
    if (arme) return true;
    var dd = coord(x, y) - d0;
    /* Depuis le corps, on n'accapare le geste qu'une fois le seuil de tap
       franchi ET seulement dans le sens de la fermeture. */
    if (dd <= DRAG_SLOP) {
      if (dd < -DRAG_SLOP) glisse = false;
      return false;
    }
    var scroller = corps();
    if (scroller && scroller.scrollTop > 0) {
      glisse = false;
      return false;
    }
    arme = true;
    gesteArme();
    if (capture && sheet()) {
      try {
        sheet().setPointerCapture(idPointeur);
      } catch (e) {
        /* idem */
      }
    }
    return true;
  }

  function pas(x, y, t, capture) {
    if (!decide(x, y, capture)) return false;
    var dd = coord(x, y) - d0;
    if (Math.abs(dd) > DRAG_SLOP) bouge = true;
    echantillon(coord(x, y), t);
    gesteBouge(decalage(dd));
    return true;
  }

  function fin(x, y, t, fermer) {
    if (!glisse) return;
    var etaitArme = arme;
    glisse = false;
    arme = false;
    try {
      if (idPointeur !== null && sheet()) sheet().releasePointerCapture(idPointeur);
    } catch (e) {
      /* deja relache */
    }
    idPointeur = null;
    /* Le retour elastique EST le retrait de la propriete : la transition du
       panneau reprend dans la meme image et ramene le `transform` a zero. */
    gesteRepose();
    if (!etaitArme || !fermer) {
      trace.length = 0;
      return;
    }
    var dd = coord(x, y) - d0;
    var v = vitesse(coord(x, y), t);
    trace.length = 0;
    if (dd > 0 && (dd >= DRAG_DISTANCE || Math.abs(v) > DRAG_VELOCITY)) ferme();
  }

  function abandonne() {
    if (!glisse) return;
    glisse = false;
    arme = false;
    idPointeur = null;
    trace.length = 0;
    gesteRepose();
  }

  /* ── Le chemin du doigt ─────────────────────────────────────────────────
     Il est prioritaire sur celui du pointeur : c'est le seul qui peut dire
     non au defilement natif. `touchstart` en capture pour etre servi avant
     tout ecouteur de la page, `touchmove` NON PASSIF pour avoir le droit
     d'appeler `preventDefault()`.

     DEUX DOIGTS NE GLISSENT PAS UNE FEUILLE : c'est un pincement, et il
     appartient au navigateur (le zoom de page reste possible, regle
     d'accessibilite). */
  document.addEventListener(
    'touchstart',
    function (event) {
      if (event.touches.length > 1) {
        abandonne();
        return;
      }
      var t = event.touches[0];
      debut(event.target, t.clientX, t.clientY, event.timeStamp, 'touch', false, 'touch');
    },
    true
  );

  document.addEventListener(
    'touchmove',
    function (event) {
      if (!glisse) return;
      if (event.touches.length > 1) {
        abandonne();
        return;
      }
      var t = event.touches[0];
      if (!pas(t.clientX, t.clientY, event.timeStamp, false)) return;
      /* C'est ICI, et nulle part ailleurs, que le defilement natif et le
         rebond elastique de WebKit sont arretes. */
      if (event.cancelable) event.preventDefault();
    },
    { passive: false, capture: true }
  );

  document.addEventListener(
    'touchend',
    function (event) {
      if (!glisse) return;
      var t = event.changedTouches[0];
      fin(t ? t.clientX : 0, t ? t.clientY : d0, event.timeStamp, true);
    },
    true
  );

  document.addEventListener('touchcancel', abandonne, true);

  /* ── Le chemin du pointeur ──────────────────────────────────────────────
     Il reste pour la souris et le stylet. Quand le doigt a deja pris le geste
     en charge, `debut` rend `true` sans rien refaire et `pas` est idempotent :
     les deux chemins ne peuvent pas deplacer la feuille deux fois.

     `pointercancel` NE DECIDE RIEN : une annulation de WebKit pourrait sinon
     fermer une feuille que le visiteur n'a pas lachee. */
  document.addEventListener(
    'pointerdown',
    function (event) {
      if (event.pointerType === 'touch' && glisse) return;
      debut(event.target, event.clientX, event.clientY, event.timeStamp, event.pointerId, true, event.pointerType);
    },
    true
  );

  document.addEventListener('pointermove', function (event) {
    if (!glisse || event.pointerId !== idPointeur) return;
    pas(event.clientX, event.clientY, event.timeStamp, true);
  });

  function finPointeur(event) {
    if (!glisse) return;
    fin(event.clientX, event.clientY, event.timeStamp, event.type === 'pointerup');
  }

  document.addEventListener('pointerup', finPointeur);
  document.addEventListener('pointercancel', finPointeur);

  /* ══════════════════════════════════════════════════════════════════════
     § 3. LE RENDU
     ----------------------------------------------------------------------
     Une seule source : `/cart.js`. Le balisage produit ici est celui de
     `snippets/casemira-cart-ligne.liquid` et de `casemira-cart-pied.liquid`,
     classe pour classe : Liquid peint la premiere image, ce code peint les
     suivantes.

     LA VIGNETTE EST LA VUE A PLAT, et `/cart.js` ne la connait pas : il ne
     rend que l'image de la variante. Trois sources, dans cet ordre :
       1. l'image DEJA peinte pour cette ligne (Liquid l'a choisie, ou une
          passe precedente) ;
       2. celle que le clic d'ajout a donnee (§ 5) ;
       3. l'image de la variante, remplacee des que `/products/<h>.js` a
          repondu (une requete par produit inconnu, jamais bloquante).
     ══════════════════════════════════════════════════════════════════════ */

  var platParHandle = {};
  var platEnCours = {};

  /* ── LA PHOTO DEJA DECODEE, VAGUE 13 LOT F (03/09) ─────────────────────
     `CHRONO-V13.md` § 4, capture a 900 ms : « la vignette de la ligne est
     devenue un rectangle gris vide ». La ligne provisoire du § 5 peint la photo
     que le visiteur REGARDE, donc deja decodee, donc gratuite ; puis `rendu()`
     la remplacait par `item.image` (l'image de la VARIANTE, 31,5 Ko, arrivee a
     1 259 ms), avant que `chercheLaFiche` ne pose enfin la vue a plat.

     Trois images pour une vignette, dont une seule est la bonne. On garde donc
     l'adresse peinte au clic, et `ligneHTML` s'en sert TANT QUE la vue a plat
     n'est pas connue. L'etat stable ne change pas d'un pixel : des que
     `/products/<handle>.js` a repondu, `platParHandle` reprend la main et la
     vignette est exactement celle que Liquid aurait rendue. */
  var platClic = {};

  /* L'ELIGIBILITE A L'OFFRE DUO, PAR HANDLE. Elle est semee par Liquid (le
     bloc d'offre ecrit un dictionnaire handle -> booleen pour tout ce qui est
     deja au panier) et complete par `/products/<handle>.js` pour ce qui
     arrive ensuite. C'est la MEME requete que celle de la vue a plat : un
     produit inconnu coute une requete, pas deux. */
  var eligibleParHandle = {};

  function memoriseLesPlats() {
    $$('[data-cmk-line]').forEach(function (l) {
      var h = l.getAttribute('data-cmk-handle');
      var img = $('img', l);
      if (h && img && img.getAttribute('src')) platParHandle[h] = img.getAttribute('src');
    });
  }

  /* LES DEUX EXCLUSIONS, LUES DANS `/products/<handle>.js`, et ce sont les
     memes que celles du pipeline de complements du dashboard
     (`eligibleOffre`) et celles de la collection `duo-eligibles` qui porte la
     remise :
       promotion   `compare_at_price_max > 0` ;
       echantillon SKU commencant par « Sample » (signal de tete, VAGUE i18n
                   R1c), avec le titre « Échantillon » et le handle
                   `echantillon-` conserves en repli francais (releve du 02/09 :
                   127 fiches DEDIEES, les memes des trois cotes).

     ═══ VAGUE 11 (02/09) : LE FAIT MAIN ET LE SUR MESURE SONT SORTIS ═══════

     Points 10 et 13 de la revue de Raph du 01/09 : « si quelqu'un prend 2
     tapis carpet decor fait main il doit avoir aussi la remise -20 % », et
     pour le sur mesure « meme comportement que tous les autres produits ». Le
     tag « Fait Main », le tag `forme:Couloir` et les options « Largeur » /
     « Longueur » ne rejettent donc plus rien ICI. `surMesureDe`, lui, ne
     bouge pas : il ne parle pas de l'offre, il ecrit la mention « coupe sur
     mesure » sur la ligne, qui decrit le produit. */
  function ficheEligible(p) {
    /* 23/10/2026 : une carte cadeau n'est pas un tapis. `/products/<h>.js` ne
       porte pas de drapeau carte cadeau : on lit le tag (non traduit). */
    if ((p.tags || []).indexOf('carte-cadeau') !== -1) return false;
    if ((p.compare_at_price_max || 0) > 0) return false;
    if (estEchantillonFiche(p)) return false;
    return true;
  }

  /* ── VAGUE i18n R1c (04/09) : LE SKU EST LE SEUL SIGNAL NON TRADUIT ────
     Le titre du produit ET son handle sont tous deux traduits par Shopify :
     en `/en` le titre devient « ... Rug Sample - Hudson » et le handle
     `ivory-black-100-wool-rug-sample-hudson`, en `/de` « Teppichmuster ... ».
     Les deux signaux historiques cassaient donc EN SILENCE hors du francais :
     l'echantillon redevenait un tapis eligible et l'offre duo s'appliquait a
     tort. Le SKU, lui, n'est pas un champ traduisible : releve API Admin du
     04/09, les 127 fiches de `echantillons-decor` portent une variante unique
     dont le SKU commence par « Sample », et aucun des 1 085 produits de la
     boutique ne porte ce jeton ailleurs. Meme correction que les sept tests
     Liquid de `casemira-cart-offre.liquid` et `-offre-rangee.liquid`.

     Le SKU ne vit pas au meme endroit selon la source : `/cart.js` le pose
     sur la ligne (`item.sku`), `/products/<h>.js` sur la variante
     (`variants[0].sku` ; les 127 fiches n'en ont qu'une). Le titre et le
     handle restent en repli : si l'usine change un SKU fournisseur, le
     francais continue de reconnaitre l'echantillon. La propriete de ligne
     `_sample`, posee par `sample-button.liquid`, est testee par
     `estEchantillonLigne` et ne se traduit pas non plus. */
  function skuDe(p) {
    if (p.sku) return String(p.sku);
    var v = p.variants;
    if (v && v.length && v[0] && v[0].sku) return String(v[0].sku);
    return '';
  }

  function estEchantillonFiche(p) {
    if (!p) return false;
    if (skuDe(p).indexOf('Sample') === 0) return true;
    var titre = String(p.title || p.product_title || '');
    if (titre.indexOf('\u00c9chantillon') === 0) return true;
    if (String(p.handle || '').indexOf('echantillon-') === 0) return true;
    return false;
  }

  function estEchantillonLigne(it) {
    if (!it) return false;
    if (it.properties && it.properties._sample === 'true') return true;
    return estEchantillonFiche(it);
  }

  /* ★ LOT I · LA LARGEUR EST IMPOSEE, PLUS SEULEMENT AJOUTEE.
     Cette fonction rendait l'adresse INTACTE des qu'elle portait deja un
     `width`. C'etait sans consequence tant que les seules adresses qui en
     portaient un venaient du rendu du panier (`width=320` deja) ; le lot I
     donne a la graine une adresse prise dans la GALERIE de la fiche, qui porte
     `width=1946`. La laisser telle quelle ferait telecharger une image de
     1946 px pour une vignette de 104, et surtout ce ne serait PAS la meme
     adresse que celle du rendu reel : l'echange que Raph voit serait toujours
     la, avec une image lourde en plus. La largeur est donc REECRITE. */
  function taille(url, w) {
    if (!url) return '';
    if (/[?&]width=\d+/.test(url)) return url.replace(/([?&]width=)\d+/, '$1' + w);
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }

  /* Le nom de fichier d'une adresse d'image, sans son hote ni sa requete : deux
     adresses qui le partagent designent la meme photo. */
  function fichierDe(u) {
    var sans = String(u || '').split('?')[0];
    var bouts = sans.split('/');
    return bouts[bouts.length - 1] || '';
  }

  function memeFichier(a, b) {
    var fa = fichierDe(a);
    return fa !== '' && fa === fichierDe(b);
  }

  function chercheLaFiche(handle) {
    if (!handle || platEnCours[handle]) return;
    if (platParHandle[handle] && eligibleParHandle[handle] !== undefined) return;
    platEnCours[handle] = true;
    fetch(RACINE + 'products/' + handle + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) {
        return r.json();
      })
      .then(function (p) {
        eligibleParHandle[handle] = ficheEligible(p);
        var images = p.images || [];
        var vc = null;
        for (var i = 0; i < images.length; i++) {
          if (/vue-complete/i.test(images[i])) {
            vc = images[i];
            break;
          }
        }
        var u = vc || images[1] || p.featured_image || images[0];
        if (u) {
          if (u.indexOf('//') === 0) u = 'https:' + u;
          /* ★ LOT I · LA MEME PHOTO NE SE RETELECHARGE PAS PARCE QU'ELLE ARRIVE
             PAR UN AUTRE HOTE.
             ──────────────────────────────────────────────────────────────
             DEFAUT TROUVE EN RECETTE, PREMIERE PASSE DU LOT I
             (`v13i-img.log`) : la ligne provisoire peignait, des 81 ms,
             `//casemira.com/cdn/shop/files/...-vue-complete-...&width=320` -
             exactement l'adresse que Liquid rend. A 878 ms, cette fonction la
             REMPLACAIT par
             `https://cdn.shopify.com/s/files/1/.../...-vue-complete-...&width=320`,
             parce que `/products/<h>.js` sert les images par le domaine du CDN
             et non par celui de la boutique. C'est LE MEME FICHIER, mais deux
             origines differentes : le navigateur retelecharge, et il peut
             peindre un vide entre les deux. Le lot I aurait supprime l'echange
             d'IMAGE en laissant un echange d'ADRESSE.

             ON COMPARE DONC LE NOM DE FICHIER, pas l'adresse. S'il est deja a
             l'ecran, on n'y touche pas, et c'est l'adresse DEJA PEINTE qui
             devient la reference du handle : tout le panier reste sur un seul
             hote, celui que Liquid a choisi. */
          var peinte = '';
          var vues = $$('[data-cmk-handle="' + handle + '"] img');
          if (vues.length) peinte = vues[0].getAttribute('src') || '';
          if (peinte && memeFichier(peinte, u)) {
            platParHandle[handle] = peinte;
          } else {
            platParHandle[handle] = u;
            vues.forEach(function (img) {
              img.src = taille(u, 320);
            });
          }
        }
        /* L'eligibilite vient d'arriver : l'offre peut avoir change d'avis. */
        if (dernierPanier) majOffre(dernierPanier);
      })
      .catch(function () {
        /* pas de fiche : la ligne garde l'image de la variante, et le produit
           reste hors offre. On ne promet jamais sur un doute. */
        eligibleParHandle[handle] = false;
        platEnCours[handle] = false;
      });
  }

  var SVG_SUP = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M4 4l16 16M20 4L4 20"/></svg>';

  function surMesureDe(item) {
    var p = item.properties || {};
    var vals = [];
    Object.keys(p).forEach(function (k) {
      if (k.charAt(0) !== '_' && p[k]) vals.push(String(p[k]).replace(/\./g, ','));
    });
    return vals;
  }

  /* « 3.00 m » devient « 3,00 m » : le point decimal anglais des longueurs de
     couloir etait un defaut de l'audit du 30/08. */
  function virgule(s) {
    return String(s).replace(/(\d)\.(\d)/g, '$1,$2');
  }

  /* 03/11/2026 carte cadeau : la ligne d'une carte dit a qui elle va et quand,
     avec les libelles de la fiche carte (casemira.gift_card.preview_*, passes
     par casemira-js-strings). Aucune virgule decimale, aucune pastille « coupe
     sur mesure », aucun « Modifier ». Meme rendu que `casemira-cart-ligne.liquid`
     (cc_txt). Ne sert qu'aux lignes `gift_card` : les tapis ne passent pas ici. */
  function carteHeure(v) {
    var h = parseInt(String(v).split(':')[0], 10);
    if (isNaN(h)) return String(v);
    var P = (window.FoxTheme && FoxTheme.casemira && FoxTheme.casemira.prix) || {};
    var loc = P.locale || 'fr';
    if (loc === 'fr') return h + ' h';
    if (loc === 'en') return h < 12 ? h + ' am' : (h === 12 ? '12 pm' : (h - 12) + ' pm');
    return String(v);
  }

  function carteDate(v) {
    var m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(String(v));
    if (!m) return String(v);
    var parts = String(S.carteDateIntl || '').split('|');
    try {
      return new Intl.DateTimeFormat(parts[0] || document.documentElement.lang || 'fr', {
        day: parts[1] || 'numeric', month: parts[2] || 'short', year: 'numeric'
      }).format(new Date(+m[1], +m[2] - 1, +m[3]));
    } catch (e) {
      return String(v);
    }
  }

  /* Les gabarits arrivent par `| t | json` et peuvent porter une entite
     (« Invio all&#39;ordine ») : on la ramene au caractere avant `esc`, pour
     n'echapper qu'une fois. */
  function carteGabarit(g, repli) {
    return String(g || repli).replace(/&#39;/g, "'").replace(/&quot;/g, '"').replace(/&amp;/g, '&');
  }

  function carteMeta(item) {
    var p = item.properties || {};
    var nom = String(p['Recipient name'] || '').trim();
    var mail = String(p['Recipient email'] || '').trim();
    var msg = String(p['Message'] || '').trim();
    var date = String(p['Send on'] || '').trim();
    var heure = String(p["_Heure d'envoi"] || '').trim();
    var bouts = [];
    if (nom) bouts.push(avec(carteGabarit(S.cartePour, 'Pour [n]'), 'n', nom));
    if (mail) bouts.push(mail);
    if (msg) bouts.push(msg);
    if (mail) {
      if (date) {
        var d = carteDate(date);
        bouts.push(heure
          ? avec(avec(carteGabarit(S.carteEnvoiLeHeure, 'Envoi le [d], dès [h]'), 'd', d), 'h', carteHeure(heure))
          : avec(carteGabarit(S.carteEnvoiLe, 'Envoi le [d]'), 'd', d));
      } else {
        bouts.push(carteGabarit(S.carteEnvoiNow, 'Envoi dès la commande'));
      }
    }
    return esc(bouts.join(' · '));
  }

  function ligneHTML(item, index) {
    var estEchantillon = item.properties && item.properties._sample === 'true';
    var estCarte = !!item.gift_card; /* 03/11/2026 carte cadeau */
    var sur = estCarte ? [] : surMesureDe(item);
    /* Deux signaux pour la coupe sur mesure : les proprietes de ligne (le
       configurateur), et le TYPE de produit « Tapis > Couloir » (le Torino,
       dont les longueurs sont de vraies variantes). Voir la note du snippet
       `casemira-cart-ligne.liquid`. */
    var surMesure = !estCarte && (sur.length > 0 || /couloir/i.test(item.product_type || ''));
    var modifiable = !estCarte && !estEchantillon && !sur.length && item.product_has_only_default_variant === false;
    var carteTxt = estCarte ? carteMeta(item) : ''; /* 03/11/2026 carte cadeau */
    var src = item.gift_card ? (item.image || '') : (platParHandle[item.handle] || platClic[item.handle] || item.image || ''); /* 01/11/2026 : une carte cadeau garde l'image de sa variante (son style), jamais la vue a plat */
    if (!estEchantillon && !item.gift_card) chercheLaFiche(item.handle);
    var remise = (item.original_line_price || 0) - (item.final_line_price || 0);
    var pct = remise > 0 ? Math.round((remise * 100) / item.original_line_price) : 0;

    var meta = '';
    if (estEchantillon) {
      meta = esc(S.ligneEchantillon || 'Échantillon, montant déduit à l’achat de votre tapis');
    } else if (carteTxt) {
      meta = carteTxt;
    } else if (sur.length) {
      meta = esc(sur.join(' · '));
    } else if (item.product_has_only_default_variant === false) {
      meta = esc(virgule(String(item.variant_title || '').replace(/ x /, ' × ').replace(' / ', ' · ')));
    }
    if (!estEchantillon && surMesure) {
      meta += '<span class="cmk__sur">' + esc(S.ligneSurMesure || 'coupe sur mesure') + '</span>';
    }
    var modLib = esc(S.ligneModifier || 'Modifier');
    if (modifiable) {
      meta += (meta ? ' · ' : '') +
        '<button type="button" class="cmk__mod" data-cmk-mod aria-expanded="false">' + modLib + '</button>';
    } else if (sur.length && item.handle !== 'antiderapant-cousu-berbere') {
      /* 02/11/2026 : l'antidérapant cousu des berbères n'a pas de fiche où « Modifier » (casemira-cart-antiderapant.js). */
      meta += ' · <a class="cmk__mod" href="' + esc(item.url) + '">' + modLib + '</a>';
    }
    if (pct > 0) meta += '<span class="cmk__tag">-' + pct + '&nbsp;%</span>';

    return (
      '<div class="cmk__line" data-cmk-line="' + index + '"' +
      ' data-cmk-key="' + esc(item.key) + '"' +
      ' data-cmk-variant="' + item.id + '"' +
      ' data-cmk-handle="' + esc(item.handle) + '"' +
      ' data-cmk-qty="' + item.quantity + '"' +
      (modifiable ? ' data-cmk-modifiable' : '') + '>' +
      (src
        ? '<a href="' + esc(item.url) + '" class="cmk__vign-l" aria-label="' +
          esc(avec(S.ligneVoirFiche || 'Voir la fiche de [produit]', 'produit', item.product_title)) + '">' +
          /* ★ LOT L · NI `lazy`, NI DECODAGE DIFFERE, ET L'ASYMETRIE AVEC
             LIQUID EST VOULUE. Liquid rend ses lignes dans un tiroir FERME,
             hors du cadre : `loading="lazy"` y evite de payer les vignettes
             d'un panier que le visiteur n'ouvrira peut-etre jamais. Le script,
             lui, ne rend JAMAIS que dans un tiroir DEJA OUVERT ou sur la page
             /cart : la vignette est a l'ecran a l'instant meme ou elle est
             ecrite, et `lazy` n'y coute qu'une image d'attente de plus.
             `decoding="sync"` demande au navigateur de decoder AVANT de
             presenter : c'est l'attribut qui interdit la case vide d'une
             image pourtant deja en cache. */
          '<img class="cmk__vign" src="' + esc(taille(src, 320)) + '" alt="" width="320" height="427" decoding="sync"' + (estCarte ? ' style="object-fit: contain"' : '') + '></a>'
        : '<span class="cmk__vign" aria-hidden="true"></span>') +
      '<div class="cmk__col">' +
      '<p class="cmk__name">' + esc(item.product_title) + '</p>' +
      '<p class="cmk__meta">' + meta + '</p>' +
      '<div class="cmk__fmt" data-cmk-fmt hidden></div>' +
      '<div class="cmk__bas">' +
      '<div class="cmk__qte" data-cmk-qte>' +
      '<button type="button" data-cmk-minus aria-label="' +
      esc(avec(S.qteMoins || 'Diminuer la quantité pour [produit]', 'produit', item.product_title)) +
      '">&minus;</button>' +
      '<span data-cmk-qty-val>' + item.quantity + '</span>' +
      '<button type="button" data-cmk-plus aria-label="' +
      esc(avec(S.qtePlus || 'Augmenter la quantité pour [produit]', 'produit', item.product_title)) +
      '">+</button>' +
      '</div>' +
      '<div class="cmk__prix">' +
      (remise > 0 ? '<s>' + eur(item.original_line_price) + '</s>' : '') +
      eur(item.final_line_price) +
      '</div>' +
      '</div></div>' +
      '<button type="button" class="cmk__sup" data-cmk-sup aria-label="' +
      esc(avec(S.ligneRetirer || 'Retirer [produit]', 'produit', item.product_title)) + '">' +
      SVG_SUP +
      '</button>' +
      '</div>'
    );
  }

  /* ── LE PACK D'ECHANTILLONS ───────────────────────────────────────────
     Meme balisage que `snippets/casemira-cart-pack.liquid`, classe pour
     classe. LE PRIX EST CELUI DU PANIER : la somme des `final_line_price`
     des lignes d'echantillon, barree de la somme des `original_line_price`
     quand une remise automatique s'applique. L'ancien tiroir ecrivait
     « 15,00 € » et « 20,00 € » en clair dans son affichage.

     Les rangees portent `data-cmk-line` et `data-cmk-key` : la suppression et
     « Annuler » de la vague 1 les servent sans une ligne de plus. */
  /* Le mot « Échantillon » retire du nom de la rangee est un PREFIXE DE TITRE
     PRODUIT, donc une donnee traduite par Shopify, pas une chaine d'interface :
     le retirer en dur laissait le prefixe colle au nom en /en. Il vient de la
     locale, la MEME cle que `casemira-cart-pack.liquid` appelle en `| t`
     (§ 5 de CONVENTION.md, une cle et deux consommateurs), avec le repli
     francais code. `replace` sur une chaine retire la PREMIERE occurrence, ou
     qu'elle soit : c'est exactement `remove_first` du Liquid, et cela couvre le
     francais, ou le mot est en tete, comme l'anglais, ou il est au milieu. */
  var MOT_ECH = S.echantillonMot || '\u00c9chantillon';

  function sansMotEchantillon(titre) {
    return String(titre || '').replace(MOT_ECH + ' ', '');
  }

  function packHTML(echs) {
    var n = 0;
    var brut = 0;
    var net = 0;
    echs.forEach(function (it) {
      n += it.quantity;
      brut += it.original_line_price || 0;
      net += it.final_line_price || 0;
    });
    return (
      '<div class="cmk__pack" data-cmk-pack>' +
      '<p class="cmk__pack-t"><b>' + esc(S.packTitre || 'Pack d\u2019\u00e9chantillons') + '</b>' +
      '<span>' + esc(S.packDetail || 'd\u00e9duits \u00e0 l\u2019achat de votre tapis') + '</span></p>' +
      '<div class="cmk__pack-l">' +
      echs
        .map(function (it, i) {
          var src = it.image || '';
          return (
            '<div class="cmk__pack-r" data-cmk-line="e' + (i + 1) + '"' +
            ' data-cmk-key="' + esc(it.key) + '"' +
            ' data-cmk-variant="' + it.id + '"' +
            ' data-cmk-handle="' + esc(it.handle) + '"' +
            ' data-cmk-qty="' + it.quantity + '">' +
            (src
              ? '<img class="cmk__pack-i" src="' + esc(taille(src, 96)) + '" alt="" width="96" height="96" loading="lazy">'
              : '<span class="cmk__pack-i" aria-hidden="true"></span>') +
            '<span class="cmk__name cmk__pack-n">' +
            esc(sansMotEchantillon(it.product_title)) +
            '</span>' +
            '<button type="button" class="cmk__pack-x" data-cmk-sup aria-label="' +
            esc(avec(S.ligneRetirer || 'Retirer [produit]', 'produit', it.product_title)) +
            '">' + SVG_SUP + '</button>' +
            '</div>'
          );
        })
        .join('') +
      '</div>' +
      '<p class="cmk__pack-f"><span>' +
      esc(avec(S.packNombre || '[n] \u00e9chantillons', 'n', n)) + '</span><b>' +
      (brut > net ? '<s>' + eur(brut) + '</s> ' : '') + eur(net) +
      '</b></p></div>'
    );
  }

  /* Les tapis d'abord, le pack ensuite : le meme ordre que
     `snippets/casemira-cart-lignes.liquid`. */
  /* 02/11/2026 · la sous-couche antidérapante cousue des berbères se place juste
     SOUS son tapis (propriété `_Pour le tapis` = SKU du tapis), quel que soit
     l'ordre d'ajout de Shopify (le dernier ajouté en premier). Décision Raphaël. */
  function ordonneLiees(items) {
    var AD = 'antiderapant-cousu-berbere', reste = [], liees = [];
    items.forEach(function (it) {
      var sku = it.handle === AD && it.properties && it.properties['_Pour le tapis'];
      (sku ? liees : reste).push(it);
    });
    if (!liees.length) return items;
    var out = [];
    reste.forEach(function (it) {
      out.push(it);
      liees = liees.filter(function (ad) {
        if (ad.properties['_Pour le tapis'] !== it.sku) return true;
        out.push(ad); return false;
      });
    });
    return out.concat(liees); /* une sous-couche sans tapis : en fin, le temps que casemira-cart-antiderapant.js la retire */
  }
  function lignesHTML(cart) {
    var echs = (cart.items || []).filter(function (it) {
      return it.properties && it.properties._sample === 'true';
    });
    var grouper = echs.length >= 2;
    var out = '';
    var rang = 0;
    ordonneLiees(cart.items || []).forEach(function (it) {
      if (grouper && it.properties && it.properties._sample === 'true') return;
      rang += 1;
      out += ligneHTML(it, rang);
    });
    if (grouper) out += packHTML(echs);
    return out;
  }

  /* ══════════════════════════════════════════════════════════════════════
     § 3 bis. LE PIED, ET LE SEUL TOTAL                    vague 13, lot F, 03/09
     ----------------------------------------------------------------------
     RAPH, 03/09 A 01h08 : « quand tu ajoutes au panier sur mobile, le tiroir
     s'ouvre avec juste le tapis ajoute, et une demi-seconde apres le reste
     arrive. Est-ce que ca ne pourrait pas etre plus instantane ? »

     CE QUE LE CHRONOMETRE A MESURE (`CHRONO-V13.md`, § 2 et § 6.b) :
       · scenario 1, panier vide : le pied N'EXISTE PAS de 0 a 604 ms, parce que
         Liquid l'a rendu avec `hidden` (« LE PIED DISPARAIT EN ENTIER QUAND LE
         PANIER EST VIDE », `casemira-cart-pied.liquid`). Pas de total, pas de
         « Commander », pas de Klarna, et la feuille GRANDIT d'un coup a 604 ms ;
       · scenario 2, un tapis deja au panier : le client voit TROIS totaux,
         49,00 € puis 98,00 € pendant une seconde entiere, puis 88,20 €. Le faux
         tient plus longtemps que la demi-seconde dont parle Raph.

     CE QUE CE BLOC FAIT, ET C'EST UNE SEULE IDEE : le pied s'ecrit a partir
     d'un OBJET PANIER, quel qu'il soit. `rendu()` lui donne celui du serveur ;
     le § 5 lui donne, des le clic, un panier FICTIF qui porte deja le tapis
     qu'on ajoute. Un seul code, donc un seul resultat : quand la verite arrive,
     elle ecrase les memes chiffres avec les memes chiffres, sans animation et
     sans clignotement.

     ET LE TOTAL EST PROJETE, PAS SEULEMENT AVANCE. La remise duo n'est pas
     posee par le serveur au moment de l'ajout : elle arrive DEUX allers-retours
     plus tard (`POST /cart/update.js` puis `GET /cart.js`, 1 442 et 1 608 ms
     mesures). Afficher `total_price` a cet instant, c'est afficher 98,00 € pour
     un panier qui vaudra 88,20 €. `argentDuPanier()` applique donc la remise
     que le script s'apprete a demander, et il ne le fait QUE quand il comprend
     toutes les remises deja posees.
     ══════════════════════════════════════════════════════════════════════ */

  /* CE QUE LE PANIER VAUT, ET CE QU'IL VAUDRA.

       total    le montant a AFFICHER ;
       etat     l'etat de l'offre pour ce panier (§ 7) ;
       projete  vrai quand le total affiche n'est pas encore celui du serveur,
                parce que la remise duo n'est pas posee. C'est le seul cas ou
                une ligne « Remise duo » est ecrite sans que Shopify l'ait
                confirmee.

     LA GARDE, ET ELLE EST STRICTE : on ne projette QUE si la somme des remises
     du panier (`total_discount`) est exactement celle que la remise duo
     explique (`remiseSrv`). Un panier qui porte BIENVENUE10, une remise
     automatique d'echantillon ou quoi que ce soit d'autre n'est pas rejoue :
     on ne sait pas comment ce quelque chose reagira a un tapis de plus, et un
     chiffre invente vaut moins qu'un chiffre en retard. Dans ce cas le pied
     garde le comportement d'avant ce lot, au centime pres. */
  function argentDuPanier(cart) {
    /* La configuration de l'offre peut n'avoir jamais ete lue : `majPied` est
       le premier appel du rendu, et il precede `majOffre`. `litOffre` ne fait
       son travail qu'une fois. */
    litOffre();
    var etat = etatOffre(cart);
    var brut = typeof cart.original_total_price === 'number' ? cart.original_total_price : cart.total_price;
    var seuil = OFFRE && OFFRE.seuil ? OFFRE.seuil : 2;
    var meca = OFFRE && OFFRE.meca ? OFFRE.meca : 'article_n';
    /* DEUX CONDITIONS POUR SE PERMETTRE DE PROJETER. La premiere est que le
       panier porte bien son montant AVANT remise (tous les paniers de
       `/cart.js` le portent ; un objet partiel publie par un autre script,
       non). La seconde est que la somme des remises deja posees soit
       exactement celle que la remise duo explique : un panier qui porte
       BIENVENUE10, une remise automatique d'echantillon ou quoi que ce soit
       d'autre n'est pas rejoue, parce qu'on ne sait pas comment ce quelque
       chose reagira a un tapis de plus. */
    var comprend = typeof cart.original_total_price === 'number' && (cart.total_discount || 0) === etat.remiseSrv;
    var attendue = 0;
    if (OFFRE && meca === 'article_n' && offreOuverte() && etat.n >= seuil) attendue = etat.remise;
    if (comprend && attendue > etat.remiseSrv) {
      return { total: brut - attendue, etat: etat, projete: true, duo: attendue };
    }
    return { total: cart.total_price, etat: etat, projete: false, duo: 0 };
  }

  /* LA LIGNE « Remise duo », SANS UNE PHRASE DANS CE FICHIER. Le libelle
     traduit voyage en attribut depuis `casemira-cart-pied.liquid` (lot F) :
     avant lui, ces deux mots etaient ecrits en dur ici. S'il manque, la ligne
     n'est pas ecrite du tout - le total, lui, reste juste. */
  function ligneDuo(codes, code, montant) {
    var libelle = codes.getAttribute('data-cmk-duo-label') || '';
    if (!libelle || montant <= 0) return '';
    return (
      '<p class="cmk__remise"' + (code ? ' data-cmk-applied="' + esc(code) + '"' : '') + ' data-cmk-duo>' +
      '<span>' + esc(libelle) + '</span><b>-' + eur(montant) + '</b></p>'
    );
  }

  /* Casemira 28/10/2026 (offre de novembre) · LA REMISE AUTOMATIQUE A SA LIGNE.
     Inventaire technique § 4.4, point 7 : la remise des paliers est une remise
     AUTOMATIQUE de commande (`cart_level_discount_applications`, `type:
     'automatic'`) ; sans cette ligne, le total baissait sans explication.
     Quand l'offre de novembre est active, le libellé est la clé traduite
     (`data-cmk-auto-g`, « %periode% : %montant% offerts ») avec la période du
     JOUR (`CM_OFFRE.periode`, libellés courts en `data-cmk-auto-<periode>`) et
     le montant que Shopify a réellement alloué ; jamais le titre Shopify.
     Hors offre, le titre Shopify : mieux vaut un nom que pas de ligne. */
  var MOINS = '\u2212';
  var ICONE_ETIQUETTE_REMISE =
    '<svg class="cmk__remise-icone" viewBox="0 0 24 24" width="15" height="15" aria-hidden="true" focusable="false">' +
    '<path d="M3.5 12.6V4.5a1 1 0 0 1 1-1h8.1l8 8a1.4 1.4 0 0 1 0 2l-7.1 7.1a1.4 1.4 0 0 1-2 0l-8-8z"/>' +
    '<circle cx="8.25" cy="8.25" r="1.4"/></svg>';

  function ligneAuto(codes, a, marque) {
    marque = marque || 'data-cmk-auto';
    var montant = (a && a.total_allocated_amount) || 0;
    if (montant <= 0) return '';
    var libelle = String(a.title || '');
    var g = codes.getAttribute('data-cmk-auto-g') || '';
    var O = window.CM_OFFRE;
    if (g && !(O && O.actif === false)) {
      var p = (O && O.periode) || codes.getAttribute('data-cmk-auto-repli') || 'socle';
      var nomP = codes.getAttribute('data-cmk-auto-' + p) || codes.getAttribute('data-cmk-auto-socle') || '';
      /* Avant-première : « Accès anticipé Black Week : −30 € ». */
      if (marque === 'data-cmk-acces' && nomP) nomP = ((codes.getAttribute('data-cmk-acces-badge') || '') + ' ' + nomP).trim();
      /* Lot R3-D : « Black Friday : −40 € », icône étiquette devant, montant
         précédé du signe moins et en gras (clé `ligne_remise`). */
      if (nomP) {
        return (
          '<p class="cmk__remise cmk__remise--auto" ' + marque + '>' +
          '<span>' + ICONE_ETIQUETTE_REMISE + '<span>' +
          jetonsHTML(g, { periode: nomP, montant: MOINS + prixCourt(montant).replace(/ /g, '\u00a0') }, { montant: true }) +
          '</span></span><b>-' + eur(montant) + '</b></p>'
        );
      }
    }
    return (
      '<p class="cmk__remise cmk__remise--auto" ' + marque + '>' +
      '<span>' + esc(libelle) + '</span><b>-' + eur(montant) + '</b></p>'
    );
  }

  /* ★ LOT H · L'ETIQUETTE DE LA CROIX, TRADUITE, OU RIEN. Le gabarit porte
     `%c%` a la place du code (`casemira.panier.code_retirer`). Sans gabarit, on
     ne rend AUCUN `aria-label` : un attribut absent laisse le lecteur d'ecran
     annoncer le contenu du bouton, un attribut francais en dur ment dans les
     trois autres langues de la boutique. */
  function etiquetteRetrait(codes, code) {
    var gabarit = codes.getAttribute('data-cmk-off-label') || '';
    if (!gabarit) return '';
    return ' aria-label="' + esc(gabarit.split('%c%').join(code)) + '"';
  }

  function majPied(cart) {
    if (!scene) return;
    var arg = argentDuPanier(cart);

    /* VAGUE 6 : L'ETAT VIDE N'EST PLUS ECRIT ICI, IL EST SEULEMENT MONTRE.
       Le script en fabriquait le balisage, avec deux phrases francaises en dur
       (« Votre panier est vide. », « Voir les tapis ») et une adresse de
       collection ecrite en clair. La regle i18n de la vague les interdit, et
       il y avait pire : il ne savait pas reconstruire la rangee de
       best-sellers, qu'aucune API de panier ne lui donne. Liquid rend donc le
       bloc une fois, en permanence, et le script ne fait que poser ou retirer
       son `hidden`. */
    var vide = $('[data-cmk-empty]', scene);
    if (vide) vide.hidden = !!cart.item_count;

    var cpt = $('[data-cmk-count]', scene);
    if (cpt) cpt.textContent = '(' + cart.item_count + ')';

    /* 03/11/2026 carte cadeau : panier fait uniquement de cartes = pas de
       « Satisfait ou remboursé, 30 jours » ni de date de livraison (même règle
       que `casemira-cart-pied.liquid`, pied_que_cartes). Un tapis dans le
       panier et la rangée revient, inchangée. */
    var calme = $('[data-cmk-calme]', scene);
    if (calme) {
      var lignesPied = cart.items || [];
      calme.hidden = lignesPied.length > 0 && lignesPied.every(function (it) { return !!it.gift_card; });
    }

    var tot = $('[data-cmk-total]', scene);
    if (tot) tot.textContent = eur(arg.total);
    var ctaTot = $('[data-cmk-cta-total]', scene);
    if (ctaTot) ctaTot.textContent = eur(arg.total);

    /* La pilule Klarna, aux bornes de la fiche produit. */
    var kl = $('[data-cmk-klarna]', scene);
    if (kl) {
      var ok = arg.total >= KL_MIN && arg.total <= KL_MAX;
      kl.hidden = !ok;
      if (ok) {
        var x = $('[data-cmk-klarna-x]', kl);
        if (x) x.textContent = klarnaMoney(Math.ceil(arg.total / 3)) + ' × 3';
      }
    }

    /* 17/09 · FRANCE : Klarna 3x et PayPal 4x sur la meme ligne. Les deux
       lignes ont ete RENDUES par Liquid, traduites ; ici on choisit laquelle
       se montre et on reecrit ses montants. Aucune phrase n'est ecrite dans ce
       fichier, exactement comme pour la date de livraison.

       Hors de France, `[data-cmk-pf]` n'existe pas : ce bloc ne fait rien, et
       c'est `[data-cmk-klarna]` ci-dessus qui travaille, sans un octet de
       difference avec la veille. Les deux ne coexistent jamais.

       `klarnaMoney` convient au quart comme au tiers : PayPal plafonne a
       3 000 EUR, le quart vaut donc au plus 750 EUR et ne porte jamais de
       separateur de milliers, la raison meme pour laquelle cette fonction
       existe. */
    var pf = $('[data-cmk-pf]', scene);
    if (pf) {
      var pfSeul = $('[data-cmk-pf-seul]', scene);
      var okK = arg.total >= KL_MIN && arg.total <= KL_MAX;
      var okP = arg.total >= PP_MIN && arg.total <= PP_MAX;
      pf.hidden = !(okK && okP);
      if (pfSeul) pfSeul.hidden = !(!okK && okP);
      if (okK && okP) {
        var xk = $('[data-cmk-pf-k]', pf);
        if (xk) xk.textContent = klarnaMoney(Math.ceil(arg.total / 3));
        var xp = $('[data-cmk-pf-p]', pf);
        if (xp) xp.textContent = klarnaMoney(Math.ceil(arg.total / 4));
      } else if (okP && pfSeul) {
        var xp2 = $('[data-cmk-pf-p]', pfSeul);
        if (xp2) xp2.textContent = klarnaMoney(Math.ceil(arg.total / 4));
      }
    }

    /* Les codes appliques, en ligne. */
    var codes = $('[data-cmk-codes]', scene);
    if (codes) {
      var appliques = (cart.discount_codes || []).filter(function (d) {
        return d.applicable !== false;
      });
      var duo = codeDuo();
      var duoEcrit = false;
      var html = appliques
        .map(function (d) {
          var montant = montantDuCode(cart, d.code);
          /* LA REMISE DUO N'A PAS DE CROIX. Un code que le client n'a pas saisi
             ne se retire pas d'un clic : il reviendrait au rendu suivant. Elle
             ne s'affiche pas non plus tant qu'elle ne vaut rien, ce qui arrive
             quand un autre code la prive de son effet : le panier ne montre
             alors que ce qui est VRAI, sans une ligne pour expliquer une remise
             a zero. */
          /* Avant-première Black Week (SPEC-ACCES-ANTICIPE, 29/10) : le code
             posé par le thème pour le palier n'est pas un code du client. Il
             s'écrit comme la remise automatique (« Black Week : −30 € »), sans
             croix, sous sa propre marque pour que le repli des lignes
             automatiques ne le recopie pas. */
          if (estCodeAcces(d.code)) {
            return ligneAuto(codes, { title: d.code, total_allocated_amount: montant }, 'data-cmk-acces');
          }
          if (duo && d.code.toUpperCase() === duo) {
            /* LE CODE EST DEJA POSE MAIS SON MONTANT PEUT AVOIR VIEILLI : c'est
               le cas au clic d'un TROISIEME tapis, ou Shopify n'a pas encore
               recalcule. On ecrit alors le montant projete, une seule fois. */
            duoEcrit = true;
            return ligneDuo(codes, d.code, arg.projete ? arg.duo : montant);
          }
          /* ★ LOT H · LA LIGNE DU CODE EST LA MEME QUE CELLE DE LA REMISE DUO,
             a la croix pres, et son etiquette n'est plus ecrite ici. Voir la
             note de `casemira-cart-pied.liquid` : l'or appartient a NOTRE
             offre, pas a un code tape par le client, et « Retirer le code X »
             etait la derniere phrase francaise en dur de ce fichier. Le
             gabarit vient de la boutique, avec `%c%` pour le code ; s'il
             manque, la croix reste posee mais SANS etiquette inventee. */
          return (
            '<p class="cmk__remise cmk__remise--code" data-cmk-applied="' + esc(d.code) + '">' +
            '<span>' + esc(d.code) + '</span>' +
            '<b>-' + eur(montant) + '</b>' +
            '<button type="button" data-cmk-code-off="' + esc(d.code) + '"' +
            etiquetteRetrait(codes, d.code) + '>×</button></p>'
          );
        })
        .join('');
      /* LE TOTAL PROJETE S'EXPLIQUE, SINON IL SE LIT COMME UNE ERREUR. Quand le
         pied dit 88,20 € pour deux tapis a 49,00 €, la ligne qui dit ou sont
         passes les 9,80 € doit etre la au meme instant. Elle porte le meme
         balisage que celle du serveur ; quand Shopify confirme, la boucle
         ci-dessus la reecrit a l'identique. */
      if (arg.projete && !duoEcrit) html += ligneDuo(codes, duo, arg.duo);
      /* Casemira 28/10/2026 (offre de novembre) : les remises automatiques de
         commande, après les codes. `/cart/change.js` rend ce tableau VIDE
         (note de `remisesExpliquees`) : tant que le panier n'explique pas ses
         remises, la ligne déjà à l'écran est gardée, et la relecture de
         `/cart.js` qui suit (§ 3, `rendu`) la réécrit. */
      /* Nuit du 30/10 (test réel des remises) : Shopify rend la remise
         automatique « montant sur la commande » avec `type: ""` dans
         `/cart.js`, pas `automatic`. On garde donc tout ce qui n'est PAS un
         code (les codes ont leur ligne ci-dessus) et qui vaut quelque chose. */
      var codesPoses = appliques.map(function (d) { return String(d.code || '').toUpperCase(); });
      var autos = (cart.cart_level_discount_applications || [])
        .filter(function (a) {
          return a && a.type !== 'discount_code' && (a.total_allocated_amount || 0) > 0 &&
            codesPoses.indexOf(String(a.title || '').toUpperCase()) < 0;
        })
        .map(function (a) {
          return ligneAuto(codes, a);
        })
        .join('');
      if (!autos && !remisesExpliquees(cart)) {
        autos = $$('[data-cmk-auto]', codes)
          .map(function (el) {
            return el.outerHTML;
          })
          .join('');
      }
      html += autos;
      codes.innerHTML = html;
    }

    /* LE PIED SE MONTRE DES QU'IL Y A QUELQUE CHOSE A COMPTER, et c'est la
       reponse a la zone vide de 604 ms du scenario 1 : Liquid le rend `hidden`
       sur un panier vide, et rien ne le rallumait avant `cart-update`. */
    var pied = $('[data-cmk-foot]', scene);
    if (pied) pied.hidden = !cart.item_count;
  }

  /* ══════════════════════════════════════════════════════════════════════
     ★ LOT L (03/09, 23 h 05) · UNE VIGNETTE, UN SEUL NOEUD `<img>`
     ----------------------------------------------------------------------
     RAPH, SUR LE PUBLIE, AU TELEPHONE : « quand tu ajoutes au panier, l'image
     vient se mettre, puis elle se recharge, ca fait un effet de saut,
     bizarre. »

     CE QUE LA MESURE DIT (`c4-v13l-mesure.mjs`, iPhone 13 Pro, 4G bridee,
     fiche Sahel, panier vide ; releve `perf/v13l-mesure-avant-*.json`) :

       103 ms  ajout    <DIV> img#1  ...vue-complete-new...&width=320
       833 ms  ajout    <DIV> img#2  ...vue-complete-new...&width=320
       833 ms  retrait  <DIV> img#1  ...vue-complete-new...&width=320

     L'ADRESSE EST LA MEME, AU CARACTERE PRES - le lot I l'avait bien reglee -
     MAIS LE NOEUD N'EST PAS LE MEME. `rendu()` ecrit `lignes.innerHTML`, ce
     qui detruit la ligne provisoire et en fabrique une neuve. Un `<img>` qui
     vient de naitre n'a rien a peindre tant que son image n'est pas RATTACHEE
     et REDECODEE, meme quand le fichier est deja dans le cache : WebKit peint
     alors la boite vide (le fond `--cm-sand`) pendant une a deux images. C'est
     le blanc que Raph filme, et c'est pour cela que le controle du lot I, qui
     ne comparait que des ADRESSES, le declarait vert.

     LA REGLE POSEE ICI : de la ligne provisoire a l'etat stable, la vignette
     est LE MEME ELEMENT. On retient les images avant le remplacement, par leur
     adresse ; apres le remplacement, chaque image neuve dont l'adresse est
     deja tenue rend sa place a l'ancienne. Deplacer un `<img>` dans le
     document ne le fait ni recharger ni redecoder : il reste peint.

     ELLE VAUT POUR TOUS LES RENDUS, pas seulement pour l'ajout. Un changement
     de quantite, un code pose, une suppression annulee repassent tous par
     `rendu()` et faisaient clignoter toutes les vignettes du panier.

     LES ATTRIBUTS DU RENDU NEUF SONT REPORTES SUR LE NOEUD GARDE (`class`,
     `alt`, `width`, `height`, `loading`, `decoding`), et `src` SEUL ne l'est
     pas : c'est lui qui declencherait le rechargement qu'on supprime. L'etat
     d'arrivee est donc, attribut pour attribut, celui que Liquid aurait rendu.
     ══════════════════════════════════════════════════════════════════════ */
  var ATTR_VIGN = ['class', 'alt', 'width', 'height', 'loading', 'decoding'];

  function recolteLesVignettes(hote) {
    var pot = {};
    $$('img.cmk__vign', hote).forEach(function (im) {
      var a = im.getAttribute('src');
      if (a && !pot[a]) pot[a] = im;
    });
    return pot;
  }

  function replanteLesVignettes(hote, pot) {
    $$('img.cmk__vign', hote).forEach(function (neuve) {
      var a = neuve.getAttribute('src');
      var gardee = a ? pot[a] : null;
      if (!gardee || gardee === neuve || !neuve.parentNode) return;
      delete pot[a];
      ATTR_VIGN.forEach(function (n) {
        var v = neuve.getAttribute(n);
        if (v === null) gardee.removeAttribute(n);
        else gardee.setAttribute(n, v);
      });
      neuve.parentNode.replaceChild(gardee, neuve);
    });
  }

  /* ── LE TIROIR ROUVERT DIT LE PANIER DU MOMENT ──────────────────────────
     Correctif du 28/10, 17 h (retour de Raphaël : le tiroir rouvert par
     l'icône montrait un état « tel quel », différent de celui d'après un
     ajout). Le tiroir n'est jamais re-rendu par le serveur : il garde ce que
     `rendu()` a écrit en dernier. Deux chemins ordinaires le laissaient en
     retard sur le vrai panier : la page RESTAURÉE par le cache avant/arrière
     du navigateur (le geste de retour de Safari iOS : la page revient telle
     qu'on l'a quittée, panier compris, et `theme.js` ne corrige que le
     compteur de l'en-tête), et un panier changé dans un autre onglet.

     À chaque ouverture par l'icône, et à chaque page restaurée, `/cart.js`
     est relu UNE fois (lecture seule) ; le tiroir n'est réécrit que si le
     panier diffère de celui qu'il montre. `renduN` écarte une réponse
     arrivée après un autre rendu (un ajout fait entre-temps) : elle serait
     plus vieille que ce qui est à l'écran. */
  var renduN = 0;

  function signaturePanier(c) {
    if (!c) return '';
    return [
      c.item_count,
      c.total_price,
      (c.items || [])
        .map(function (it) {
          return it.key + 'x' + it.quantity;
        })
        .join(','),
      (c.discount_codes || [])
        .map(function (d) {
          return d.code;
        })
        .join(','),
    ].join('|');
  }

  function verifieLaFraicheur() {
    if (!scene || !dernierPanier) return;
    var n = renduN;
    panierFrais()
      .then(function (c) {
        if (n !== renduN || !c || typeof c.item_count !== 'number') return;
        if (signaturePanier(c) !== signaturePanier(dernierPanier)) rendu(c);
      })
      .catch(function () {
        /* hors ligne : le tiroir garde ce qu'il montre */
      });
  }

  window.addEventListener('pageshow', function (event) {
    if (event.persisted) verifieLaFraicheur();
  });

  function rendu(cart) {
    renduN++;
    dernierPanier = cart;
    panierLivraisonProvisoire = null;
    if (!scene) return;

    var lignes = $('[data-cmk-lines]', scene);
    if (lignes) {
      /* « ANNULER » SURVIT AU RENDU, ET C'EST UN DEFAUT TROUVE EN EXECUTION.
         Retirer un tapis fait tomber le panier sous le seuil de l'offre ; le
         thème retire alors le code duo, ce qui declenche un SECOND rendu, une
         demi-seconde apres le premier. Sans cette precaution, ce second rendu
         effacait la ligne « Annuler » que le premier venait de poser : le
         client avait trois secondes pour revenir en arriere, et elles lui
         etaient reprises au bout d'une. Le noeud est detache puis remis a sa
         place ; son ecouteur de clic et son minuteur voyagent avec lui. */
      var undo = $('[data-cmk-undo]', lignes);
      var rangUndo = undo ? Array.prototype.indexOf.call(lignes.children, undo) : -1;
      /* ★ LOT L : les vignettes deja peintes sont retenues AVANT le
         remplacement, et rendues a leur place APRES. Voir la note ci-dessus. */
      var pot = recolteLesVignettes(lignes);
      lignes.innerHTML = cart.item_count ? lignesHTML(cart) : '';
      replanteLesVignettes(lignes, pot);
      if (undo) lignes.insertBefore(undo, lignes.children[rangUndo] || null);
    }

    majPied(cart);

    publier(cart);
    dateLivraison();
    majOffre(cart);
    majAttributAB(cart);

    /* ★ LOT I · LA RELECTURE D'UN PANIER INCOMPLET, UNE FOIS ET PAS DEUX.
       Voir la note de `remisesExpliquees` : `/cart/change.js` rend un panier
       dont les remises de niveau COMMANDE sont amputees, et le pied y ecrivait
       « -0,00 € » en face du code du client. Le drapeau interdit la boucle :
       `/cart.js`, lui, explique toujours ses remises, donc la relecture ne peut
       en declencher une seconde. Si le reseau la refuse, on garde ce qui est a
       l'ecran - le TOTAL, lui, est juste dans les deux cas. */
    if (!remisesExpliquees(cart) && !relitLesRemises) {
      relitLesRemises = true;
      panierFrais()
        .then(function (c) {
          relitLesRemises = false;
          rendu(c);
        })
        .catch(function () {
          relitLesRemises = false;
        });
    }
  }

  var relitLesRemises = false;

  /* `rafraichis()` NE REJETTE JAMAIS, et c'est un defaut trouve en execution.
     Trois appels le lancaient sans filet (le bus `cart:refresh`, le filet de
     l'ajout optimiste, et l'echec d'ajout) : une coupure reseau y devenait une
     « Unhandled Promise Rejection » dans la console, relevee en WebKit. Le
     filet est pose ICI plutot qu'a chaque appel : un panier qu'on ne peut pas
     relire garde ce qu'il affiche, il ne se vide pas et il ne crie pas. */
  function rafraichis() {
    return panierFrais()
      .then(function (c) {
        rendu(c);
        return c;
      })
      .catch(function () {
        return dernierPanier;
      });
  }

  /* ══════════════════════════════════════════════════════════════════════
     § 4. LES ACTIONS
     ══════════════════════════════════════════════════════════════════════ */

  var occupe = false;

  function change(key, qte) {
    if (occupe) return Promise.resolve();
    occupe = true;
    if (scene) scene.setAttribute('data-cmk-busy', '');
    return post(RACINE + 'cart/change.js', { id: key, quantity: qte })
      .then(function (c) {
        rendu(c);
        return c;
      })
      .catch(function () {
        return rafraichis();
      })
      .finally(function () {
        occupe = false;
        if (scene) scene.removeAttribute('data-cmk-busy');
      });
  }

  /* ── La suppression, avec « Annuler » pendant trois secondes ────────────
     La ligne d'annulation prend LA PLACE de la ligne retiree : rien ne remonte
     tant que le delai court, et un clic sur « Annuler » repose l'article.
     Shopify ne sait pas ressusciter une ligne : « Annuler » la RAJOUTE, avec
     sa quantite et ses proprietes. Son rang peut donc changer, et c'est le
     seul effet visible. */
  var undoTimer = null;

  function supprime(ligne) {
    var key = ligne.getAttribute('data-cmk-key');
    var item = null;
    if (dernierPanier) {
      item = (dernierPanier.items || []).filter(function (i) {
        return i.key === key;
      })[0];
    }
    var titre = $('.cmk__name', ligne)
      ? $('.cmk__name', ligne).textContent.trim()
      : S.ligneDefaut || 'l’article';
    var index = Array.prototype.indexOf.call(ligne.parentNode.children, ligne);

    change(key, 0).then(function () {
      if (!item) return;
      var lignes = $('[data-cmk-lines]', scene);
      if (!lignes) return;
      var undo = document.createElement('div');
      undo.className = 'cmk__undo';
      undo.setAttribute('data-cmk-undo', '');
      undo.innerHTML =
        '<span>' + esc(avec(S.annulerLigne || '[produit] retiré', 'produit', titre)) + '</span>' +
        '<button type="button" data-cmk-undo-go>' + esc(S.annulerAction || 'Annuler') + '</button>';
      var ref = lignes.children[index] || null;
      lignes.insertBefore(undo, ref);
      dire(
        avec(
          S.annulerDit || '[produit] retiré du panier. Annuler reste possible pendant trois secondes.',
          'produit',
          titre
        )
      );

      if (undoTimer) clearTimeout(undoTimer);
      undoTimer = setTimeout(function () {
        if (undo.parentNode) undo.parentNode.removeChild(undo);
      }, UNDO_MS);

      $('[data-cmk-undo-go]', undo).addEventListener('click', function () {
        if (undoTimer) clearTimeout(undoTimer);
        if (undo.parentNode) undo.parentNode.removeChild(undo);
        var corpsAjout = { id: item.id, quantity: item.quantity };
        if (item.properties && Object.keys(item.properties).length) corpsAjout.properties = item.properties;
        if (item.selling_plan_allocation && item.selling_plan_allocation.selling_plan) {
          corpsAjout.selling_plan = item.selling_plan_allocation.selling_plan.id;
        }
        post(RACINE + 'cart/add.js', corpsAjout)
          .then(rafraichis)
          .then(function () {
            dire(avec(S.annulerRemis || '[produit] remis dans le panier.', 'produit', titre));
          })
          .catch(function () {
            rafraichis();
          });
      });
    });
  }

  /* ── Changer de format EN PLACE ─────────────────────────────────────────
     Pas de second calque : la ligne s'agrandit, les formats du produit
     s'affichent, un choix referme. Shopify ne sait pas changer la variante
     d'une ligne : le changement est un retrait suivi d'un ajout, deux
     requetes, et c'est la seule facon de le faire hors Plus. */
  function ouvreFormats(ligne) {
    var boite = $('[data-cmk-fmt]', ligne);
    var bouton = $('[data-cmk-mod]', ligne);
    if (!boite) return;
    if (!boite.hidden) {
      boite.hidden = true;
      if (bouton) bouton.setAttribute('aria-expanded', 'false');
      return;
    }
    var handle = ligne.getAttribute('data-cmk-handle');
    var actuelle = ligne.getAttribute('data-cmk-variant');
    boite.hidden = false;
    boite.innerHTML = '<p class="cmk__fmt-h">' + esc(S.formatChargement || 'Chargement des formats') + '</p>';
    if (bouton) bouton.setAttribute('aria-expanded', 'true');

    fetch(RACINE + 'products/' + handle + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) {
        return r.json();
      })
      .then(function (p) {
        boite.innerHTML =
          '<p class="cmk__fmt-h">' + esc(S.formatTitre || 'Changer de format') + '</p><div class="cmk__fmt-g">' +
          p.variants
            .map(function (v) {
              var courant = String(v.id) === String(actuelle);
              return (
                '<button type="button" class="cmk__chip" data-cmk-chip="' + v.id + '"' +
                (courant ? ' aria-current="true"' : '') +
                (v.available ? '' : ' disabled') +
                '><b>' + esc(virgule(String(v.title).replace(/ x /, ' × ').replace(' / ', ' · '))) + '</b><i>' + eur(v.price) + '</i></button>'
              );
            })
            .join('') +
          '</div>';
      })
      .catch(function () {
        boite.innerHTML =
          '<p class="cmk__fmt-h">' +
          esc(S.formatIndisponible || 'Formats indisponibles, ouvrez la fiche du produit.') +
          '</p>';
      });
  }

  function changeFormat(ligne, variantId) {
    var key = ligne.getAttribute('data-cmk-key');
    var qte = parseInt(ligne.getAttribute('data-cmk-qty'), 10) || 1;
    var item = null;
    if (dernierPanier) {
      item = (dernierPanier.items || []).filter(function (i) {
        return i.key === key;
      })[0];
    }
    if (occupe) return;
    occupe = true;
    if (scene) scene.setAttribute('data-cmk-busy', '');
    post(RACINE + 'cart/change.js', { id: key, quantity: 0 })
      .then(function () {
        var corpsAjout = { id: parseInt(variantId, 10), quantity: qte };
        if (item && item.properties && Object.keys(item.properties).length) corpsAjout.properties = item.properties;
        return post(RACINE + 'cart/add.js', corpsAjout);
      })
      .then(rafraichis)
      .then(function () {
        dire(S.formatModifie || 'Format modifié.');
      })
      .catch(function () {
        return rafraichis();
      })
      .finally(function () {
        occupe = false;
        if (scene) scene.removeAttribute('data-cmk-busy');
      });
  }

  /* ── Le code de reduction ───────────────────────────────────────────────
     `POST /cart/update` avec le champ `discount` : c'est le seul chemin
     qu'expose l'API Ajax hors Plus, et c'est celui que le theme empruntait
     deja. La reponse porte `discount_codes` : un code refuse s'y lit
     `applicable: false`, et c'est ce qui produit le message d'erreur, en
     encre et non en rouge. */
  /* LES CODES SE LISENT DANS `cart.discount_codes`, ET NULLE PART AILLEURS.
     Premiere passe : ils etaient lus dans `discount_applications`, ce qui
     marche en Liquid mais PAS sur l'API Ajax. Mesure du 30/08 sur le preview :
     BIENVENUE10 applique, total passe de 158,00 a 142,20 €, et la liste
     restait VIDE - parce que BIENVENUE10 est une remise de classe PRODUIT
     (`target_type: line_item`, verifie en direct le 30/08) et qu'une remise
     produit n'apparait pas dans `discount_applications` de `/cart.js`. */
  /* LE MONTANT D'UN CODE N'EST PAS DANS `discount_codes`, IL S'Y SOMME.
     Releve du 30/08 sur le preview, BIENVENUE10 applique : `/cart.js` rend
     `discount_codes: [{code, applicable}]`, SANS montant, parce que la remise
     est de classe PRODUIT et qu'elle vit dans
     `items[].line_level_discount_allocations`. Le montant se somme donc la,
     plus les remises de niveau panier, ce qui reste juste le jour ou un code
     de commande sera utilise (la bascule prevue pour BIENVENUE10). */
  function montantDuCode(cart, code) {
    var total = 0;
    (cart.items || []).forEach(function (it) {
      (it.line_level_discount_allocations || []).forEach(function (a) {
        if (a.discount_application && a.discount_application.title === code) total += a.amount || 0;
      });
    });
    (cart.cart_level_discount_applications || []).forEach(function (a) {
      if (a.title === code) total += a.total_allocated_amount || 0;
    });
    return total;
  }

  /* ★ LOT I · UN PANIER QUI NE SAIT PAS EXPLIQUER SES REMISES SE RELIT
     ──────────────────────────────────────────────────────────────────────
     RAPH, 03/09 A 16 h : « BIENVENUE10-TEST + 2 tapis = les deux remises OK ;
     j'ajoute un 3e tapis, je le retire, il ne reste que 2 tapis : plus aucune
     remise, BIENVENUE10-TEST est parti ».

     LA SONDE DIT AUTRE CHOSE QUE CE QU'IL A VU, ET LES DEUX SONT VRAIS
     (`v13i-sonde.log`, journal de chaque requete et de chaque reponse) : le
     code n'est JAMAIS parti. Apres son « + » puis son « - », `/cart.js` rend
     `discount_codes: [DUO20-TEST, BIENVENUE10-TEST]` et `total_price: 7938`,
     c'est-a-dire exactement le panier construit directement dans le meme etat.
     Ce qui est faux est le MONTANT ECRIT EN FACE DU CODE : le pied affiche
     « BIENVENUE10-TEST -0,00 € », et une remise a zero se lit comme une remise
     partie.

     LA CAUSE, ET ELLE EST DANS LA REPONSE DE SHOPIFY. `POST /cart/change.js`
     rend un panier COMPLET pour ses articles mais AMPUTE pour ses remises : il
     porte `discount_codes` et un `total_discount` justes, mais son
     `cart_level_discount_applications` arrive vide. Or `BIENVENUE10-TEST` est
     une remise de COMMANDE : tout son montant vit la. `montantDuCode` n'a donc
     rien a sommer et rend 0. C'est le meme defaut que celui releve le 30/08 sur
     `/cart/update.js` (voir la note de `poseLeCode`) ; la difference est qu'ici
     RIEN ne relisait `/cart.js` derriere : `poseLeCode` ne part pas, puisque le
     code duo est deja au bon endroit. Le faux montant restait donc a l'ecran
     jusqu'au chargement de page suivant.

     LA REGLE POSEE : le pied n'ecrit un montant que s'il peut l'EXPLIQUER.
     Quand la somme des remises qu'on sait attribuer ne tombe pas sur le
     `total_discount` du panier, l'objet est INCOMPLET : on le rend quand meme
     (le total, lui, est juste, et il vaut mieux que rien), et on relit
     `/cart.js` UNE fois derriere. Apres cette relecture, l'etat des remises est
     identique a celui d'un panier construit directement dans le meme etat, ce
     qui est precisement ce qu'on doit garantir apres toute modification de
     ligne.

     LA TOLERANCE EST D'UN CENTIME : les remises de Shopify sont des entiers de
     centimes, mais une remise repartie sur plusieurs lignes peut laisser un
     centime d'arrondi entre la somme des allocations et le total. */
  function remisesExpliquees(cart) {
    var total = cart.total_discount || 0;
    if (!total) return true;
    var somme = 0;
    (cart.items || []).forEach(function (it) {
      (it.line_level_discount_allocations || []).forEach(function (a) {
        somme += a.amount || 0;
      });
    });
    (cart.cart_level_discount_applications || []).forEach(function (a) {
      somme += a.total_allocated_amount || 0;
    });
    return Math.abs(somme - total) <= 1;
  }

  function codesEnCours() {
    if (!dernierPanier) return [];
    return (dernierPanier.discount_codes || [])
      .filter(function (d) {
        return d.applicable !== false;
      })
      .map(function (d) {
        return d.code;
      });
  }

  function envoieCodes(liste, nouveau) {
    var err = scene ? $('[data-cmk-code-err]', scene) : null;
    if (err) err.textContent = '';
    var fd = new FormData();
    fd.append('discount', liste.join(','));
    return fetch(RACINE + 'cart/update', {
      method: 'POST',
      headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: fd,
    })
      .then(function (r) {
        return r.json();
      })
      .then(function (etat) {
        var refuse =
          nouveau &&
          (etat.discount_codes || []).filter(function (d) {
            return d.code === nouveau && d.applicable === false;
          })[0];
        if (refuse) {
          if (err) {
            err.textContent =
              S.codeRefuse || 'Ce code ne s’applique pas à votre panier. Vérifiez-le, ou essayez-en un autre.';
          }
          dire(S.codeRefuseDit || 'Le code n’a pas été appliqué.');
          /* Le code refuse ne doit pas rester dans la liste. */
          var propre = liste.filter(function (c) {
            return c !== nouveau;
          });
          var fd2 = new FormData();
          fd2.append('discount', propre.join(','));
          return fetch(RACINE + 'cart/update', {
            method: 'POST',
            headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
            body: fd2,
          }).then(rafraichis);
        }
        return rafraichis().then(function () {
          if (nouveau) dire(avec(S.codeAppliqueDit || 'Code [code] appliqué.', 'code', nouveau));
        });
      })
      .catch(function () {
        if (err) err.textContent = S.codeErreur || 'Le code n’a pas pu être vérifié. Réessayez dans un instant.';
      });
  }

  /* ── Un seul ecouteur de clic pour tout le panneau ─────────────────────── */
  document.addEventListener('click', function (event) {
    var t = event.target;
    if (!t || typeof t.closest !== 'function') return;

    /* Ouvrir depuis n'importe quel declencheur du theme. */
    var ouvreur = t.closest('[aria-controls="CartDrawer"]');
    if (ouvreur && estTiroir && !ouvreur.classList.contains('cmk__veil')) {
      event.preventDefault();
      if (ouvert) ferme();
      else {
        ouvre(ouvreur);
        verifieLaFraicheur();
      }
      return;
    }

    if (!scene) return;
    if (!scene.contains(t)) return;

    if (t.closest('[data-cmk-close]')) {
      event.preventDefault();
      ferme();
      return;
    }
    if (t.closest('[data-cmk-veil]')) {
      /* Un glissement qui a ferme la feuille ne laisse pas de `click`
         derriere lui, mais un glissement ANNULE en laisse un : le drapeau
         `bouge` empeche le tap fantome. */
      if (!bouge) ferme();
      return;
    }

    var ligne = t.closest('[data-cmk-line]');
    if (ligne) {
      var key = ligne.getAttribute('data-cmk-key');
      var q = parseInt(ligne.getAttribute('data-cmk-qty'), 10) || 1;
      if (t.closest('[data-cmk-minus]')) {
        event.preventDefault();
        if (q <= 1) supprime(ligne);
        else change(key, q - 1);
        return;
      }
      if (t.closest('[data-cmk-plus]')) {
        event.preventDefault();
        change(key, q + 1);
        return;
      }
      if (t.closest('[data-cmk-sup]')) {
        event.preventDefault();
        supprime(ligne);
        return;
      }
      if (t.closest('[data-cmk-mod]') && t.closest('button')) {
        event.preventDefault();
        ouvreFormats(ligne);
        return;
      }
      var chip = t.closest('[data-cmk-chip]');
      if (chip && !chip.disabled) {
        event.preventDefault();
        if (chip.getAttribute('aria-current') === 'true') {
          ouvreFormats(ligne);
          return;
        }
        changeFormat(ligne, chip.getAttribute('data-cmk-chip'));
        return;
      }
    }

    var tete = t.closest('[data-cmk-code-t]');
    if (tete) {
      event.preventDefault();
      var pan = $('[data-cmk-code-p]', scene);
      var ouvertCode = tete.getAttribute('aria-expanded') === 'true';
      tete.setAttribute('aria-expanded', ouvertCode ? 'false' : 'true');
      if (pan) {
        pan.hidden = ouvertCode;
        if (!ouvertCode) {
          var inp = $('[data-cmk-code-in]', pan);
          if (inp) inp.focus();
        }
      }
      return;
    }

    if (t.closest('[data-cmk-code-go]')) {
      event.preventDefault();
      var champ = $('[data-cmk-code-in]', scene);
      var code = champ ? champ.value.trim().toUpperCase() : '';
      if (!code) return;
      var liste = codesEnCours();
      if (liste.indexOf(code) > -1) {
        var e2 = $('[data-cmk-code-err]', scene);
        if (e2) e2.textContent = S.codeDeja || 'Ce code est déjà appliqué.';
        return;
      }
      liste.push(code);
      if (champ) champ.value = '';
      envoieCodes(liste, code);
      return;
    }

    var off = t.closest('[data-cmk-code-off]');
    if (off) {
      event.preventDefault();
      var aRetirer = off.getAttribute('data-cmk-code-off');
      envoieCodes(
        codesEnCours().filter(function (c) {
          return c !== aRetirer;
        }),
        null
      );
      return;
    }
  });

  /* Entree dans le champ de code : le formulaire de paiement ne doit pas
     partir a sa place. */
  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Enter') return;
    var t = event.target;
    if (t && t.hasAttribute && t.hasAttribute('data-cmk-code-in')) {
      event.preventDefault();
      var go = $('[data-cmk-code-go]', scene);
      if (go) go.click();
    }
  });

  /* ══════════════════════════════════════════════════════════════════════
     § 5. L'AJOUT QUI SE RESSENT
     ----------------------------------------------------------------------
     LE PROBLEME MESURE : rien ne bougeait a l'ecran pendant les 687 premieres
     millisecondes apres le clic, sauf la DISPARITION du libelle du bouton a
     57 ms. Le tiroir n'etait pose qu'a 1 543 ms sur telephone.

     LA REPONSE : le tiroir s'ouvre AU CLIC, avec une ligne provisoire peinte
     a partir de ce que la page a deja sous les yeux (le titre, la photo, le
     prix). L'ajout, lui, part par le chemin habituel du theme ; quand le
     serveur repond, `cart-update` arrive et le rendu du § 3 remplace la ligne
     provisoire par la vraie. Aucun second ajout n'est emis : ce code ne fait
     qu'OUVRIR et PEINDRE.

     CE QUI N'EST PAS INTERCEPTE, ET POURQUOI : les boutons qui ouvrent
     l'apercu rapide (ils n'ajoutent rien), « Acheter maintenant » (il part au
     paiement), et tout ce qui se trouve DANS l'apercu rapide, parce que le
     theme referme la modale AVANT d'ouvrir le tiroir et que deux verrous de
     defilement poses en meme temps se marchent dessus.
     ══════════════════════════════════════════════════════════════════════ */

  var SEL_AJOUT = [
    'form[action*="/cart/add"] button[name="add"]',
    'form[action*="/cart/add"] [type="submit"]',
    '.product-form__submit',
    '#couloir-atc',
    '.vd-drawer__add-btn',
    '.sg7-btn[data-sample-variant-id]',
    '.pcard-sample-btn',
  ].join(', ');

  /* LA REGLE DU PANIER, LUE DANS LA PAGE, ET ELLE N'EST ECRITE QU'ICI (lot I,
     puis lot L). Parmi les images du produit deja presentes dans le DOM, la
     premiere dont l'adresse porte `vue-complete`. `grainePres` s'en sert pour
     peindre la ligne provisoire, `chauffeLaVignette` pour la chauffer avant le
     clic : les deux DOIVENT tomber sur le meme fichier, sinon le prechauffage
     ne sert rien. */
  function vueAPlatDe(scope) {
    var vues = (scope || document).querySelectorAll('img[src*="vue-complete"], img[srcset*="vue-complete"]');
    return vues.length ? vues[0].getAttribute('src') || '' : '';
  }

  /* ══════════════════════════════════════════════════════════════════════
     ★ LOT L (03/09) · LA PHOTO DE LA LIGNE EST CHAUFFEE AVANT LE CLIC
     ----------------------------------------------------------------------
     LA DEUXIEME MOITIE DE CE QUE RAPH DECRIT : « l'image VIENT SE METTRE,
     puis elle se recharge ». Le « puis elle se recharge » est l'echange de
     noeud regle au § 3 bis ; le « vient se mettre » est ceci.

     CE QUE LE LOT F PROMETTAIT : « la photo deja decodee, donc gratuite ».
     CE QUE LE LOT L A MESURE (`c4-v13l-sonde.mjs`, fiche Sahel, iPhone) :

       l'image que le selecteur retient (diapositive 2 de la galerie)
         src = ...vue-complete-new...&width=1946
         currentSrc = ""   complete = false   naturalWidth = 0

     ELLE N'EST PAS CHARGEE DU TOUT : c'est une diapositive hors cadre, en
     `loading="lazy"`. Et `taille()` reecrit sa largeur en 320, une adresse que
     RIEN dans la page n'a jamais demandee. La ligne provisoire ouvrait donc
     une VRAIE requete au moment du clic : relevé du 03/09, 36 795 octets
     partis a 108 ms, en concurrence avec `POST /cart/add`, et la vignette
     restait une case vide puis un JPEG progressif a moitie dessine jusqu'a
     804 ms. Le lot I avait corrige l'ADRESSE (la bonne photo) en perdant, sans
     le voir, le CACHE qui faisait tout l'interet du lot F.

     LA REPARATION EST UNE REQUETE, AU BON MOMENT. La page tient deja ce
     fichier en 160 px (la pastille de couleur) et parfois en 240 px (la rangee
     de complements) ; aucune des deux n'a la finesse d'une vignette de 104 px
     sur un ecran a trois points par pixel, et servir l'une d'elles ferait
     diverger l'etat stable du rendu de Liquid. On chauffe donc L'ADRESSE
     EXACTE que Liquid rendra, `width=320`, une fois par fiche, APRES le
     chargement et pendant un temps mort. Au clic, la ligne provisoire peint
     une image que le navigateur tient : plus de requete, plus de case vide.

     TROIS GARDES, ET AUCUNE N'EST DE PRECAUTION VAGUE :
       · seulement sur une FICHE (`.section-main-product`) : c'est le seul
         endroit ou l'on sait, sans requete, quelle photo le panier montrera ;
       · jamais en `Save-Data`, jamais en 2G : 36 Ko pour une hypothese ne se
         prennent pas sur une connexion qu'on economise ;
       · une seule fois par page, et jamais avant la fin du chargement : la
         chauffe ne doit disputer sa bande passante ni au LCP ni aux polices.
     ══════════════════════════════════════════════════════════════════════ */
  var vignetteChauffee = false;

  function chauffeLaVignette() {
    if (vignetteChauffee) return;
    var scopePdp = document.querySelector('.section-main-product, [id*="__main"]');
    if (!scopePdp) return;
    var co = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
    if (co && (co.saveData === true || /(^|-)2g$/.test(String(co.effectiveType || '')))) return;
    var u = vueAPlatDe(scopePdp);
    if (!u) return;
    vignetteChauffee = true;
    var im = new Image();
    im.decoding = 'async';
    im.src = taille(u, 320);
  }

  function auCalme(fn) {
    var poser = function () {
      if (typeof window.requestIdleCallback === 'function') window.requestIdleCallback(fn, { timeout: 3000 });
      else setTimeout(fn, 1200);
    };
    if (document.readyState === 'complete') poser();
    else window.addEventListener('load', poser, { once: true });
  }

  function grainePres(bouton) {
    var carte = bouton.closest('.product-card, .card-product, .product-card__inner');
    var scopePdp = document.querySelector('.section-main-product, [id*="__main"]');
    var scope = carte || scopePdp || document;

    var titre = '';
    var el = carte
      ? carte.querySelector('.product-card__title, .card__heading, .pcard__title')
      : document.querySelector('h1.product__title, .product__title, h1');
    if (el) titre = el.textContent.replace(/\s+/g, ' ').trim();

    /* ★ LOT I · LA GRAINE PREND, DES LE CLIC, L'IMAGE QUE LE PANIER MONTRERA
       ──────────────────────────────────────────────────────────────────────
       RAPH, 03/09 A 16 h : « quand on ajoute un produit, il y a un changement
       rapide entre l'image lifestyle (1) et la vue complete (2), visible ; il
       faut la vue complete directement ».

       IL DECRIT DEUX REGLES QUI NE SE PARLAIENT PAS. La ligne provisoire du
       lot F prenait la PREMIERE photo de la fiche - celle que le visiteur
       regarde, deja decodee, donc gratuite. Mais le panier, lui, ne montre pas
       cette photo-la : `casemira-cart-ligne.liquid` cherche dans les images du
       produit celle dont l'adresse contient `vue-complete` (la vue a plat, qui
       dit la forme et la matiere) et ne retombe sur l'image de la variante que
       s'il n'y en a aucune. `chercheLaFiche` applique la meme regle une demi-
       seconde plus tard. Deux images pour une vignette : l'echange se voit.

       RELEVE DU 03/09 SUR LA FICHE SAHEL ECRU (`v13i-mesure2.log`) : la galerie
       rend, dans l'ordre, `...-sahel-salon_...jpg` (l'ambiance, ce que la
       graine prenait) puis `...-sahel-vue-complete-new_...jpg` (ce que le
       panier montre). Ce sont bien deux fichiers differents.

       LA REGLE DEVIENT CELLE DU PANIER, ET ELLE EST LUE DANS LA PAGE : parmi
       les images du produit deja presentes dans le DOM, on prend la premiere
       dont l'adresse porte `vue-complete`. Meme fichier, et `ligneProvisoire`
       lui pose la MEME largeur de 320 px que `ligneHTML` et que Liquid : meme
       adresse exacte, donc zero echange visible.

       S'IL N'Y EN A PAS, ON GARDE CE QU'ON AVAIT. Une fiche sans vue a plat
       (le panier y montre alors l'image de la variante) et un ajout depuis une
       carte de collection (qui n'a qu'une photo) gardent le comportement du
       lot F : la photo deja decodee vaut mieux qu'un rectangle gris, et
       `chercheLaFiche` corrigera si elle differe. */
    var img = vueAPlatDe(scope);
    if (!img) {
      var im = scope.querySelector('img[src*="/cdn/shop/"], img[src*="cdn.shopify"]');
      if (im) img = im.currentSrc || im.src;
    }

    var prix = '';
    var pe = scope.querySelector('.price__regular, .price-item--regular, .price .money, .product__price');
    if (pe) prix = pe.textContent.replace(/\s+/g, ' ').trim();
    if (!prix) {
      /* R11b : le libelle porte « 49,00 € » en francais mais « €49.00 » en
         anglais. Le premier motif est celui d'avant, au caractere pres, avec le
         symbole de la boutique a la place du « € » ecrit en dur ; le second le
         retrouve quand le symbole PRECEDE le nombre. Rien ne change en francais. */
      var txtB = bouton.textContent || '';
      var sym = symboleMonnaie().replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
      var m =
        new RegExp('(\\d[\\d\xa0\u202f .,]*\\s*' + sym + ')').exec(txtB) ||
        new RegExp('(' + sym + '\\s*\\d[\\d\xa0\u202f .,]*\\d)').exec(txtB);
      if (m) prix = m[1].trim();
    }

    /* ── VAGUE 13, LOT F (03/09) : LE HANDLE ET LE PRIX EXACT ──────────
       `CHRONO-V13.md` § 6.b : pour ecrire le pied juste des le clic, il faut le
       prix de la variante EN CENTIMES, et pour poser le bloc d'offre il faut le
       handle. Les deux sont deja dans la page, sans une seule requete :

         · le handle et TOUTES les variantes avec leur prix vivent dans
           `<script class="cm-pdp-variants">`, rendu par `sections/main-product.liquid`
           (C1 vague 7) pour que le selecteur de tailles repeigne sans reseau ;
         · la variante CHOISIE est celle du champ `[name="id"]` du formulaire,
           que le theme met a jour a chaque changement de format.

       LA VERIFICATION CROISEE EST LE COEUR DE CE BLOC : on n'accepte le handle
       QUE si l'identifiant du formulaire figure dans les variantes de ce
       bloc-la. Le selecteur de tailles sait passer d'une couleur a l'autre
       (`siblings`) ; si le formulaire et le JSON ne parlent plus du meme
       produit, on ne sait rien et on ne montre rien d'optimiste. Un prix faux
       ou un rail faux valent moins qu'une demi-seconde d'attente.

       DEPUIS UNE CARTE DE COLLECTION on ne prend que le handle, par le lien de
       la carte : il suffit a garder la photo deja decodee (levier c), pas a
       calculer un total. */
    var handle = '';
    var cents = 0;
    var variante = 0;
    var qte = 1;
    var form = bouton.closest('form[action*="/cart/add"]');
    var qEl = form ? form.querySelector('[name="quantity"]') : null;
    var nq = qEl ? parseInt(qEl.value, 10) : 1;
    if (nq > 0) qte = nq;

    if (carte) {
      var lien = carte.querySelector('a[href*="/products/"]');
      var mh = lien ? /\/products\/([^/?#]+)/.exec(lien.getAttribute('href') || '') : null;
      if (mh) handle = decodeURIComponent(mh[1]);
    } else {
      var js =
        (scopePdp || document).querySelector('script.cm-pdp-variants') ||
        document.querySelector('script.cm-pdp-variants');
      var idEl = form ? form.querySelector('[name="id"]') : null;
      variante = idEl ? parseInt(idEl.value, 10) : 0;
      if (js && variante) {
        try {
          var d = JSON.parse(js.textContent);
          var vus = d && d.variants ? d.variants : [];
          for (var i = 0; i < vus.length; i++) {
            if (vus[i].id === variante) {
              handle = d.handle || '';
              if (typeof vus[i].price === 'number') cents = vus[i].price;
              break;
            }
          }
        } catch (e) {
          /* un JSON illisible ne vaut pas mieux qu'un JSON absent */
        }
      }
    }

    return { titre: titre, img: img, prix: prix, handle: handle, cents: cents, variante: variante, qte: qte };
  }

  function ligneProvisoire(graine) {
    var lignes = scene ? $('[data-cmk-lines]', scene) : null;
    if (!lignes) return;
    /* L'ETAT VIDE SE CACHE, IL NE S'ARRACHE PLUS, ET C'EST UN DEFAUT TROUVE A
       LA RECETTE DU 01/09. Cette ligne cherchait `[data-cmk-empty]` DANS la
       liste et le detachait de son parent. La vague 6 a sorti l'etat vide de
       la liste pour en faire son FRERE (il porte une rangee de best-sellers
       que le script ne sait pas reconstruire) : depuis, la recherche ne trouve
       plus rien, et l'etat vide restait VISIBLE sous la ligne provisoire.
       Releve a 390 px : pendant les ~500 ms qui separent le clic de la reponse
       du serveur, le tiroir montrait « Votre panier est vide » et sa rangee de
       best-sellers SOUS une ligne qui dit « Ajout au panier », puis se
       retractait de 56 px quand `rendu()` posait enfin le `hidden`.
       On pose donc le meme `hidden` que `rendu()`, au meme endroit, tout de
       suite. La symetrie est exacte : `rendu()` ecrit
       `vide.hidden = !!cart.item_count` a chaque rendu, et un ajout refuse
       repasse par `rafraichis()`, qui le rend a `false`. */
    var vide = $('[data-cmk-empty]', scene);
    if (vide) vide.hidden = true;
    /* VAGUE 13, LOT F : LA PHOTO PEINTE ICI EST GARDEE POUR LA VRAIE LIGNE.
       Elle est deja decodee (c'est celle que le visiteur regarde) ; sans elle,
       `rendu()` demandait l'image de la VARIANTE et la vignette devenait un
       rectangle gris pendant six dixiemes de seconde (`CHRONO-V13.md` § 4,
       capture a 900 ms ; 31,5 Ko pour rien). Voir `platClic` au § 3. */
    if (graine.handle && graine.img && !platParHandle[graine.handle]) platClic[graine.handle] = graine.img;
    var d = document.createElement('div');
    d.className = 'cmk__line';
    d.setAttribute('data-cmk-pending', '');
    d.innerHTML =
      (graine.img
        ? '<img class="cmk__vign" src="' + esc(taille(graine.img, 320)) + '" alt="" decoding="sync">'
        : '<span class="cmk__vign" aria-hidden="true"></span>') +
      '<div class="cmk__col"><p class="cmk__name">' +
      esc(graine.titre || S.ajoutTitre || 'Ajout en cours') + '</p>' +
      '<p class="cmk__meta">' + esc(S.ajoutMeta || 'Ajout au panier') + '</p>' +
      '<div class="cmk__bas"><div class="cmk__qte"><button type="button" disabled>&minus;</button>' +
      '<span>1</span><button type="button" disabled>+</button></div>' +
      '<div class="cmk__prix">' + esc(graine.prix || '') + '</div></div></div>';
    lignes.appendChild(d);
  }

  /* ── La vignette qui vole, ordinateur seulement ─────────────────────────
     Elle part de la photo cliquee et rejoint l'icone du panier. Elle n'est
     meme pas fabriquee quand le mouvement reduit est demande, ni sur
     telephone, ou l'icone du panier est souvent hors de l'ecran de travail du
     pouce et ou l'animation retarderait la seule chose qui compte : le tiroir
     qui s'ouvre. */
  function vole(graine) {
    if (!desktop() || !graine.img) return;
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var cible = document.querySelector('a.cart-drawer-button[aria-controls="CartDrawer"], .cart-icon');
    var source = document.querySelector('img[src="' + graine.img + '"]');
    if (!cible || !source) return;
    var a = source.getBoundingClientRect();
    var b = cible.getBoundingClientRect();
    if (!a.width || !b.width) return;
    var img = document.createElement('img');
    img.className = 'cmk-fly';
    img.src = graine.img;
    img.alt = '';
    img.style.left = a.left + 'px';
    img.style.top = a.top + 'px';
    img.style.width = a.width + 'px';
    img.style.height = a.height + 'px';
    document.body.appendChild(img);
    var dx = b.left + b.width / 2 - (a.left + a.width / 2);
    var dy = b.top + b.height / 2 - (a.top + a.height / 2);
    requestAnimationFrame(function () {
      img.style.transform = 'translate(' + dx + 'px,' + dy + 'px) scale(0.08)';
      img.style.opacity = '0';
    });
    setTimeout(function () {
      if (img.parentNode) img.parentNode.removeChild(img);
    }, 700);
  }

  /* ── LE PANIER FICTIF, VAGUE 13 LOT F (03/09) ──────────────────────────
     `CHRONO-V13.md` § 1 : les 430 ms de `POST /cart/add` sont du temps de
     SERVEUR, identiques bridees ou non, et aucun levier ne les raccourcit. La
     seule question qui reste est CE QUE LE TIROIR MONTRE PENDANT CE TEMPS.

     Ce panier-la n'est envoye nulle part et n'est jamais garde : c'est le
     panier que le serveur VA rendre, ecrit a partir de ce que la page sait
     deja. Il passe par le MEME `majPied()` et le MEME `majOffre()` que le
     panier reel, ce qui interdit aux deux de diverger : quand `cart-update`
     arrive, il reecrit les memes chiffres, sans animation et sans clignotement.

     TROIS CONDITIONS, ET SANS ELLES ON NE MONTRE RIEN D'OPTIMISTE (le
     comportement d'avant ce lot, au pixel pres) : un panier de reference deja
     lu, un handle verifie, et un prix en centimes. Une carte de collection ou
     un script tiers n'en ont pas : ils gardent l'attente. */
  function panierFictif(graine) {
    if (!dernierPanier || !graine || !graine.handle || !graine.cents) return null;
    var c = dernierPanier;
    var qte = graine.qte || 1;
    var montant = graine.cents * qte;
    var deliveryProduct = document.querySelector('[data-delivery-product]');
    var deliveryVendor = deliveryProduct && deliveryProduct.getAttribute('data-delivery-product') === graine.handle
      ? deliveryProduct.getAttribute('data-delivery-vendor') : '';
    var existingProduct = (c.items || []).find(function (item) { return item.handle === graine.handle; });
    if (!deliveryVendor && existingProduct) deliveryVendor = existingProduct.vendor;
    var faux = {
      key: 'cmk-optimiste',
      vendor: deliveryVendor || '',
      id: graine.variante || 0,
      handle: graine.handle,
      product_title: graine.titre || '',
      title: graine.titre || '',
      variant_title: '',
      quantity: qte,
      price: graine.cents,
      original_line_price: montant,
      final_line_price: montant,
      line_level_discount_allocations: [],
      properties: {},
      image: graine.img || '',
      url: '',
    };
    var brut = (typeof c.original_total_price === 'number' ? c.original_total_price : c.total_price || 0) + montant;
    var remises = c.total_discount || 0;
    return {
      item_count: (c.item_count || 0) + qte,
      /* SHOPIFY MET LE NOUVEL ARTICLE EN TETE, et c'est mesure, pas suppose :
         releve du 03/09, deux ajouts successifs, `/cart.js` rend le SECOND en
         premier. L'ordre compte parce que c'est le PREMIER tapis eligible qui
         donne son rail au bloc d'offre ; le poser a la fin ferait sauter le
         rail au moment de `cart-update`, c'est-a-dire exactement le saut qu'on
         cherche a supprimer. */
      items: [faux].concat(c.items || []),
      original_total_price: brut,
      /* Casemira 28/10/2026 (offre de novembre) : la base des paliers. Sans
         sous-total connu, la somme des lignes, qui est sa définition. */
      items_subtotal_price: sousTotalArticles(c) + montant,
      total_discount: remises,
      total_price: brut - remises,
      discount_codes: c.discount_codes || [],
      cart_level_discount_applications: c.cart_level_discount_applications || [],
      requires_shipping: c.requires_shipping,
      currency: c.currency,
    };
  }

  /* ── LA ZONE DU BLOC D'OFFRE GARDE SA PLACE ────────────────────────────
     `CHRONO-V13.md` § 6.c. Quand le bloc d'offre NE PEUT PAS etre pose des le
     clic - le seul cas reel est l'ajout depuis une carte de collection, dont
     l'eligibilite n'est connue qu'apres `/products/<handle>.js` - le tiroir
     recevra un bloc dans une demi-seconde et tout ce qui est en dessous
     descendra d'un coup. On garde donc la hauteur MINIMALE de ce bloc, celle du
     bandeau seul (57,4 px mesures au bras A, `VAGUE-13.md` § 5), et pas celle
     du rail : reserver 250 px pour un bandeau qui en fera 57 mentirait plus
     grand que le saut qu'on evite.

     ELLE SE LIBERE AU PREMIER RENDU REEL, quel qu'il soit : `majOffre()` retire
     l'attribut des que le serveur a parle, que le bloc arrive ou non. */
  function reserveLaZone(graine) {
    var hote = hoteOffre();
    if (!hote || $('[data-cmk-off]', hote)) return;
    if (!OFFRE || (OFFRE.meca || 'article_n') !== 'article_n' || !offreOuverte()) return;
    if (!graine || !graine.handle) return;
    if (eligibleParHandle[graine.handle] !== undefined) return;
    hote.setAttribute('data-cmk-off-attente', '');
  }

  /* CE QUE LE TIROIR MONTRE PENDANT QUE LE SERVEUR ECRIT. Trois gestes, dans
     l'ordre ou ils comptent pour l'oeil : le pied (compteur, total, Klarna,
     « Commander · X € »), puis le bloc d'offre depuis la reserve deja rendue
     par Liquid, puis, faute de mieux, la place qu'il prendra.

     `majOffre(fictif, true)` est OPTIMISTE : il ne pose aucun code de reduction
     (aucune ecriture de panier tant que l'ajout n'est pas confirme) et ne
     RETIRE jamais un bloc. Un panier fictif ne doit pouvoir qu'ajouter. */
  function montreLaSuite(graine) {
    var fictif = panierFictif(graine);
    if (!fictif) {
      reserveLaZone(graine);
      return;
    }
    majPied(fictif);
    panierLivraisonProvisoire = fictif;
    dateLivraison();
    majOffre(fictif, true);
    var hote = hoteOffre();
    if (!hote || !$('[data-cmk-off]', hote)) reserveLaZone(graine);
  }

  document.addEventListener(
    'click',
    function (event) {
      if (!estTiroir || !scene) return;
      var t = event.target;
      if (!t || typeof t.closest !== 'function') return;
      var b = t.closest(SEL_AJOUT);
      if (!b) return;
      if (b.disabled || b.getAttribute('aria-disabled') === 'true') return;
      /* Un bouton qui ouvre un calque n'ajoute rien. */
      if (b.hasAttribute('aria-controls') || b.getAttribute('aria-haspopup') === 'dialog') return;
      if (b.closest('quick-view-modal')) return;
      if (b.name === 'checkout' || /buy|acheter/i.test(b.id || '')) return;

      /* VAGUE 5 · L'ORDRE A CHANGE, ET C'EST LA MOITIE DU GAIN. `ouvre()` est
         la PREMIERE instruction : la classe qui declenche la montee est posee
         avant tout le reste. La graine (six `querySelector` sur le document),
         la ligne provisoire (un noeud ajoute DANS la feuille, invisible tant
         qu'elle monte) et la vignette qui vole (deux lectures de geometrie,
         donc deux mises en page forcees) partent a l'image suivante. Rien de
         cela ne change ce que le visiteur voit pendant les 220 ms de la
         montee : la feuille arrive vide et se remplit, ce qu'elle faisait
         deja en attendant le serveur. */
      ouvre(b);
      apresLImage(function () {
        var graine = grainePres(b);
        ligneProvisoire(graine);
        vole(graine);
        /* VAGUE 13, LOT F : LE RESTE DU PANIER ARRIVE UNE IMAGE PLUS TARD, ET
           C'EST MESURE. Ecrit dans la MEME tache que la ligne provisoire, le
           pied et le bloc d'offre repoussaient la premiere PEINTURE : le
           cinema du 03/09 montrait encore « Votre panier est vide » a 97 ms la
           ou l'ancien theme montrait deja la ligne a 90 ms. Le travail est
           reel (un bloc de 24 cartes injecte, ses prix reecrits, ses fondus
           mesures) et le navigateur ne peint qu'a la fin de la tache.

           Une image de plus coute 16 ms au pied et au bloc - ils passent de 46
           a 62 ms, tres loin des 700 ms d'avant le lot - et rend a la ligne
           provisoire sa premiere image. C'est la lecon du § 5 de la vague 5,
           appliquee une fois de plus : l'ordre est la moitie du gain. */
        apresLImage(function () {
          montreLaSuite(graine);
        });
      });
      /* Filet : si aucun `cart-update` n'arrive dans la seconde et demie,
         on va chercher la verite nous-memes. La ligne provisoire ne reste
         jamais seule a l'ecran. */
      setTimeout(function () {
        if ($('[data-cmk-pending]', scene)) rafraichis();
      }, 1500);
    },
    true
  );

  /* Un ajout refuse (rupture) ne laisse pas une ligne fantome. */
  document.addEventListener('product-ajax:error', function () {
    rafraichis();
    dire(S.ajoutEchec || 'Cet article n’a pas pu être ajouté. Vérifiez la disponibilité du format.');
  });

  /* § 6. Date de livraison: même moteur que les neuf gabarits produits actifs.
     Fournisseur par ligne, calendrier PL au départ, destination pendant le transport.
     Le panier affiche la date la plus tardive parmi les articles physiques. */
  function langueDuDocument() {
    var l = document.documentElement.getAttribute('lang');
    return l && l.length > 1 ? l : 'fr-FR';
  }

  /* VAGUE 8 : UN SEUL FORMAT, ET IL GARDE LE JOUR DE LA SEMAINE. La zone du
     bas est desormais une rangee de DEUX colonnes larges : une colonne offre
     135,9 px de texte a 390 px, et « lundi 8 sept. » y tient sur une ligne.

     `weekday: 'long'` parce que Raph l'a demande le 01/09 a 13 h 20 (« un
     meilleur truc pour la livraison ») : une date sans son jour de la semaine
     oblige a compter. `month: 'short'` parce que « lundi 8 septembre » mesure
     29 px de plus et fait passer le detail sur deux lignes a 320 px, ou la
     colonne n'offre que 108 px. C'est le NAVIGATEUR qui abrege le mois, dans
     la langue du document (« 8 sept. » en francais, « Sep 8 » en anglais) :
     aucune abreviation n'est ecrite dans le theme, et la regle i18n tient.

     LES DEUX FORMATS DE LA VAGUE 7 SONT PARTIS AVEC LEURS VARIANTES : le
     format long de V1 (`month: 'long'`) et le format court de V2 (sans le
     jour de la semaine). Une seule zone, un seul format, une seule date. */
  function dateLivree(d) {
    /* 23/10/2026 (Salli, fi ; Daniel, lt) : le jour suit le cas de la phrase, comme sur la fiche et le compte a
       rebours. casemira.fiche.jours_accusatif porte sept noms dans l'ordre de getUTCDay() (fi : essif en -na,
       lt : accusatif). Cle absente ou mal formee, donc toutes les autres langues : sortie d'Intl inchangee. */
    var J = (window.FoxTheme && FoxTheme.casemira && FoxTheme.casemira.fiche && FoxTheme.casemira.fiche.joursAccusatif) || '';
    var jours = String(J).split(',').map(function (j) { return j.trim(); });
    if (jours.length !== 7 || jours.some(function (j) { return !j; })) jours = null;
    try {
      var fmt = new Intl.DateTimeFormat(langueDuDocument(), { timeZone: 'UTC', weekday: 'long', day: 'numeric', month: 'short' });
      if (!jours || !fmt.formatToParts) return fmt.format(d);
      return fmt.formatToParts(d).map(function (p) { return p.type === 'weekday' ? jours[d.getUTCDay()] : p.value; }).join('');
    } catch (e) {
      /* Une langue que le moteur refuse ne doit pas emporter la ligne. */
      return d.toLocaleDateString('fr-FR', { timeZone: 'UTC' });
    }
  }

  var panierLivraisonProvisoire = null;

  /* ── 17/09/2026 · LES PIÈCES FABRIQUÉES À LA COMMANDE ────────────────────
     UNE LIGNE SUR COMMANDE NE PEUT PAS PORTER DE DATE. Le moteur commun ne
     modélise que du TRANSPORT : un tapis tufté en quatre semaines y sortirait
     à cinq jours. Tant qu'une telle ligne est au panier, la colonne de droite
     ne dit plus « livré le <date> » mais la fourchette de semaines : c'est la
     ligne la plus lente qui commande, exactement comme la date la plus
     tardive commandait déjà pour les articles physiques.

     DEUX SOURCES, ET IL EN FAUT DEUX. `_sur_commande` est la propriété de
     ligne posée par le formulaire d'achat (`snippets/buy-buttons.liquid`) :
     elle suit l'article dès l'instant de l'ajout, y compris dans le tiroir
     qui s'ouvre juste après, avant tout rechargement. `CFG.deliveryItems`
     porte le métachamp lu par Liquid au dernier rendu de page : c'est le
     filet pour les lignes déposées au panier AVANT que la propriété
     n'existe. L'une comble le trou de l'autre.

     LE NOMBRE EST LE MAXIMUM et non le premier trouvé : deux pièces de délais
     différents au même panier arrivent ensemble, pas séparément. */
  var surCommandeCfg = null;

  function surCommandeParId() {
    if (surCommandeCfg) return surCommandeCfg;
    surCommandeCfg = {};
    (CFG.deliveryItems || []).forEach(function (item) {
      var n = parseInt(item && item.surCommande, 10);
      if (item && item.id && n > 0) surCommandeCfg[String(item.id)] = n;
    });
    return surCommandeCfg;
  }

  function semainesSurCommande(items) {
    var table = surCommandeParId();
    var max = 0;
    (items || []).forEach(function (item) {
      if (!item) return;
      var n = parseInt(item.properties && item.properties._sur_commande, 10);
      if (!(n > 0)) n = table[String(item.product_id || item.id || '')] || 0;
      if (n > max) max = n;
    });
    return max;
  }

  function calculeLivraison() {
    var moteur = window.CasemiraDelivery;
    if (!moteur) return null;
    var panier = panierLivraisonProvisoire || dernierPanier;
    var items = panier ? panier.items : CFG.deliveryItems;
    // Un ajout optimiste sans fournisseur attend la réponse, pas de date inventée.
    if (items && items.some(function (item) { return item.key === 'cmk-optimiste' && !item.vendor; })) return null;
    var estimation = moteur.estimateCart({ country: moteur.currentCountry(), items: items || [] });
    return estimation ? estimation.deliveryDate : null;
  }

  /* LA SECONDE COLONNE DE LA RANGEE : SON TITRE ET SON DETAIL.

     LE DETAIL EST DU TEXTE NU, ET C'EST UN CHANGEMENT DE LA VAGUE 8. Les deux
     ecritures precedentes posaient la date dans un `<b>` en encre pleine :
     elle etait alors le seul element fort d'une rangee qui n'avait qu'un
     niveau. La rangee en a deux, et le niveau fort est le TITRE. Une date en
     gras SOUS un titre en gras ferait deux accents dans la meme colonne.

     LE TITRE DIT « offerte » OU NE LE DIT PAS, selon le sous-total. Les deux
     ecritures sont rendues par Liquid et l'une des deux est masquee : le
     tiroir n'est pas re-rendu par le serveur quand le panier change, c'est
     donc ici que la bascule se refait, avec le meme seuil, passe en
     configuration par le pied (`portMin`, 100 €). Le DETAIL, lui, ne bouge
     pas : la date de livraison est vraie au-dessus comme en dessous du seuil.

     LA COLONNE EST MASQUEE TANT QUE LA DATE N'EST PAS ECRITE, et la rangee
     tient a une colonne le temps d'une image, sans changer de hauteur : celle
     de gauche porte deja les deux niveaux. */
  function dateLivraison() {
    if (!scene) return;
    var boite = $('[data-cmk-livr]', scene);
    var texte = $('[data-cmk-livr-d]', scene);
    if (!boite || !texte) return;
    var panier = panierLivraisonProvisoire || dernierPanier;
    if (panier && !panier.item_count) {
      boite.hidden = true;
      return;
    }
    /* LE GABARIT EST COUPE EN DEUX AU `%date%`, ET C'EST CE QUI SAUVE LE 320.
       Le mot qui precede la date (« livré le », « by ») va dans un noeud a
       part que la feuille masque sous 390 px : mesure du 01/09, « livré le
       mercredi 2 sept. » se replie dans une colonne de 108 px, la date seule
       ne se replie jamais, pas meme au pire jour de l'annee. Le gabarit reste
       UNIQUE, une seule chaine de locale par langue, et le script n'invente
       toujours aucune phrase : il ne fait que la couper la ou elle nomme sa
       propre variable. Le segment d'apres est pose pour les langues qui
       placent la date ailleurs qu'en fin de phrase. */
    /* LA PIÈCE D'ATELIER PASSE AVANT LA DATE, et elle sort par les mêmes trois
       noeuds : le mot d'avant, la valeur, le mot d'après. Rien n'est écrit en
       dur ici, le gabarit vient du pied, traduit.
       18/09/2026 : la promesse passe à « sous 5 semaines », soit semaines + 1,
       comme dans les quatre snippets Liquid. `%bas%` reçoit la même valeur que
       `%haut%` pour qu'un gabarit de locale oublié ne rende jamais un « 6 ». */
    var panierSc = panierLivraisonProvisoire || dernierPanier;
    var semaines = semainesSurCommande(panierSc ? panierSc.items : CFG.deliveryItems);
    if (semaines > 0) {
      var gabaritSc = CFG.livraisonSurCommande || '%bas% - %haut%';
      var avantSc = $('[data-cmk-livr-p]', scene);
      var apresSc = $('[data-cmk-livr-s]', scene);
      if (avantSc) avantSc.textContent = '';
      if (apresSc) apresSc.textContent = '';
      texte.textContent = gabaritSc
        .split('%bas%').join(String(semaines + 1))
        .split('%haut%').join(String(semaines + 1));
      majPortTitre();
      boite.hidden = false;
      return;
    }
    var gabarit = CFG.livraison || '%date%';
    var coupe = gabarit.indexOf('%date%');
    if (coupe < 0) coupe = gabarit.length;
    var avant = $('[data-cmk-livr-p]', scene);
    var apres = $('[data-cmk-livr-s]', scene);
    if (avant) avant.textContent = gabarit.slice(0, coupe);
    if (apres) apres.textContent = gabarit.slice(coupe + '%date%'.length);
    var date = calculeLivraison();
    if (!date) { boite.hidden = true; return; }
    texte.textContent = dateLivree(date);
    majPortTitre();
    boite.hidden = false;
  }

  /* 23/10/2026 : total du panier SANS les cartes cadeaux, pour la livraison
     offerte et la jauge au montant (une carte ne s'expédie pas et n'est pas un
     tapis). `/cart.js` pose `gift_card: true` sur la ligne. */
  function totalHorsCartes(cart) {
    var t = (cart && cart.total_price) || 0;
    ((cart && cart.items) || []).forEach(function (it) {
      if (it.gift_card) t -= (typeof it.final_line_price === 'number' ? it.final_line_price : (it.line_price || 0));
    });
    return Math.max(0, t);
  }

  function majPortTitre() {
    if (!scene || !dernierPanier) return;
    var offerte = $('[data-cmk-livr-offerte]', scene);
    var payante = $('[data-cmk-livr-payante]', scene);
    if (!offerte || !payante) return;
    var seuil = typeof CFG.portMin === 'number' ? CFG.portMin : 10000;
    var franchi = totalHorsCartes(dernierPanier) >= seuil;
    offerte.hidden = !franchi;
    payante.hidden = franchi;
  }

  /* ══════════════════════════════════════════════════════════════════════
     § 7. L'OFFRE DUO                                              vague 2
     ----------------------------------------------------------------------
     TROIS CHOSES, ET RIEN DE PLUS.

     1. POSER LE CODE, SANS SAISIE. `POST /cart/update.js` avec le champ
        `discount` : Shopify l'a ouvert le 21 mai 2025 (changelog « [Cart AJAX
        API] Discounts support on /cart/update.js », reference « Cart API »,
        section « Update discounts in the cart »). Plusieurs codes se separent
        par une virgule, la chaine vide les retire tous. VERIFIE sur le site
        reel, pas suppose : `c4-v2-ajax.mjs`, releve du 30/08, panier de deux
        tapis, 83,00 € qui passent a 76,20 € et un `discount_codes:
        [{code, applicable: true}]` dans `/cart.js`.

     2. AFFICHER LA VRAIE REMISE, JAMAIS UN CALCUL PARALLELE. Le montant vient
        de `items[].line_level_discount_allocations`, exactement comme celui
        d'un code saisi (§ 4, `montantDuCode`). Le prix barre et l'etiquette
        « -20 % » de la ligne viennent, eux, de la difference entre
        `original_line_price` et `final_line_price` : la ligne produit de la
        vague 1 les affichait deja, sans une ligne de plus.

        CE QUE SHOPIFY FAIT DU CUMUL, AUJOURD'HUI. Sur ce plan (Basic), une
        remise BXGY et une remise PRODUIT ne se combinent pas : « All products
        that are part of a Buy X get Y discount are ineligible for further
        product discounts » (help.shopify.com, « Buy X get Y discounts »).
        BIENVENUE10 est encore une remise PRODUIT : releve du 30/08, panier de
        deux tapis, les deux codes poses ensemble, Shopify garde BIENVENUE10
        (8,30 €) et rend DUO20-TEST `applicable: false` (6,80 €) - la meilleure
        des deux pour le client, pas la somme. Le thème n'ecrit alors AUCUNE
        ligne « Remise duo », parce qu'elle vaudrait zero. Apres la bascule du
        jour J (BIENVENUE10 devient une remise de COMMANDE), les deux se
        cumulent : verifie le 30/08 avec 10HAQBN, un code de commande deja en
        service, 83,00 € - 6,80 € - 10,00 € = 66,20 €, les DEUX `applicable:
        true`.

     3. POSER LA RANGEE. Les quatre compléments viennent du metachamp
        `custom.complements` du premier tapis eligible, que seul LIQUID sait
        lire : `/products/<handle>.js` ne rend pas les metachamps. La rangee
        est donc toujours celle du serveur, jamais une reconstruction, et elle
        arrive DEJA RENDUE avec la page : celle du panier est visible, celle du
        produit de la page attend dans un `<template>`. AUCUNE requete n'est
        faite pour elle. Le chemin evident, l'API de rendu de section, ne
        marche pas ici : elle rend les sections SANS leurs reglages (§ 7,
        `memoriseLesRangees`).
     ══════════════════════════════════════════════════════════════════════ */

  var OFFRE = null;
  var offreLue = false;

  function litOffre() {
    if (offreLue) return;
    offreLue = true;
    var el = scene ? $('[data-cmk-offre-cfg]', scene) : null;
    if (!el) return;
    try {
      OFFRE = JSON.parse(el.textContent);
    } catch (e) {
      OFFRE = null;
      return;
    }
    /* La semence : Liquid a deja juge tout ce qui etait au panier au chargement
       de la page, en lisant les tags, les options ET les collections. Le script
       n'a plus qu'a completer pour ce qui arrive ensuite. */
    var f = OFFRE.fiches || {};
    Object.keys(f).forEach(function (h) {
      if (eligibleParHandle[h] === undefined) eligibleParHandle[h] = !!f[h];
    });
  }

  function codeDuo() {
    return OFFRE && OFFRE.code ? String(OFFRE.code).trim().toUpperCase() : '';
  }

  /* La date de fin est refaite ici avec l'horloge du VISITEUR : Liquid est
     rendu par le serveur, souvent depuis un cache, et une offre qui se termine
     a minuit ne doit pas survivre a une page servie de la veille. */
  function offreOuverte() {
    if (!OFFRE || !codeDuo()) return false;
    if (OFFRE.fin) {
      var t = Date.parse(String(OFFRE.fin) + 'T23:59:59');
      if (!isNaN(t) && Date.now() > t) return false;
    }
    return true;
  }

  /* ── L'ETAT DE L'OFFRE, VAGUE 11 ────────────────────────────────────────
     Il ne rend plus seulement un compte : il rend de quoi ECRIRE la phrase et
     BARRER les prix du rail, et les deux se lisent dans la meme passe.

       n        le nombre d'unites eligibles au panier ;
       premier  le handle du premier tapis eligible (celui dont le rail parle) ;
       prix     leurs prix unitaires, TRIES du moins cher au plus cher ;
       k        floor(n / 2), le nombre de tapis que la BXGY illimitee remise ;
       pivot    le (k+1)-ieme prix trie quand n est IMPAIR, 0 sinon. C'est le
                seul nombre dont le rail a besoin (voir la note du snippet
                `casemira-cart-offre-rangee.liquid`) : l'economie
                SUPPLEMENTAIRE d'une carte de prix P vaut 20 % x min(P, pivot),
                et rien quand n est pair ;
       remise   20 % de la somme des k moins chers - le calcul LOCAL, optimiste,
                celui qu'on affiche tant que Shopify n'a pas repondu ;
       kSrv,
       remiseSrv  ce que le serveur a REELLEMENT accorde, lu dans les
                `discount_allocations` des lignes, filtrees sur le code duo.
                BIENVENUE10 pose ses propres allocations tant qu'elle est une
                remise PRODUIT : les additionner annoncerait une remise duo qui
                n'en est pas une. */
  function etatOffre(cart) {
    var n = 0;
    var premier = null;
    var prix = [];
    var code = codeDuo();
    var remiseSrv = 0;
    var kSrv = 0;
    var pct = (OFFRE && OFFRE.pct ? OFFRE.pct : 20) / 100;
    (cart.items || []).forEach(function (it) {
      if (it.gift_card) return; /* 23/10/2026 : la carte cadeau ne compte pas dans le Duo */
      if (estEchantillonLigne(it)) return;
      var e = eligibleParHandle[it.handle];
      if (e === undefined) {
        chercheLaFiche(it.handle);
        return;
      }
      if (!e) return;
      n += it.quantity;
      for (var q = 0; q < it.quantity; q++) prix.push(it.price);
      if (!premier) premier = it.handle;
      var allocs = it.line_level_discount_allocations || it.discounts || [];
      for (var a = 0; a < allocs.length; a++) {
        var app = allocs[a].discount_application || {};
        var titre = String(app.title || allocs[a].title || '').toUpperCase();
        /* Le titre d'une allocation de code EST le code, mais une remise
           renommee peut le porter en tete (« DUO20-TEST (recette...) ») : on
           accepte les deux, jamais un autre code. */
        if (!code || (titre !== code && titre.indexOf(code) !== 0)) continue;
        var m = allocs[a].amount || 0;
        remiseSrv += m;
        var unite = it.price * pct;
        if (unite > 0) kSrv += Math.round(m / unite);
      }
    });
    prix.sort(function (a, b) {
      return a - b;
    });
    var k = Math.floor(n / 2);
    var somme = 0;
    for (var i = 0; i < k; i++) somme += prix[i];
    return {
      n: n,
      premier: premier,
      prix: prix,
      k: k,
      pivot: n % 2 === 1 ? prix[k] || 0 : 0,
      remise: Math.round(somme * pct),
      kSrv: kSrv,
      remiseSrv: remiseSrv,
    };
  }

  var codeEnVol = false;
  var codeRelance = null;

  /* ★ LOT I · LE THEME NE TOUCHE JAMAIS A UN CODE QU'IL N'A PAS POSE.
     Le champ `discount` de `/cart/update.js` REMPLACE la liste complete des
     codes du panier : n'y ecrire que le code duo effacerait le code du client.
     La regle est donc ecrite ici, une fois, et elle vaut pour chaque ecriture :
     ce qu'on envoie est (les codes deja presents, moins le duo) + le duo s'il
     est du, DANS L'ORDRE D'ORIGINE. Le code n'a jamais fait autrement ; ce que
     le lot I ajoute est la SOURCE DE REPLI. `cart` peut etre un objet partiel
     publie par un autre script (le bus `cart-update` du theme en rend un) :
     sans `discount_codes`, la liste envoyee serait vide et le code du client
     partirait pour de bon. On retombe donc sur le dernier panier connu, et si
     on ne connait rien, ON N'ECRIT RIEN. */
  function poseLeCode(n, cart) {
    var code = codeDuo();
    if (!code) return;
    var source = cart && cart.discount_codes;
    if (!source && dernierPanier) source = dernierPanier.discount_codes;
    if (!source) return;
    var presents = source.map(function (d) {
      return String(d.code).toUpperCase();
    });
    var doit = n >= (OFFRE.seuil || 2);
    var est = presents.indexOf(code) > -1;
    if (doit === est) return;
    /* Une seule ecriture de panier a la fois. `change()` relache son verrou
       APRES avoir rendu : sans cette relance, un « + » de quantite qui fait
       passer le seuil ne poserait jamais le code. */
    if (occupe || codeEnVol) {
      if (!codeRelance) {
        codeRelance = setTimeout(function () {
          codeRelance = null;
          if (dernierPanier) majOffre(dernierPanier);
        }, 120);
      }
      return;
    }
    codeEnVol = true;
    var liste = presents.filter(function (c) {
      return c !== code;
    });
    if (doit) liste.push(code);
    fetch(RACINE + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ discount: liste.join(',') }),
    })
      .then(function () {
        /* La reponse de `/cart/update.js` ne porte PAS le detail des remises de
           niveau panier (releve du 30/08 : `cart_level_discount_applications`
           y arrive vide de son titre et de son montant). On relit `/cart.js`,
           qui, lui, dit tout. */
        return panierFrais();
      })
      .then(function (c) {
        codeEnVol = false;
        rendu(c);
      })
      .catch(function () {
        codeEnVol = false;
      });
  }

  /* ══ AVANT-PREMIÈRE BLACK WEEK (SPEC-ACCES-ANTICIPE-2026-10-29) ═══════════
     Samedi 21 et dimanche 22 novembre, le visiteur venu par le lien du mail
     (`CM_OFFRE.acces`) a la Black Week trois jours avant tout le monde. Une
     remise automatique ne se réserve pas à un segment ; quatre CODES réservés
     au segment « inscrits et clients », un par palier, le font. Le client ne
     tape rien : ce script pose le code du palier atteint et retire les trois
     autres, exactement comme `poseLeCode` pose DUO20 (même verrou, même
     relecture de `/cart.js`). Hors avant-première, il retire les quatre s'ils
     traînent (Shopify les aura de toute façon expirés le lundi à 0 h).

     JAMAIS DEUX FOIS LA MÊME TENTATIVE SUR LE MÊME PANIER : si Shopify ne
     garde pas un code inconnu ou refusé dans `discount_codes`, la relecture
     relancerait la pose à l'infini. La dernière tentative (code, panier, base)
     est mémorisée et n'est pas rejouée tant que le panier n'a pas changé. */
  var accesDernierEssai = '';

  function codesAcces() {
    var O = window.CM_OFFRE;
    return (O && O.accesCodes) || [];
  }

  function estCodeAcces(code) {
    var liste = codesAcces();
    return liste.length > 0 && liste.indexOf(String(code || '').toUpperCase()) > -1;
  }

  function poseCodeAcces(cart) {
    var O = window.CM_OFFRE;
    var liste = codesAcces();
    if (!liste.length) return;
    var source = cart && cart.discount_codes;
    if (!source && dernierPanier) source = dernierPanier.discount_codes;
    if (!source) return;
    var presents = source.map(function (d) {
      return String(d.code).toUpperCase();
    });
    var voulu = '';
    var e = O && O.acces && O.actif !== false ? etatPaliers(cart) : null;
    if (e && e.at >= 1) voulu = liste[Math.min(e.at, liste.length) - 1] || '';
    var autres = presents.filter(function (c) {
      return liste.indexOf(c) > -1 && c !== voulu;
    });
    var est = !!voulu && presents.indexOf(voulu) > -1;
    if (!autres.length && (!voulu || est)) return;
    var essai = voulu + '@' + ((cart && cart.token) || '') + '@' + (e ? e.base : 0) + '@' + presents.join('+');
    if (essai === accesDernierEssai) return;
    if (occupe || codeEnVol) {
      if (!codeRelance) {
        codeRelance = setTimeout(function () {
          codeRelance = null;
          if (dernierPanier) majOffre(dernierPanier);
        }, 120);
      }
      return;
    }
    accesDernierEssai = essai;
    codeEnVol = true;
    var envoi = presents.filter(function (c) {
      return liste.indexOf(c) === -1;
    });
    if (voulu) envoi.push(voulu);
    fetch(RACINE + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ discount: envoi.join(',') }),
    })
      .then(function () {
        return panierFrais();
      })
      .then(function (c) {
        codeEnVol = false;
        rendu(c);
      })
      .catch(function () {
        codeEnVol = false;
      });
  }

  /* LES RANGEES SONT RENDUES PAR LE SERVEUR, ET GARDEES EN RESERVE.
     `custom.complements` est un metachamp : `/products/<handle>.js` ne le rend
     pas, et l'API de rendu de section ne peut pas remplacer Liquid ici - elle
     rend les sections SANS leurs reglages (releve du 31/08 : un
     `/?sections=cart-drawer` rend les lignes du panier mais un bloc d'offre
     vide, parce que `section.settings.offre_active` y est nul ; meme resultat
     sur `/cart?sections=main-cart`).

     Liquid rend donc DEUX rangees a chaque page : celle du premier tapis
     eligible du panier, visible, et celle du produit de la PAGE, rangee dans
     un `<template>`. Le geste le plus frequent du site est « j'ajoute le tapis
     que je regarde » : il est servi sans une seule requete. Ce qui n'est
     couvert ni par l'une ni par l'autre - un ajout rapide depuis une carte de
     collection - ne montre pas de bloc jusqu'au chargement suivant, et c'est
     le bon comportement : mieux vaut se taire que proposer les complements
     d'un autre tapis. */
  var railParHandle = {};

  function hoteOffre() {
    return scene ? $('[data-cmk-offre]', scene) : null;
  }

  /* ══════════════════════════════════════════════════════════════════════
     ★ LOT M (04/09) - UNE VIGNETTE DE RAIL, UN SEUL NOEUD
     ----------------------------------------------------------------------
     C'EST LE POINT 4 DU § L.7, ET IL A ETE MESURE AVANT D'ETRE CORRIGE.
     `injecteLeBloc` remplace le bloc d'offre EN ENTIER : `retireLeBloc` sort
     l'ancien noeud du document, `insertAdjacentHTML` en fabrique un neuf, et
     TOUTES les vignettes du rail renaissent avec lui, alors que leur adresse
     ne change pas d'un caractere (le HTML vient de `railParHandle`, qui garde
     le bloc TEL QUEL). Un `<img>` qui vient de naitre n'a rien a peindre tant
     que son image n'est pas rattachee et REDECODEE, meme quand le fichier est
     deja en cache : c'est exactement le blanc d'une a deux images d'ecran que
     Raph avait filme sur la vignette de LIGNE, et que le lot L a ferme la.

     CE QUE LA MESURE DIT, ET C'EST DEUX CHOSES (`c4-v13m-mesure.mjs`) :

       · LE SCENARIO ORDINAIRE N'EST PAS TOUCHE. Une quantite qui change, un
         code pose, une suppression annulee : `majOffre` appelle
         `poseLaRangee`, qui NE REINJECTE RIEN tant que le handle du bloc en
         place est celui du panier. Le bloc d'offre n'est donc PAS remplace a
         chaque rendu, contrairement a ce que le § L.7 supposait.
       · MAIS LE CHEMIN EXISTE, et il est ordinaire lui aussi : des que le
         dernier tapis eligible sort du panier, `retireLeBloc` emporte le bloc,
         et le tapis suivant le fait revenir par `injecteLeBloc`. Les memes
         cartes, les memes adresses, et pourtant des noeuds neufs.

     LA REGLE POSEE ICI EST CELLE DU LOT L, transposee au rail. Deux
     differences, et elles sont voulues :

       1. LE POT SURVIT ENTRE LES DEUX GESTES. Pour la ligne, la recolte et la
          replantation encadrent un seul `innerHTML` ; ici, le retrait et la
          remise en place peuvent etre separes de plusieurs secondes (le temps
          que le client remette un tapis). Le pot est donc porte par le module,
          pas par l'appel, et il est BORNE : au-dela de `POT_RAIL_MAX` adresses
          les plus anciennes sortent, sans quoi une longue session de va-et-
          vient retiendrait des images pour rien.
       2. UNE VIGNETTE GARDEE NE SERT QU'UNE FOIS PAR MISE EN PLACE. Le bloc
          rend jusqu'a huit rails, et un meme tapis peut figurer dans deux
          d'entre eux : rendre le meme noeud a deux emplacements le DEPLACERAIT
          et laisserait le premier vide. `pris` l'interdit.

     COMME AU LOT L, `src` N'EST PAS REPORTE sur le noeud garde : c'est lui qui
     declencherait le rechargement qu'on supprime. Les autres attributs le
     sont, `data-cmk-forme` compris, parce que c'est lui qui decide du cadrage.
     ══════════════════════════════════════════════════════════════════════ */
  var ATTR_VIGN_RAIL = ['class', 'alt', 'width', 'height', 'loading', 'decoding', 'data-cmk-forme'];
  var POT_RAIL_MAX = 64;
  var potRail = {};
  var ordreRail = [];

  function recolteLesVignettesRail(hote) {
    $$('img.cmk__off-i', hote).forEach(function (im) {
      var a = im.getAttribute('src');
      if (!a || potRail[a] === im) return;
      if (!potRail[a]) ordreRail.push(a);
      potRail[a] = im;
    });
    while (ordreRail.length > POT_RAIL_MAX) {
      var vieille = ordreRail.shift();
      delete potRail[vieille];
    }
  }

  function replanteLesVignettesRail(hote) {
    var pris = {};
    $$('img.cmk__off-i', hote).forEach(function (neuve) {
      var a = neuve.getAttribute('src');
      var gardee = a ? potRail[a] : null;
      if (!gardee || gardee === neuve || pris[a] || !neuve.parentNode) return;
      /* LE BON TEST EST `isConnected`, PAS `parentNode`, ET C'EST UN DEFAUT
         TROUVE A LA PREMIERE MESURE. `retireLeBloc` retire le BLOC ; les
         vignettes recoltees restent donc filles de leur `<a>` dans un arbre
         detache, et leur `parentNode` n'est jamais nul. Le juger sur
         `parentNode` sautait la replantation a tous les coups (releve du
         04/09 : sept vignettes neuves, aucune gardee). Ce qu'il faut
         interdire, c'est de prendre un noeud encore DANS LE DOCUMENT, ce qui
         laisserait un trou la ou il est. */
      if (gardee.isConnected) return;
      pris[a] = true;
      ATTR_VIGN_RAIL.forEach(function (n) {
        var v = neuve.getAttribute(n);
        if (v === null) gardee.removeAttribute(n);
        else gardee.setAttribute(n, v);
      });
      neuve.parentNode.replaceChild(gardee, neuve);
    });
  }

  function retireLeBloc() {
    var hote = hoteOffre();
    if (!hote) return;
    var vieux = $('[data-cmk-off]', hote);
    /* ★ LOT M : les vignettes deja peintes sont retenues AVANT le retrait.
       C'est le seul endroit par lequel un bloc quitte le document, que ce soit
       pour disparaitre ou pour etre remplace : la recolte y est donc complete
       et elle n'est ecrite qu'une fois. */
    if (vieux) recolteLesVignettesRail(vieux);
    if (vieux && vieux.parentNode) vieux.parentNode.removeChild(vieux);
    surveilleLOffre();
  }

  function injecteLeBloc(html, handle, nu) {
    var hote = hoteOffre();
    if (!hote) return;
    retireLeBloc();
    hote.insertAdjacentHTML('beforeend', html);
    var bloc = $('[data-cmk-off]', hote);
    if (bloc) {
      /* Le bandeau nu n'a pas de tapis : c'est le panier qui lui en donne un,
         sans quoi `poseLaRangee` le reinjecterait a chaque rendu. */
      if (handle) bloc.setAttribute('data-cmk-off-handle', handle);
      if (nu) bloc.setAttribute('data-cmk-nu', '');
      else bloc.removeAttribute('data-cmk-nu');
      accordeLeRail(bloc);
      /* ★ LOT M : et APRES `accordeLeRail`, qui retire les rails sans cartes.
         Replanter avant reviendrait a rendre leur place a des vignettes qu'on
         s'apprete a jeter. */
      replanteLesVignettesRail(bloc);
    }
    /* Le bloc vient d'etre remplace : l'observateur du § 8 regardait l'ancien
       noeud, qui n'est plus dans le document. */
    surveilleLOffre();
    /* VAGUE 13 : les deux rangees du bloc sont neuves, leurs fondus aussi. */
    prevoisLesFondus();
  }

  function memoriseLesRangees() {
    var hote = hoteOffre();
    if (!hote) return;
    var bloc = $('[data-cmk-off]', hote);
    if (bloc) {
      /* Le bloc rendu par le serveur passe par le meme garde-fou que ceux
         qu'on injecte : un intitule de rail sans carte n'entre pas en reserve
         et ne reste pas a l'ecran. */
      accordeLeRail(bloc);
      railParHandle[bloc.getAttribute('data-cmk-off-handle')] = bloc.outerHTML;
    }
    $$('[data-cmk-off-tpl]').forEach(function (t) {
      var dedans = t.content ? t.content.querySelector('[data-cmk-off]') : null;
      if (dedans) {
        accordeLeRail(dedans);
        railParHandle[dedans.getAttribute('data-cmk-off-handle')] = dedans.outerHTML;
      }
    });
  }

  /* ── LE BANDEAU NU, ET LA RANGEE QU'ON VA CHERCHER ─────────────────────
     VAGUE 11, BUG 8 DE RAPH : « supprimer un produit, fermer, ajouter un
     autre : j'avais plus rien d'affiche, le bundle n'etait plus affiche ».

     LA CAUSE, MESUREE LE 02/09. `railParHandle` ne connait que ce que Liquid a
     rendu d'avance : le bloc du premier tapis eligible du panier, et celui du
     produit de la page. Un tapis qui entre au panier SANS rechargement (panier
     vide puis un autre tapis, ajout rapide depuis une carte de collection) n'y
     est pas, et l'ancien `poseLaRangee` appelait alors `retireLeBloc` : plus
     de rail, mais plus de BANDEAU non plus, c'est-a-dire plus de promesse.

     LA REPARATION, EN DEUX TEMPS, ET LE PREMIER NE COUTE RIEN.
       1. LE BANDEAU NU, tout de suite. Liquid en rend un exemplaire par page,
          sans tapis donc sans rail (`<template data-cmk-off-nu>`). La promesse
          ne depend d'aucun complement (vague 6, decouplage ; vague 7, « le
          bandeau reste toujours ») : elle revient donc immediatement, sans une
          seule requete.
       2. LA RANGEE, ensuite. Le metachamp `custom.complements` n'est lisible
          que par Liquid, et l'API de rendu de section rend les sections SANS
          leurs reglages (releve du 31/08). Le seul endroit qui porte le bloc
          deja rendu est donc la PAGE PRODUIT elle-meme : on la lit, on en
          extrait `[data-cmk-off]`, on le garde en reserve et on remplace le
          bandeau nu. Une requete par tapis inconnu, jamais bloquante, jamais
          repetee - et si elle echoue, le bandeau nu reste, ce qui est deja
          l'essentiel. */
  var railEnCours = {};

  function blocNu() {
    var t = document.querySelector('[data-cmk-off-nu]');
    var dedans = t && t.content ? t.content.querySelector('[data-cmk-off]') : null;
    return dedans ? dedans.outerHTML : '';
  }

  /* L'ADRESSE D'UN APERCU DE THEME SE TRANSMET, ET C'EST MESURE. Un `fetch`
     vers `/products/<handle>` depuis une page servie en APERCU rend le theme
     PUBLIE, pas celui qu'on regarde : releve du 02/09, la reponse ne portait
     meme pas `[data-cmk-scene]`. Shopify expose le theme courant dans
     `window.Shopify.theme` ; hors apercu son role est `main` et l'adresse ne
     change pas. Sans cela, aucune recette ne pourrait prouver le retour du
     rail, et un apercu mentirait sur ce que le visiteur verra. */
  function adressePreview(chemin) {
    try {
      var t = window.Shopify && window.Shopify.theme;
      if (t && t.id && String(t.role || '').toLowerCase() !== 'main') {
        return chemin + (chemin.indexOf('?') > -1 ? '&' : '?') + 'preview_theme_id=' + t.id;
      }
    } catch (e) {
      /* pas de `Shopify` : on demande la page telle quelle */
    }
    return chemin;
  }

  /* CE QUE CETTE REQUETE COUTE, ET POURQUOI ON LA PAIE QUAND MEME. Une fiche
     produit pese environ 700 Ko : c'est cher, et c'est pour cela qu'elle n'est
     faite QUE dans le cas orphelin (un tapis entre au panier sans rechargement
     et sans reserve), une seule fois par handle, apres que le bandeau est deja
     revenu. Le chemin econome, l'API de rendu de section, a ete re-essaye le
     02/09 sur `?sections=cart-drawer` ET `?sections=main-cart` : les deux
     rendent 14 Ko SANS le bloc d'offre, parce qu'elles rendent les sections
     sans leurs reglages. Le constat de la vague 6 tient toujours. */
  function chercheLaRangee(handle) {
    if (!handle || railEnCours[handle] || railParHandle[handle]) return;
    railEnCours[handle] = true;
    fetch(adressePreview(RACINE + 'products/' + encodeURIComponent(handle)), { headers: { Accept: 'text/html' } })
      .then(function (r) {
        return r.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var bloc =
          doc.querySelector('[data-cmk-off][data-cmk-off-handle="' + handle + '"]') ||
          (function () {
            var t = doc.querySelector('[data-cmk-off-tpl="' + handle + '"]');
            return t && t.content ? t.content.querySelector('[data-cmk-off]') : null;
          })();
        if (!bloc) return;
        railParHandle[handle] = bloc.outerHTML;
        /* Le panier a pu changer entre la requete et sa reponse : `majOffre`
           decide, il ne repose la rangee que si elle est encore celle du
           panier. Le bandeau NU, lui, doit etre remplace meme s'il porte deja
           ce handle : c'est tout l'objet de la requete qu'on vient de faire. */
        if (dernierPanier) majOffre(dernierPanier);
      })
      .catch(function () {
        /* Le bandeau nu reste : mieux vaut la promesse sans les suggestions
           que rien du tout. */
      });
  }

  function poseLaRangee(handle) {
    var hote = hoteOffre();
    if (!hote) return;
    var actuel = $('[data-cmk-off]', hote);
    var pose = actuel ? actuel.getAttribute('data-cmk-off-handle') : null;
    if (railParHandle[handle]) {
      if (pose !== handle || (actuel && actuel.hasAttribute('data-cmk-nu'))) injecteLeBloc(railParHandle[handle], handle);
      return;
    }
    var nu = blocNu();
    if (nu) {
      if (!actuel || pose !== handle) injecteLeBloc(nu, handle, true);
      chercheLaRangee(handle);
      return;
    }
    if (pose !== handle) retireLeBloc();
  }

  /* ── UN TITRE DE RAIL NE VIT JAMAIS SANS SES CARTES ────────────────────
     VAGUE 11, BUG 5b : la capture du collegue de Raph montre « POUR UNE AUTRE
     PIECE » sans une seule carte dessous.

     COTE SERVEUR, C'EST IMPOSSIBLE, et c'est verifie : dans
     `casemira-cart-offre-rangee.liquid`, l'intitule et les cartes sortent du
     MEME `{% if %}`, gouverne par un compteur incremente dans la boucle qui
     ECRIT les cartes. Le titre ne peut donc pas etre rendu seul.

     CE QUI RESTE POSSIBLE EST ICI : un bloc garde en reserve, ou rapporte de
     la page produit, dont le rail aurait perdu ses cartes. Le garde-fou ne
     coute rien et il ferme le cas pour de bon : apres CHAQUE mise en place,
     si le rail ne porte aucune carte, son intitule sort avec lui. Les deux
     apparaissent ensemble ou pas du tout.

     ═══ VAGUE 13 (03/09) : LA MEME REGLE, MAIS IL Y A HUIT RAILS ═══════════

     Le bloc par piece rend une rangee de puces et un rail PAR PIECE, tous dans
     le document, un seul visible. La regle ne change pas de nature, elle se
     decline :

       · un rail de moins de DEUX cartes sort, ET SA PUCE AVEC LUI. Une puce
         qui reste apres son rail est un mensonge d'un tap : le client la
         choisit et ne recoit rien. Le plancher est deux et non trois (celui du
         rail herite) parce que cette rangee vit sous une piece que le client
         vient de DESIGNER : deux tapis de la bonne piece valent mieux qu'une
         piece qui disparait ;
       · s'il ne reste aucun rail, les puces et l'intitule sortent ensemble, et
         le bloc redevient le bandeau seul - exactement l'etat d'une fiche sans
         complement, qui est un etat prevu depuis la vague 6 ;
       · si le rail VISIBLE est celui qui vient d'etre retire, le premier
         survivant prend sa place. Une rangee de puces sans rail visible serait
         un bloc a moitie peint.

     ET C'EST AUSSI ICI QUE LE BRAS A PERD SON RAIL. Voir le § 8 : le bras A
     garde le bandeau et la remise, il ne perd que les suggestions. Comme cette
     fonction est appelee sur CHAQUE bloc mis en place - celui du serveur, ceux
     des reserves, celui rapporte d'une fiche produit - c'est le seul endroit
     ou l'epuration ne peut pas etre oubliee. */
  function retireLesRails(bloc) {
    $$('[data-cmk-off-r], [data-cmk-off-puces], .cmk__off-h', bloc).forEach(function (el) {
      if (el.parentNode) el.parentNode.removeChild(el);
    });
  }

  function railsDe(bloc) {
    return $$('[data-cmk-off-r]', bloc);
  }

  function puceDe(bloc, cle) {
    var puces = $('[data-cmk-off-puces]', bloc);
    if (!puces || !cle) return null;
    return puces.querySelector('[data-cmk-puce="' + cle + '"]');
  }

  function accordeLeRail(bloc) {
    if (!bloc) return;
    if (!brasB()) {
      retireLesRails(bloc);
      return;
    }
    var titre = $('.cmk__off-h', bloc);
    var puces = $('[data-cmk-off-puces]', bloc);
    var rails = railsDe(bloc);

    if (!puces) {
      /* UNE SEULE RANGEE, ET DEUX CAS LA PRENNENT : le rail HERITE
         (`custom.complements`) et, depuis le lot G, la RANGEE PAR PIECE
         (`data-cmk-rail="rangee"`), qui est le rendu par defaut. Les deux ont
         leur plancher de trois cartes deja applique par Liquid, et aucune puce
         a accorder. Ici on ne ferme qu'un cas, celui de la rangee VIDE - celui
         qu'un bloc garde en reserve ou rapporte d'une fiche produit peut
         encore produire. */
      var ul = rails[0];
      var n = ul ? ul.querySelectorAll('.cmk__off-c').length : 0;
      if (n > 0) return;
      if (ul && ul.parentNode) ul.parentNode.removeChild(ul);
      if (titre && titre.parentNode) titre.parentNode.removeChild(titre);
      return;
    }

    var restants = [];
    rails.forEach(function (ul) {
      if (ul.querySelectorAll('.cmk__off-c').length >= 2) {
        restants.push(ul);
        return;
      }
      var p = puceDe(bloc, ul.getAttribute('data-cmk-rail'));
      var li = p ? p.parentNode : null;
      if (li && li.parentNode) li.parentNode.removeChild(li);
      if (ul.parentNode) ul.parentNode.removeChild(ul);
    });

    if (!restants.length) {
      if (puces.parentNode) puces.parentNode.removeChild(puces);
      if (titre && titre.parentNode) titre.parentNode.removeChild(titre);
      return;
    }

    /* La piece que le client a choisie reprend la main sur celle que le serveur
       a rendue, quand ce bloc-ci la propose. */
    var garde = null;
    if (pieceChoisie) {
      restants.forEach(function (ul) {
        if (ul.getAttribute('data-cmk-rail') === pieceChoisie) garde = ul;
      });
    }
    if (garde) {
      montreLaPiece(bloc, pieceChoisie);
      return;
    }
    var visible = null;
    restants.forEach(function (ul) {
      if (!ul.hidden && !visible) visible = ul;
    });
    if (!visible) montreLaPiece(bloc, restants[0].getAttribute('data-cmk-rail'));
  }

  /* ── CHANGER DE PIECE : UN `hidden`, ET RIEN D'AUTRE ───────────────────
     VAGUE 13, ET C'EST LA CONTRAINTE QUE RAPH A POSEE EN PREMIER : « ca doit
     rester fluide ». Les huit rails sont deja dans le document (Liquid les rend
     d'un coup depuis `duo_refs`) : changer de puce ne demande donc AUCUNE
     requete, aucun rendu de section, aucun aller-retour vers `/cart/*` que
     Shopify bride justement. On bascule un attribut, on repose le fondu, et
     c'est tout.

     `hidden` ET NON `display: none` EN STYLE : c'est l'attribut qui porte le
     sens (« ce contenu n'est pas pertinent »), il retire le rail de l'arbre
     d'accessibilite en meme temps que de la peinture, et le CSS du theme le
     respecte deja (`[hidden] { display: none }` du reset). Un style en ligne
     aurait dit la meme chose au navigateur et rien du tout au lecteur d'ecran.

     LES IMAGES DES RAILS CACHES NE SONT PAS TELECHARGEES tant qu'ils sont
     caches : elles sont en `loading="lazy"` dans un ancetre sans boite, donc
     jamais dans le viewport. Le premier affichage d'une piece paie donc ses
     quatre vignettes, une fois, et c'est le seul cout du changement. */
  /* ── LA PIECE CHOISIE SURVIT AU RENDU ──────────────────────────────────
     VAGUE 13. Le bloc d'offre est REMPLACE en entier a chaque mise a jour du
     panier (`injecteLeBloc`) : le HTML qui revient est celui du serveur, donc
     la premiere puce active. Sans memoire, le client qui choisit « Chambre »
     puis ajoute une carte voit la rangee retomber sur « Assorti » au moment
     precis ou il vient de dire ce qu'il cherche.

     LA MEMOIRE EST GLOBALE, PAS PAR TAPIS, et c'est voulu : ce que la puce
     exprime est le besoin du CLIENT (« il me faut un tapis de chambre »), pas
     une propriete du tapis qui est au panier. Elle ne vit que le temps de la
     page - rien n'est ecrit ni dans un biscuit ni dans `sessionStorage`, parce
     qu'une preference d'un seul geste n'a pas a survivre a la visite. */
  var pieceChoisie = '';

  function montreLaPiece(bloc, cle) {
    if (!bloc || !cle) return;
    railsDe(bloc).forEach(function (ul) {
      ul.hidden = ul.getAttribute('data-cmk-rail') !== cle;
    });
    var puces = $('[data-cmk-off-puces]', bloc);
    if (puces) {
      $$('[data-cmk-puce]', puces).forEach(function (b) {
        var on = b.getAttribute('data-cmk-puce') === cle;
        b.classList.toggle('is-on', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
    }
    synchroniseLesFondus();
  }

  /* ── DIRE QUE CA DEFILE ────────────────────────────────────────────────
     VAGUE 13, point 3 de Raph : « il faut un indicateur de glissement ». C'est
     exactement le fondu de 24 px de la collection (`casemira-collection.css`
     § « dire que ca defile », C3 vague 7 point 15) : un MASQUE sur le bord
     droit, pose quand il reste quelque chose a droite, RETIRE des que la rangee
     est au bout. Un signal qui ment est pire que pas de signal.

     LE SEUIL DE 8 px, ET NON 0 : les largeurs de defilement sont
     fractionnaires sur les ecrans a densite non entiere, et
     `scrollWidth - clientWidth` y garde un reste d'un pixel ou deux meme en fin
     de course. C'est le meme seuil que la collection, pour la meme raison.

     L'ECOUTE EST EN CAPTURE SUR LE DOCUMENT parce que `scroll` NE REMONTE PAS :
     un ecouteur pose sur chaque rangee devrait etre repose a chaque injection de
     bloc, et il serait oublie une fois. En capture, le document voit tout, y
     compris les rangees qui n'existaient pas au demarrage.

     ET ON MESURE AUSSI QUAND LES POLICES ARRIVENT. Meme defaut mesure a la
     vague 11 de C3 : une rangee mesuree en police de repli est plus etroite de
     quelques dizaines de pixels, `scrollWidth - clientWidth` vaut zero, et plus
     rien ne la rallume - il n'y a ni defilement ni redimensionnement a
     l'ouverture d'un tiroir. */
  var FONDU_MARGE = 8;
  var fonduPrevu = false;

  /* ★ LOT H (03/09, 11 h 31) : LA GLISSIERE, CELLE DES CHIPS DE COLLECTION
     ──────────────────────────────────────────────────────────────────────
     RAPH : « on ne comprend pas qu'on peut slider ; mets le meme systeme que
     les chips des collections, la barre horizontale stylee, style iOS ». Le
     fondu seul ne suffisait pas : il dit qu'il reste quelque chose, il ne dit
     pas qu'on peut aller le chercher au doigt.

     LA MECANIQUE EST CELLE DE `casemira-collection.js` § « la barre de
     defilement des chips » (C3 vague 9 point 4, corrigee a la vague 11), et
     elle vit dans LA MEME FONCTION que le fondu. C'est le point : les deux
     disent la meme chose de la meme rangee, et deux fonctions separees
     finiraient par se contredire d'une image.

     PISTE 28, CURSEUR 12, COURSE 16, exactement comme la collection. Le
     curseur ne bouge qu'en `transform` : rien ne repasse par la mise en page
     pendant le glissement, ce qui est la condition pour qu'il suive le doigt a
     120 Hz sur iOS.

     ET LA COURSE EST BORNEE (elle l'etait deja pour le fondu, et c'est la meme
     borne qui sert ici) : iOS laisse `scrollLeft` sortir de ses gonds pendant
     l'elastique de fin de course. Sans bornes, le curseur sortirait de sa piste
     puis y reviendrait d'un coup au relachement. La position est gardee au
     dixieme de pixel : sur une course de 16 px, l'arrondi a l'unite se voit
     comme un cliquetis.

     LA GLISSIERE EST LE VOISIN IMMEDIAT DE LA RANGEE, et rien d'autre ne la
     designe : pas d'identifiant a fabriquer, pas de recherche dans le bloc qui
     tomberait sur la glissiere d'une autre rangee. Une rangee sans voisin
     glissiere (les rails caches du rendu par puces) n'en a tout simplement
     pas, et la fonction sort. */
  var SB_PISTE = 28;
  var SB_CURSEUR = 12;

  /* ★ LOT I · LA GLISSIERE SE TROUVE DES DEUX COTES DE L'ENVELOPPE.
     Le lot I enveloppe la rangee dans un `.cmk__off-rw` pour y ancrer les deux
     chevrons (§ « la rangee a la souris »). La glissiere, elle, reste DEHORS :
     elle est centree sous la rangee, pas dans son cadre. Elle n'est donc plus
     toujours le voisin immediat de la rangee - elle est le voisin de son
     ENVELOPPE. On regarde les deux, dans cet ordre : cela laisse le rendu qui
     n'envelopperait pas continuer a marcher sans qu'un drapeau soit a poser
     quelque part. */
  function glissiereDe(el) {
    var v = el.nextElementSibling;
    if (v && typeof v.matches === 'function' && v.matches('[data-cmk-off-sb]')) return v;
    var p = el.parentNode;
    if (!p || typeof p.matches !== 'function' || !p.matches('.cmk__off-rw')) return null;
    v = p.nextElementSibling;
    return v && typeof v.matches === 'function' && v.matches('[data-cmk-off-sb]') ? v : null;
  }

  /* ★ LOT I · LES DEUX CHEVRONS SONT DANS L'ENVELOPPE, AVEC LA RANGEE. */
  function flechesDe(el) {
    var p = el.parentNode;
    if (!p || typeof p.querySelectorAll !== 'function') return [];
    return $$('[data-cmk-off-nav]', p);
  }

  function synchroniseUnFondu(el) {
    if (!el) return;
    var course = el.scrollWidth - el.clientWidth;
    var pos = Math.min(Math.max(el.scrollLeft, 0), Math.max(course, 0));
    el.classList.toggle('is-fade', course - pos > FONDU_MARGE);

    /* ★ LOT I · LES CHEVRONS SONT CALCULES ICI, ET NULLE PART AILLEURS.
       Le fondu, la glissiere et les deux chevrons disent la meme chose de la
       meme rangee : « il reste ceci a droite, cela a gauche ». Trois calculs
       separes finiraient par se contredire d'une image - c'est deja la raison
       pour laquelle le lot H a mis la glissiere DANS cette fonction. Meme seuil
       de 8 px, pour la meme raison (les largeurs de defilement sont
       fractionnaires sur un ecran a densite non entiere).

       LE CURSEUR `grab` SUIT LE MEME JUGEMENT : une main ouverte sur une rangee
       qui ne glisse pas serait une invitation a un geste sans effet. */
    var glissable = course > FONDU_MARGE;
    el.classList.toggle('is-glissable', glissable);
    flechesDe(el).forEach(function (b) {
      var vers = parseInt(b.getAttribute('data-cmk-off-nav'), 10) || 1;
      var bout = vers < 0 ? pos <= FONDU_MARGE : course - pos <= FONDU_MARGE;
      var inerte = !glissable || bout;
      /* ★ LOT K · `is-off` NE DIT PLUS « ATTENUE » MAIS « EFFACE », et la
         bascule ne change pas d'une virgule pour autant : c'est la feuille de
         style qui a change de reponse, pas le calcul. « Revenir ensuite »
         (Raph, 19 h 55) est le simple retrait de cette classe au premier
         defilement, d'ou qu'il vienne. */
      b.classList.toggle('is-off', inerte);
      /* ★ LOT J · CE QUE LA COULEUR DIT A L'OEIL, L'ATTRIBUT LE DIT A LA VOIX.
         `aria-disabled` et NON `disabled` : un bouton desactive au sens HTML
         ne recoit plus aucun evenement de pointeur, et le clic de bout de
         course retomberait sur la carte qu'il couvre - le defaut meme que le
         lot J corrige (`VAGUE-13.md` § lot J, bug 1). Le bouton reste donc un
         bouton ; c'est l'ecouteur ci-dessous qui refuse d'agir. */
      b.setAttribute('aria-disabled', inerte ? 'true' : 'false');
    });

    var sb = glissiereDe(el);
    if (!sb) return;
    /* MEME VERITE QUE LE FONDU, ET LA SEULE CONDITION QUI RESTE : pas de
       debordement, pas de glissiere ; debordement, glissiere allumee, sans
       limite de temps et sans etat a retenir. C'est le bon sens d'un curseur de
       defilement - il dit une position, et une position reste vraie tant que la
       rangee defile - et c'est ce que fait celui d'iOS. */
    var deborde = course > FONDU_MARGE;
    sb.classList.toggle('is-on', deborde);
    if (!deborde) return;
    var x = Math.round((pos / course) * (SB_PISTE - SB_CURSEUR) * 10) / 10;
    sb.style.setProperty('--cmk-sb-x', x + 'px');
  }

  function synchroniseLesFondus() {
    fonduPrevu = false;
    if (!scene) return;
    $$('[data-cmk-off-puces]', scene).forEach(synchroniseUnFondu);
    $$('[data-cmk-off-r]', scene).forEach(function (ul) {
      if (ul.hidden) return;
      synchroniseUnFondu(ul);
    });
  }

  function prevoisLesFondus() {
    if (fonduPrevu) return;
    fonduPrevu = true;
    requestAnimationFrame(synchroniseLesFondus);
  }

  document.addEventListener(
    'scroll',
    function (event) {
      var t = event.target;
      if (!t || t === document || typeof t.matches !== 'function') return;
      if (t.matches('[data-cmk-off-puces], [data-cmk-off-r]')) prevoisLesFondus();
    },
    true
  );

  window.addEventListener('resize', prevoisLesFondus);

  /* ══════════════════════════════════════════════════════════════════════
     LA RANGEE A LA SOURIS                            C4, vague 13, lot I
     ----------------------------------------------------------------------
     RAPH, 03/09 A 16 h, ORDINATEUR : « il y a l'indicateur, mais on ne peut
     pas glisser facilement ; il faut un truc discret et beau, pas une grande
     bande blanche ».

     CE QUE LA SONDE A MESURE (`v13i-mesure.log`, 1440 x 900, tiroir de 480 px)
     : 7 cartes, 748 px de contenu dans 455 px de colonne, 293 px de course,
     fondu allume, glissiere allumee - et une molette horizontale (`deltaX` de
     120 sur la rangee) qui laisse `scrollLeft` a ZERO. Deux signaux disaient
     « il y a une suite », aucun geste ne permettait d'y aller.

     DEUX GESTES SONT AJOUTES ICI, LE TROISIEME EST DANS LA FEUILLE DE STYLE :
       · le GLISSER-DEPOSER a la souris, sur la rangee elle-meme. C'est le
         geste que la main cherche quand elle voit une rangee qui deborde ;
       · le PAS D'UNE CARTE par clic de chevron. Une carte plus sa gouttiere,
         mesurees dans le DOM et jamais ecrites en dur : la carte fait 96 px
         sous 1000 et 100 au-dessus, et la gouttiere est celle de la rangee.

     RIEN DE TOUT CELA NE VIT AU DOIGT, ET C'EST EXPLICITE. `pointerType` doit
     valoir `mouse` : au doigt, le defilement natif est meilleur que tout ce
     qu'on ecrirait, et intercepter `pointermove` lui volerait son inertie et
     son rebond de fin de course. Les chevrons, eux, ne sont meme pas rendus
     (`@media (hover: hover) and (pointer: fine)`).

     LE GLISSEMENT DEBRAYE `scroll-behavior: smooth`. La feuille de style le
     pose pour que le pas d'un chevron se lise comme un mouvement ; laisse tel
     quel, il ferait trainer la rangee derriere la souris de deux ou trois
     images. La propriete passe donc a `auto` EN LIGNE le temps du geste, et
     elle est retiree au relachement - jamais reecrite, pour que la valeur de
     la feuille (et sa version `prefers-reduced-motion`) reste la seule verite.

     ET LE CLIC QUI SUIT UN GLISSEMENT EST AVALE. Sans cela, un glissement qui
     finit sur un bouton « + » ajouterait un tapis au panier : c'est le meme
     defaut, et la meme reponse, que le drapeau `bouge` du geste de la feuille.
     L'ecouteur est en CAPTURE pour passer avant celui du « + ».
     ══════════════════════════════════════════════════════════════════════ */
  var GRAB_SLOP = 4; /* px : en deca, c'est un clic, pas un glissement */
  var railPris = null;

  function railSousLeCurseur(cible) {
    if (!cible || typeof cible.closest !== 'function') return null;
    var r = cible.closest('[data-cmk-off-r]');
    if (!r || r.hidden) return null;
    return r.scrollWidth - r.clientWidth > FONDU_MARGE ? r : null;
  }

  document.addEventListener(
    'pointerdown',
    function (event) {
      if (event.pointerType !== 'mouse' || event.button !== 0) return;
      var r = railSousLeCurseur(event.target);
      if (!r) return;
      railPris = { el: r, x: event.clientX, depart: r.scrollLeft, bouge: false };
      /* LE GLISSEMENT NATIF D'UNE IMAGE MANGEAIT LE GESTE, ET C'EST UN DEFAUT
         TROUVE EN RECETTE (premiere passe du lot I : la rangee n'avancait que
         de 15 px sur 120 demandes). La carte porte une PHOTO dans un LIEN :
         appuyer dessus et deplacer la souris demarre le glisser-deposer natif
         du navigateur, qui envoie aussitot un `pointercancel` et rend la main.
         `preventDefault` sur l'appui l'empeche de naitre ; il n'empeche ni le
         `click` (le « + » d'une carte marche toujours) ni le focus au clavier,
         qui ne passe pas par le pointeur. La ceinture est l'ecouteur de
         `dragstart` juste en dessous, pour les moteurs qui demarrent le
         glissement sans consulter l'appui. */
      if (event.cancelable) event.preventDefault();
    },
    true
  );

  document.addEventListener(
    'dragstart',
    function (event) {
      if (railPris && event.cancelable) event.preventDefault();
    },
    true
  );

  document.addEventListener('pointermove', function (event) {
    if (!railPris) return;
    var dx = event.clientX - railPris.x;
    if (!railPris.bouge) {
      if (Math.abs(dx) < GRAB_SLOP) return;
      railPris.bouge = true;
      railPris.el.classList.add('is-grab');
      railPris.el.style.scrollBehavior = 'auto';
    }
    railPris.el.scrollLeft = railPris.depart - dx;
    if (event.cancelable) event.preventDefault();
  });

  function lacheLaRangee() {
    if (!railPris) return;
    var pris = railPris;
    pris.el.classList.remove('is-grab');
    pris.el.style.removeProperty('scroll-behavior');
    /* LE DRAPEAU SURVIT AU RELACHEMENT LE TEMPS D'UN CLIC : `pointerup` precede
       `click`, et c'est ce clic-la qu'il faut avaler. */
    railPris = null;
    if (!pris.bouge) return;
    railAvale = true;
    setTimeout(function () {
      railAvale = false;
    }, 0);
  }

  var railAvale = false;

  document.addEventListener('pointerup', lacheLaRangee);
  document.addEventListener('pointercancel', lacheLaRangee);

  document.addEventListener(
    'click',
    function (event) {
      if (!railAvale) return;
      event.preventDefault();
      event.stopPropagation();
    },
    true
  );

  /* LE PAS D'UN CHEVRON : une carte plus une gouttiere, lues dans le DOM. */
  function pasDeLaRangee(r) {
    var carte = r.querySelector('.cmk__off-c');
    if (!carte) return Math.round(r.clientWidth / 2);
    var g = parseFloat(getComputedStyle(r).columnGap || getComputedStyle(r).gap || '0') || 0;
    return Math.round(carte.getBoundingClientRect().width + g);
  }

  document.addEventListener('click', function (event) {
    var t = event.target;
    if (!t || typeof t.closest !== 'function') return;
    var nav = t.closest('[data-cmk-off-nav]');
    if (!nav) return;
    /* LE CLIC EST AVALE AVANT TOUTE CHOSE, MEME QUAND LE CHEVRON EST INERTE.
       C'est la moitie du correctif du lot J : la feuille garde le rond en
       place et testable au pointeur, l'ecouteur garde le clic pour lui. Sans
       `stopPropagation`, un clic sur un chevron pose SUR une carte remonterait
       aux ecouteurs delegues de la rangee. */
    event.preventDefault();
    event.stopPropagation();
    /* ★ LOT J · UN CHEVRON EN BOUT DE COURSE NE FAIT RIEN, ET C'EST TOUT CE
       QU'IL FAIT. Raph, 03/09 a 18 h 31 : « il ne doit rien se passer ». Le
       defilement etait deja borne par le navigateur, mais l'intention doit
       etre ECRITE : demain, un pas anime ou une mesure posee ici partirait
       sans raison.

       ★ LOT K · CETTE LIGNE NE SERT PLUS QUE PENDANT LE FONDU DE SORTIE, et
       elle sert exactement a cela. Le chevron en bout de course s'efface
       maintenant en `--dur-2` ; pendant ces images il est encore peint, donc
       encore une cible, et c'est ici que son clic meurt. Apres, il n'est plus
       testable au pointeur et l'ecouteur n'est plus appele du tout. */
    if (nav.classList.contains('is-off') || nav.getAttribute('aria-disabled') === 'true') return;
    var enveloppe = nav.parentNode;
    var r = enveloppe ? $('[data-cmk-off-r]', enveloppe) : null;
    if (!r) return;
    var vers = parseInt(nav.getAttribute('data-cmk-off-nav'), 10) || 1;
    r.scrollLeft += vers * pasDeLaRangee(r);
    prevoisLesFondus();
  });

  try {
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(prevoisLesFondus);
  } catch (e) {
    /* pas d'API de polices : la premiere mesure et le premier defilement
       suffisent */
  }

  /* Le tap sur une puce. Meme forme que le « + » du rail : un seul ecouteur
     delegue sur le document, borne a la scene du panier, parce que le bloc
     d'offre est remplace en entier a chaque changement de premier tapis. */
  document.addEventListener('click', function (event) {
    var t = event.target;
    if (!t || typeof t.closest !== 'function') return;
    if (!scene || !scene.contains(t)) return;
    var puce = t.closest('[data-cmk-puce]');
    if (!puce) return;
    event.preventDefault();
    var bloc = puce.closest('[data-cmk-off]');
    if (!bloc) return;
    pieceChoisie = puce.getAttribute('data-cmk-puce') || '';
    montreLaPiece(bloc, pieceChoisie);
    /* PAS D'EVENEMENT DE MESURE ICI, ET C'EST DOCUMENTE. Le contrat du
       collecteur (`casemira-dashboard/docs/mesure-c4-panier.md` § 2,
       `web/src/lib/events/contrat.ts`) n'accepte que six noms d'evenement, et
       tout ce qui n'y figure pas est JETE a la reception. Un `rail_piece`
       envoye aujourd'hui partirait donc a la poubelle en faisant croire a une
       mesure. Il se posera en une ligne le jour ou le contrat l'accueillera. */
  });

  /* ── LES PRIX DU RAIL, VAGUE 11 (point 4 de Raph) ──────────────────────
     « Afficher le prix barre avec le montant que ca ferait avec les 20 %. »
     L'economie affichee est l'economie SUPPLEMENTAIRE que l'ajout de la carte
     declenche, pas 20 % de son prix : voir la demonstration dans la note du
     snippet. Elle se reduit a 20 % x min(P, pivot), et vaut zero quand le
     panier porte un nombre PAIR d'unites eligibles.

     AUCUN TEXTE N'EST FABRIQUE ICI : les montants passent par `eur()`, qui
     suit le format d'argent de la BOUTIQUE, et rien d'autre n'est ecrit.

     VAGUE 12 : LA MENTION « avec l'offre » A DISPARU DES CARTES, ET IL FALLAIT
     LE DIRE ICI AUSSI. Cette fonction reecrit le prix de CHAQUE carte a chaque
     rendu du tiroir : si elle avait garde son `mention.hidden = false`, elle
     aurait rallume, a la premiere mise a jour du panier, une mention que le
     Liquid ne pose plus. Elle ne la cherche donc plus du tout. Le prix barre,
     lui, reste montre ou cache exactement comme avant : c'est desormais LUI,
     seul, qui dit que l'offre joue sur cette carte. */
  function majPrixRail(etat) {
    var hote = hoteOffre();
    var bloc = hote ? $('[data-cmk-off]', hote) : null;
    if (!bloc) return;
    var pct = (OFFRE && OFFRE.pct ? OFFRE.pct : 20) / 100;
    $$('.cmk__off-p', bloc).forEach(function (el) {
      var prix = parseInt(el.getAttribute('data-cmk-off-prix'), 10);
      if (!prix && prix !== 0) return;
      var barre = $('[data-cmk-off-barre]', el);
      var fort = $('[data-cmk-off-fort]', el);
      var eco = etat.pivot > 0 ? Math.round(Math.min(prix, etat.pivot) * pct) : 0;
      if (eco > 0) {
        if (barre) {
          barre.textContent = eur(prix);
          barre.hidden = false;
        }
        if (fort) fort.textContent = eur(prix - eco);
      } else {
        if (barre) {
          barre.textContent = '';
          barre.hidden = true;
        }
        if (fort) fort.textContent = eur(prix);
      }
    });
  }

  /* ── LA LIGNE FORTE DU BANDEAU, VAGUE 11 (point 3 de Raph) ─────────────
     « Comment ca se passe si quelqu'un prend 3 produits ? T'as pas plus de
     remise ? » Depuis que la remise est illimitee, le nombre de tapis remises
     depend du panier : la phrase le DIT, avec le montant, et jamais « 1 tapis
     sur 2 ».

     LE MONTANT DU SERVEUR L'EMPORTE des qu'il existe (`discount_allocations`
     du panier Ajax) ; le calcul local ne tient que le temps que le code soit
     pose et `/cart.js` relu. Les deux gabarits sont traduits par Liquid et
     poses en attribut : le script ne remplace que `%pct%`, `%n%` et
     `%montant%`. */
  /* ── LE BANDEAU NE PROMET RIEN QUE SHOPIFY N'APPLIQUE PAS ─────────────
     VAGUE 13, LOT G (03/09). Raph : « avec BIENVENUE10 et un 2e tapis, ca
     n'affiche le -20 % que dans l'encadre, pas dans le resume des remises, on
     voit toujours que BIENVENUE10 ».

     CE QUI SE PASSE VRAIMENT. BIENVENUE10 est encore une remise PRODUIT ; hors
     Shopify Plus, les articles d'un « achetez X obtenez Y » sont ineligibles a
     une autre remise produit. Shopify garde donc UN des deux codes et laisse
     l'autre au panier avec `applicable: false`. Le code duo y est, il ne donne
     rien, et le bandeau disait pourtant « applique automatiquement ».

     LA REGLE, ET ELLE NE NOMME AUCUN CODE. On ne parle d'application que si la
     remise duo est REELLEMENT allouee (`etat.remiseSrv`, lu dans les
     `line_level_discount_allocations` filtrees sur le code duo). Sinon, et
     qu'un autre code EST AU PANIER ET S'APPLIQUE, on nomme ce code et on dit
     qu'ils ne se cumulent pas.

     `applicable !== false` EST LA CONDITION, ET ELLE COMPTE. Un code refuse
     n'explique rien : c'est celui qui GAGNE qu'il faut nommer, parce que c'est
     celui que le client lit dans le resume des remises. La liste
     `cart.discount_codes` du panier Ajax porte les deux, avec leur drapeau ;
     Liquid, lui, ne voit que ceux qui s'appliquent, et les deux jugements
     tombent donc au meme endroit.

     LE JOUR J, RIEN A DEFAIRE. Quand BIENVENUE10 deviendra une remise de
     COMMANDE (`c4-lancement-test.mjs`), les deux se cumuleront, `remiseSrv`
     sera positif, et cette fonction rendra toujours la chaine vide. */
  function nonCumulDe(cart, etat) {
    if (!cart || etat.remiseSrv > 0) return '';
    /* HOTFIX 03/09 22h40 (site publie) : avec UN seul tapis, la remise duo
       n'est pas allouee parce que le seuil n'est pas atteint, pas a cause du
       code du client. Le message « ne se cumule pas » ne vaut qu'a partir de
       deux tapis eligibles. */
    if (!etat || typeof etat.n !== 'number' || etat.n < 2) return '';
    var duo = codeDuo();
    var l = cart.discount_codes || [];
    for (var i = 0; i < l.length; i++) {
      var c = String((l[i] && l[i].code) || '').trim();
      if (!c) continue;
      if (duo && c.toUpperCase() === duo) continue;
      if (l[i].applicable === false) continue;
      return c;
    }
    return '';
  }

  /* La ligne seconde du bandeau. Deux etats, et le retour en arriere est aussi
     important que l'aller : un client qui RETIRE son code doit revoir
     « applique automatiquement » sans recharger la page. Le sous-titre par
     defaut voyage donc en attribut, comme le gabarit de la phrase. */
  function majSousTitre(nc) {
    var hote = hoteOffre();
    var bloc = hote ? $('[data-cmk-off]', hote) : null;
    var s = bloc ? $('[data-cmk-off-s]', bloc) : null;
    if (!s) return;
    var a2 = $('[data-cmk-off-a2]', s);
    if (!a2) return;
    var v = $('[data-cmk-off-v]', s);
    var sep = $('[data-cmk-off-sep]', s);
    if (nc) {
      var tpl = s.getAttribute('data-cmk-off-nc') || '';
      if (!tpl) return;
      /* ★ LOT K · le jeton est remplace D'ABORD, l'exposant est compose
         ENSUITE : c'est la phrase entiere, code compris, qui est echappee. */
      poseExposant(a2, tpl.replace('%code%', nc));
      a2.classList.add('cmk__off-nc');
      if (v) v.hidden = true;
      if (sep) sep.hidden = true;
      return;
    }
    poseExposant(a2, a2.getAttribute('data-cmk-off-a2') || '');
    a2.classList.remove('cmk__off-nc');
    if (v) v.hidden = false;
    if (sep) sep.hidden = false;
  }

  function majTete(etat, acquise) {
    var hote = hoteOffre();
    var bloc = hote ? $('[data-cmk-off]', hote) : null;
    var tete = bloc ? $('[data-cmk-off-tete]', bloc) : null;
    if (!tete) return;
    var pct = tete.getAttribute('data-cmk-off-pct') || '20';
    /* ★ LOT K · LE TITRE ET LES DEUX GABARITS SONT DU TEXTE, ET ILS LE
       RESTENT : `poseExposant` les echappe avant d'y composer le seul
       `<sup>` de la ligne (§ `exposant`, en tete de fichier). */
    if (!acquise) {
      poseExposant(tete, tete.getAttribute('data-cmk-off-titre') || '');
      return;
    }
    var k = etat.remiseSrv > 0 ? etat.kSrv : etat.k;
    var montant = etat.remiseSrv > 0 ? etat.remiseSrv : etat.remise;
    if (k < 1 || montant <= 0) {
      poseExposant(tete, tete.getAttribute('data-cmk-off-titre') || '');
      return;
    }
    var tpl = tete.getAttribute(k >= 2 ? 'data-cmk-off-tn' : 'data-cmk-off-t1') || '';
    poseExposant(
      tete,
      tpl
        .replace('%pct%', pct)
        .replace('%n%', k)
        .replace('%montant%', '-' + eur(montant))
    );
  }

  /* ── LA PROGRESSION, VAGUE 7 : IL N'EN RESTE QU'UNE ─────────────────────
     « 1 tapis sur 2 » EST SUPPRIMEE (decision de Raph du 01/09). Elle disait
     a voix haute ce que le panier montre deja : a deux tapis, le prix barre
     de la ligne et la remise « Remise duo » au-dessus du total suffisent, et
     ils sont, eux, des CHIFFRES. Une jauge de comptage sous un bandeau
     d'offre est le vocabulaire d'un programme de fidelite, pas celui d'un
     panier de deux tapis.

     LA MECANIQUE `montant` GARDE LA SIENNE, et ce n'est pas une exception :
     une distance en euros vers un seuil ne se lit NULLE PART ailleurs dans le
     panier, alors qu'un compte d'articles se lit dans la liste elle-meme.

     AUCUNE PHRASE DANS LE SCRIPT : Liquid a traduit le gabarit et l'a pose en
     attribut (`data-cmk-prog-tpl`) ; le script ne fait que remplacer `%montant%`
     par un montant passe au format d'argent de la BOUTIQUE, jamais par un
     « € » ecrit ici. */
  function majProgression(cart) {
    if (!scene) return;
    var el = $('[data-cmk-prog]', scene);
    if (!el) return;
    if (el.getAttribute('data-cmk-prog') !== 'montant') return;
    var tpl = el.getAttribute('data-cmk-prog-tpl') || '';
    var texte = $('[data-cmk-prog-t]', el);
    var seuilM = parseInt(el.getAttribute('data-cmk-prog-seuil'), 10) || 0;
    /* Casemira 28/10/2026 (offre de novembre) : la distance se mesure sur le
       sous-total des articles hors cartes cadeaux (`baseHorsCartes`), plus sur
       `total_price`, circulaire avec une remise de commande. */
    var total = baseHorsCartes(cart);
    var reste = Math.max(0, seuilM - total);
    var barre = $('[data-cmk-prog-j] i', el);
    if (barre) barre.style.width = (seuilM > 0 ? Math.min(100, Math.round((total * 100) / seuilM)) : 0) + '%';
    if (texte) texte.textContent = tpl.replace('%montant%', eur(reste));
  }

  /* ══════════════════════════════════════════════════════════════════════
     § 7 bis. LES PALIERS DE NOVEMBRE        Casemira 28/10/2026 (offre de novembre)
     ----------------------------------------------------------------------
     Lot 4 du thème de novembre. Mécanique `paliers` : quatre seuils, quatre
     montants offerts, remise AUTOMATIQUE créée dans Shopify (aucun code
     posé ici : `poseLeCode` ne part que pour `article_n`, c'est ce qui coupe
     DUO20).

     CE QUE CE SCRIPT LIT, ET RIEN D'AUTRE.
       · `window.CM_OFFRE` (lot 1, `assets/casemira-offre.js`) : la période du
         jour à l'heure de Paris, les seuils en euros (`seuils`) et convertis
         au taux Shopify (`seuilsDevise`), les montants de la période, le
         format monétaire sans décimales nulles. Jamais un réglage de section.
       · LA BASE : `items_subtotal_price` (avant remises de commande, après
         remises de ligne) MOINS les cartes cadeaux (`baseHorsCartes`). Le
         piège de `total_price`, circulaire dès qu'une remise de commande
         s'applique, est l'inventaire technique § 4.3.
       · HORS EURO : seuils convertis, montants jamais écrits (ni sur les
         crans, ni dans l'acquis, ni dans la phrase de la rangée). La ligne
         de remise du pied, elle, écrit le montant que Shopify a réellement
         alloué, dans la devise du panier.

     AUCUNE PHRASE ICI. Les gabarits traduits voyagent en attribut
     (`data-cmk-g-*`, jetons `%nom%`), posés par `casemira-cart-jauge.liquid`,
     la rangée et le pied.

     LE CALCUL EST CELUI DE LIQUID, À L'IDENTIQUE : crans réguliers à 12,5 %,
     37,5 %, 62,5 % et 87,5 % de la piste, remplissage linéaire entre deux
     crans, puis jusqu'à 100 % sur un écart égal au dernier intervalle.

     L'ANIMATION D'OUVERTURE (maquette du 28/10) : 200 ms d'attente, puis le
     remplissage de zéro au niveau du panier en 900 ms, courbe
     cubic-bezier(.2, .7, .2, 1) ; chaque cran s'allume quand le remplissage
     le passe (`--t`, calculé sur la même courbe). Rejouée à CHAQUE ouverture
     du tiroir, jamais à une mise à jour de quantité (transition de 300 ms).
     Sur /cart, une fois, au premier panier lu. Mouvement réduit : état final
     direct (feuille de style).

     DEUX ÉVÉNEMENTS, par le collecteur du § 8 (`mesure`, qui pose aussi le
     tag Clarity) ET en `CustomEvent` « cm-panier-jauge » sur `document` :
       jauge_affichee   à l'ouverture (et au premier rendu de /cart), avec le
                        palier atteint, la base et la période ;
       palier_franchi   quand un panier lu du serveur passe un cran de plus.
     ══════════════════════════════════════════════════════════════════════ */
  var POS_CRANS = [12.5, 37.5, 62.5, 87.5];
  var J_ATTENTE = 200;
  var J_DUREE = 900;
  var dernierEtatPaliers = null;
  var dernierAtteint = null;
  var pageJaugeJouee = false;
  var jaugeMinuteur = null;
  var jaugePhase = 'a';
  var jaugeJoueePour = -1;

  function ligneFinale(it) {
    return typeof it.final_line_price === 'number' ? it.final_line_price : it.line_price || 0;
  }

  /* La base des paliers. `items_subtotal_price` quand le panier le porte (tous
     les paniers de `/cart.js` et des points `/cart/*.js`) ; sinon la somme des
     lignes, qui est exactement sa définition (un panier partiel publié par un
     autre script, le panier fictif du § 5). */
  function sousTotalArticles(cart) {
    if (cart && typeof cart.items_subtotal_price === 'number') return cart.items_subtotal_price;
    var t = 0;
    ((cart && cart.items) || []).forEach(function (it) {
      t += ligneFinale(it);
    });
    return t;
  }

  function baseHorsCartes(cart) {
    if (!cart) return 0;
    var items = cart.items || [];
    var t = 0;
    if (typeof cart.items_subtotal_price === 'number') {
      t = cart.items_subtotal_price;
      items.forEach(function (it) {
        if (it.gift_card) t -= ligneFinale(it);
      });
    } else {
      items.forEach(function (it) {
        if (!it.gift_card) t += ligneFinale(it);
      });
    }
    return Math.max(0, t);
  }

  function offrePaliers() {
    return OFFRE && OFFRE.meca === 'paliers' ? window.CM_OFFRE || null : null;
  }

  /* Montant court (« 20 € », « 12,50 € ») : le format du lot 1 quand il est
     là, sinon la variante sans centimes de ce fichier. */
  function prixCourt(c) {
    var O = window.CM_OFFRE;
    var t = O && typeof O.format === 'function' ? O.format(c) : klarnaMoney(c);
    /* Lot R3-D : hors euro, le format de la boutique rend « 2 251,00 kr » ;
       les décimales nulles tombent (« dès 2 251 kr »), comme en euro. */
    return String(t).replace(/([.,])00(?![0-9])/, '');
  }

  /* Remplace les jetons `%nom%` d'un gabarit traduit. */
  function jetons(tpl, valeurs) {
    var s = String(tpl || '');
    Object.keys(valeurs).forEach(function (k) {
      s = s.split('%' + k + '%').join(String(valeurs[k] == null ? '' : valeurs[k]));
    });
    return s;
  }

  /* Le même, en HTML : le texte traduit est échappé D'ABORD, les montants
     entrent ensuite, en gras pour ceux que la maquette met en gras. */
  function jetonsHTML(tpl, valeurs, forts) {
    var s = esc(tpl || '');
    Object.keys(valeurs).forEach(function (k) {
      var v = esc(valeurs[k] == null ? '' : valeurs[k]);
      if (forts && forts[k]) v = '<strong>' + v + '</strong>';
      s = s.split('%' + k + '%').join(v);
    });
    return s;
  }

  function ecrit(el, texte) {
    if (el && el.textContent !== texte) el.textContent = texte;
  }

  function avancePaliers(base, s) {
    if (!s || s.length !== 4 || !(s[0] > 0)) return 0;
    if (base <= 0) return 0;
    if (base < s[0]) return (POS_CRANS[0] * base) / s[0];
    for (var i = 0; i < 3; i++) {
      if (base < s[i + 1]) return POS_CRANS[i] + (25 * (base - s[i])) / (s[i + 1] - s[i]);
    }
    var ecart = s[3] - s[2];
    var plus = ecart > 0 ? Math.min(1, (base - s[3]) / ecart) : 1;
    return POS_CRANS[3] + 12.5 * plus;
  }

  function etatPaliers(cart) {
    var O = offrePaliers();
    if (!O || !cart) return null;
    var seuils = (O.horsEuro ? O.seuilsDevise : O.seuils) || [];
    var base = baseHorsCartes(cart);
    var n = 0;
    (cart.items || []).forEach(function (it) {
      if (!it.gift_card) n += it.quantity || 0;
    });
    var at = 0;
    for (var i = 0; i < seuils.length; i++) if (base >= seuils[i]) at = i + 1;
    return {
      actif: O.actif !== false,
      periode: O.periode,
      base: base,
      n: n,
      at: at,
      seuils: seuils,
      montants: O.montants || [],
      /* 31/10 : hors euro, les équivalences arrondies de casemira-offre.js
         (seuils au pas supérieur, montants « ≈ ») s'écrivent ; la comparaison
         reste sur les seuils exacts convertis. */
      seuilsAff: O.seuilsAff || seuils,
      montantsAff: O.montantsAff || O.montants || [],
      approx: !!O.equivalence,
      aff: O.montantsAffichables !== false && (!O.horsEuro || !!O.equivalence),
      reste: at < seuils.length ? seuils[at] - base : 0,
      avance: avancePaliers(base, seuils),
      limite: Math.round(10000 * (O.horsEuro ? O.taux || 1 : 1)),
    };
  }

  /* Le temps (0 à 1) où la courbe cubic-bezier(.2, .7, .2, 1) atteint la
     progression `y` : bissection sur le paramètre, puis abscisse. */
  function tempsBezier(y) {
    function b(p1, p2, s) {
      return 3 * (1 - s) * (1 - s) * s * p1 + 3 * (1 - s) * s * s * p2 + s * s * s;
    }
    var lo = 0;
    var hi = 1;
    for (var k = 0; k < 24; k++) {
      var m = (lo + hi) / 2;
      if (b(0.7, 1, m) < y) lo = m;
      else hi = m;
    }
    return b(0.2, 0.2, (lo + hi) / 2);
  }

  function signalJauge(nom, extra) {
    mesure(nom, extra);
    try {
      document.dispatchEvent(new CustomEvent('cm-panier-jauge', { detail: { evenement: nom, extra: extra } }));
    } catch (e) {
      /* vieux navigateur : le collecteur suffit */
    }
  }

  /* Un seuil tel qu'on l'ÉCRIT. En euro, le seuil exact. Hors euro, le seuil
     converti au taux du jour arrondi à l'unité SUPÉRIEURE (« dès 2 289 kr »,
     pas « dès 2 288,50 kr ») : l'arrondi ne promet jamais moins que ce que
     Shopify demandera. La comparaison, elle, se fait sur la valeur exacte. */
  function seuilEcrit(e, i) {
    if (e.approx) return (e.seuilsAff || e.seuils)[i] || 0;
    var v = e.seuils[i] || 0;
    return e.aff ? v : Math.ceil(v / 100) * 100;
  }
  /* Un montant tel qu'on l'ÉCRIT (hors euro : l'équivalence au chiffre rond,
     règle de casemira-offre.js, sans « ≈ », décisions Raphaël 31/10). */
  function montantEcrit(e, c) {
    return prixCourt(c).replace(/ /g, '\u00a0');
  }

  function majJauge(e) {
    if (!scene) return;
    var jauges = $$('[data-cmk-jauge]', scene);
    var acquis = $$('[data-cmk-acquis]', scene);
    var montre = !!(e && e.actif && e.n > 0);
    scene.classList.toggle('cmk--paliers', !!(e && e.actif) && jauges.length > 0);
    jauges.forEach(function (j) {
      j.hidden = !montre;
      if (!e) return;
      j.style.setProperty('--avance', e.avance.toFixed(2) + '%');
      j.setAttribute('data-cmk-jauge-atteint', e.at);
      if (e.aff) j.removeAttribute('data-cmk-jauge-devise');
      else j.setAttribute('data-cmk-jauge-devise', '');
      $$('[data-cmk-cran]', j).forEach(function (c) {
        c.classList.toggle('est-acquis', parseInt(c.getAttribute('data-cmk-cran'), 10) <= e.at);
      });
      var gDes = j.getAttribute('data-cmk-g-des') || '';
      $$('[data-cmk-palier]', j).forEach(function (li) {
        var i = parseInt(li.getAttribute('data-cmk-palier'), 10) - 1;
        li.classList.toggle('est-acquis', i < e.at);
        var m = $('[data-cmk-palier-m]', li);
        if (m) {
          m.hidden = !e.aff;
          /* Lot R3-D : « −40 € », signe moins typographique, insécable. */
          ecrit(m, e.aff && (e.montantsAff || e.montants)[i] ? MOINS + montantEcrit(e, (e.montantsAff || e.montants)[i]) : '');
        }
        var s = $('[data-cmk-palier-s]', li);
        if (s && gDes && e.seuils[i]) ecrit(s, jetons(gDes, { seuil: prixCourt(seuilEcrit(e, i)) }));
      });
      /* Lot R3-D : la jauge est un bouton (« Comment fonctionne l'offre ») ;
         l'état du panier est sa description, dans un texte caché. */
      var piste = $('[data-cmk-jauge-etat]', j);
      if (piste) {
        var total = prixCourt(e.base);
        var label;
        if (e.at === 0) label = jetons(j.getAttribute('data-cmk-g-aria-premier'), { total: total, suivant_seuil: prixCourt(seuilEcrit(e, 0)) });
        else if (e.at >= 4) label = jetons(j.getAttribute('data-cmk-g-aria-max'), { total: total, seuil: prixCourt(seuilEcrit(e, 3)) });
        else label = jetons(j.getAttribute('data-cmk-g-aria'), { total: total, seuil: prixCourt(seuilEcrit(e, e.at - 1)), suivant_seuil: prixCourt(seuilEcrit(e, e.at)) });
        if (label) ecrit(piste, label);
      }
    });
    /* Lot R3-D : la pastille « ✓ −40 € », sans mot (plus de gabarit). */
    acquis.forEach(function (a) {
      var ok = !!(e && montre && e.at > 0 && e.aff);
      a.hidden = !ok;
      if (ok) ecrit($('[data-cmk-acquis-t]', a), MOINS + montantEcrit(e, (e.montantsAff || e.montants)[e.at - 1]));
    });
  }

  /* L'ANIMATION. Deux jeux de keyframes identiques (`-a`, `-b`) : basculer de
     l'un à l'autre relance l'animation sans lecture de géométrie, ce qui
     permet de la poser dans le PREMIER temps de `ouvre()`. La classe part
     après la dernière image : la transition de 300 ms reprend la main pour
     les mises à jour de quantité. */
  function joueJauge(j) {
    if (!j || j.hidden) return;
    var at = parseInt(j.getAttribute('data-cmk-jauge-atteint'), 10) || 0;
    var avance = parseFloat(j.style.getPropertyValue('--avance')) || 0;
    for (var i = 0; i < 4; i++) {
      var t = '0ms';
      if (i < at && avance > 0) t = Math.round(J_ATTENTE + J_DUREE * tempsBezier(Math.min(1, POS_CRANS[i] / avance))) + 'ms';
      var c = $('[data-cmk-cran="' + (i + 1) + '"]', j);
      if (c) c.style.setProperty('--t', t);
      /* Lot R3-D : deux rangées (montants au-dessus, seuils dessous). */
      $$('[data-cmk-palier="' + (i + 1) + '"]', j).forEach(function (p) {
        p.style.setProperty('--t', t);
      });
    }
    jaugePhase = jaugePhase === 'a' ? 'b' : 'a';
    j.classList.remove('cmk__jauge--joue-a', 'cmk__jauge--joue-b');
    j.classList.add('cmk__jauge--joue-' + jaugePhase);
    clearTimeout(jaugeMinuteur);
    jaugeMinuteur = setTimeout(function () {
      j.classList.remove('cmk__jauge--joue-a', 'cmk__jauge--joue-b');
    }, J_ATTENTE + J_DUREE + 400);
  }

  function jaugeAffichee(j) {
    if (!j || j.hidden) return;
    joueJauge(j);
    var e = dernierEtatPaliers;
    signalJauge('jauge_affichee', {
      palier: e ? e.at : parseInt(j.getAttribute('data-cmk-jauge-atteint'), 10) || 0,
      base: e ? e.base : 0,
      periode: (e && e.periode) || (window.CM_OFFRE && window.CM_OFFRE.periode) || '',
    });
  }

  /* À l'ouverture du tiroir (appelé par `ouvre`, premier temps). */
  function jaugeALOuverture() {
    if (!scene || !estTiroir) return;
    var j = $('[data-cmk-jauge]', scene);
    if (j && !j.hidden) jaugeJoueePour = jetonOuverture;
    jaugeAffichee(j);
  }

  /* ── LE BANDEAU DE LA RANGÉE ────────────────────────────────────────────
     Correctif du 28/10, 17 h 54 (Raphaël : « la rangée de produits en bas, il
     faut que ce soit pareil qu'avant »). La rangée des paliers EST le rail B du
     test panier : ses cartes sont rendues par Liquid (même donnée, même
     éligibilité, même plancher de trois) et posées par le chemin du rail B
     (`poseLaRangee`, `chercheLaRangee`, `accordeLeRail`), sans tri ni filtre
     par le montant. Le script ne touche ici qu'au BANDEAU : titre « Pour
     atteindre le palier suivant », phrase de l'écart, ou « Vous avez le
     maximum » au dernier palier, avec la période du jour. Le bloc n'est
     jamais masqué parce que l'écart est grand (règle du lot 4, retirée). */
  function majRangeePaliers(e) {
    var hote = hoteOffre();
    var bloc = hote ? $('[data-cmk-paliers]', hote) : null;
    if (!bloc || !e) return;
    var etat = 'rangee';
    if (!e.actif || e.n < 1) etat = 'cache';
    else if (e.at >= 4) etat = 'max';
    bloc.setAttribute('data-cmk-pal-etat', etat);
    /* Lot R3-D : un bloc sans carte (aucun produit éligible, ou rail retiré
       par `accordeLeRail`) n'est pas montré. */
    var aDesCartes = !!$('[data-cmk-off-r] .cmk__off-c', bloc);
    bloc.hidden = etat === 'cache' || !aDesCartes;
    /* Montants insécables : « 20 € » ne se coupe pas avant le symbole. */
    function m(c) {
      return prixCourt(c).replace(/ /g, '\u00a0');
    }
    /* Lot R3-D (retours 3 du 28/10) : la sous-ligne du bloc repliable dit le
       PROCHAIN palier (« Prochain palier : −60 € dès 299 € ») ou le maximum
       (« Vous avez le maximum : −160 € ») ; plus aucune phrase d'écart. Hors
       euro, le seuil converti seul (« Prochain palier dès 2 289 kr »), rien
       au dernier palier. */
    var html = '';
    if (etat === 'max') {
      if (e.aff) html = jetonsHTML(bloc.getAttribute('data-cmk-g-max'), { montant: MOINS + m((e.montantsAff || e.montants)[3]) }, { montant: true });
    } else if (etat === 'rangee') {
      var seuil = m(seuilEcrit(e, e.at));
      if (e.aff) html = jetonsHTML(bloc.getAttribute('data-cmk-g-suivant'), { montant: MOINS + m((e.montantsAff || e.montants)[e.at]), seuil: seuil }, { montant: true });
      else html = jetonsHTML(bloc.getAttribute('data-cmk-g-devise'), { seuil: seuil });
    }
    var texte = $('[data-cmk-pal-texte]', bloc);
    if (texte) {
      if (texte.innerHTML !== html) texte.innerHTML = html;
      texte.hidden = !html;
    }
    accordeLeRepli(bloc);
  }

  /* ── LE BLOC REPLIABLE « COMPLÉTEZ VOTRE INTÉRIEUR »          Lot R3-D ──
     Retours 3 du 28/10 (maquette validée par Raphaël à 23 h 25, copie du
     panier de Tapisya). Replié par défaut ; l'état ouvert est mémorisé dans la
     session (`sessionStorage`, clé `cmk_bloc_ouvert`) et rejoué à chaque
     rendu du bloc (ouverture du tiroir, bloc réinjecté, page /cart). Après un
     ajout depuis le bloc, il reste donc ouvert. La hauteur s'anime en 220 ms
     (grille 0fr vers 1fr, feuille de style § 15) ; le corps replié est
     `visibility: hidden`, donc hors du parcours au clavier et des lecteurs
     d'écran. Le déplier envoie `bloc_ouvert` par le même chemin que
     `jauge_affichee` (collecteur, Clarity, `cm-panier-jauge`). */
  var CLE_BLOC = 'cmk_bloc_ouvert';
  var numBloc = 0;

  function blocMemorise() {
    try {
      return window.sessionStorage.getItem(CLE_BLOC) === '1';
    } catch (err) {
      return false;
    }
  }

  function memoriseBloc(ouvert) {
    try {
      window.sessionStorage.setItem(CLE_BLOC, ouvert ? '1' : '0');
    } catch (err) {
      /* stockage refusé : l'état vaut pour ce rendu seulement */
    }
  }

  function ouvreLeBloc(bloc, ouvert, anime) {
    var bouton = $('[data-cmk-cx]', bloc);
    if (!bouton) return;
    if (!anime) bloc.classList.add('cmk__cx--sans-anim');
    bloc.classList.toggle('is-ouvert', ouvert);
    bouton.setAttribute('aria-expanded', ouvert ? 'true' : 'false');
    if (!anime) {
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          bloc.classList.remove('cmk__cx--sans-anim');
        });
      });
    }
    if (ouvert) prevoisLesFondus();
    /* Ouvert au doigt dans un tiroir court : le corps défile juste assez pour
       montrer les cartes, une fois la hauteur posée. */
    if (ouvert && anime) {
      setTimeout(function () {
        try {
          bloc.scrollIntoView({ block: 'nearest', behavior: reduit() ? 'auto' : 'smooth' });
        } catch (err) {
          /* vieux navigateur */
        }
      }, 240);
    }
  }

  function reduit() {
    try {
      return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    } catch (err) {
      return false;
    }
  }

  function accordeLeRepli(bloc) {
    if (!bloc) return;
    var bouton = $('[data-cmk-cx]', bloc);
    var corps = $('[data-cmk-cx-corps]', bloc);
    if (!bouton || !corps) return;
    if (!corps.id) {
      numBloc += 1;
      corps.id = 'CmkBloc-' + numBloc;
    }
    if (bouton.getAttribute('aria-controls') !== corps.id) bouton.setAttribute('aria-controls', corps.id);
    var voulu = blocMemorise();
    if (bloc.classList.contains('is-ouvert') !== voulu) ouvreLeBloc(bloc, voulu, false);
  }

  document.addEventListener('click', function (event) {
    var bouton = event.target && event.target.closest ? event.target.closest('[data-cmk-cx]') : null;
    if (!bouton) return;
    var bloc = bouton.closest('[data-cmk-paliers]');
    if (!bloc) return;
    if (!modaliteClavier) {
      bouton.classList.add('cm-focus-muet');
      bouton.addEventListener('blur', function retire() {
        bouton.classList.remove('cm-focus-muet');
        bouton.removeEventListener('blur', retire);
      });
    }
    var ouvert = !bloc.classList.contains('is-ouvert');
    memoriseBloc(ouvert);
    ouvreLeBloc(bloc, ouvert, true);
    if (ouvert) {
      var e = dernierEtatPaliers;
      signalJauge('bloc_ouvert', {
        palier: e ? e.at : 0,
        base: e ? e.base : 0,
        periode: (e && e.periode) || (window.CM_OFFRE && window.CM_OFFRE.periode) || '',
      });
    }
  });

  /* ── LA JAUGE OUVRE LA FENÊTRE D'EXPLICATION                   Lot R3-D ──
     Toucher la jauge (ou Entrée / Espace au clavier) ouvre la fenêtre
     d'explication de l'offre en variante panier : le lot R3-B y masque le bloc
     e-mail. Ce fichier n'envoie que l'événement. Au doigt, la jauge reçoit
     `cm-focus-muet` (pas d'anneau quand la fenêtre rend le focus). */
  function ouvreLaFenetre(j) {
    if (!modaliteClavier) {
      j.classList.add('cm-focus-muet');
      j.addEventListener('blur', function retire() {
        j.classList.remove('cm-focus-muet');
        j.removeEventListener('blur', retire);
      });
    }
    try {
      document.dispatchEvent(new CustomEvent('cm-offre-ouvrir', { detail: { variante: 'panier' } }));
    } catch (err) {
      /* vieux navigateur : rien */
    }
  }

  document.addEventListener('click', function (event) {
    var j = event.target && event.target.closest ? event.target.closest('[data-cmk-jauge]') : null;
    if (j) ouvreLaFenetre(j);
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Enter' && event.key !== ' ') return;
    var j = event.target && event.target.closest ? event.target.closest('[data-cmk-jauge]') : null;
    if (!j || event.target !== j) return;
    event.preventDefault();
    ouvreLaFenetre(j);
  });

  function majPaliers(cart, optimiste) {
    var e = etatPaliers(cart);
    if (!e) return;
    /* Correctif du 28/10, 17 h : le tiroir ouvert par un ajout depuis un
       panier VIDE trouvait la jauge cachée à l'ouverture ; elle apparaissait
       ensuite sans son animation (et sans `jauge_affichee`), alors que le
       tiroir rouvert par l'icône la jouait. Une jauge qui APPARAÎT pendant
       que le tiroir est ouvert se joue donc comme à l'ouverture, une fois par
       ouverture. */
    var jT = estTiroir && ouvert && scene ? $('[data-cmk-jauge]', scene) : null;
    var etaitCachee = jT ? jT.hidden : false;
    majJauge(e);
    majRangeePaliers(e);
    dernierEtatPaliers = e;
    if (jT && etaitCachee && !jT.hidden && jaugeJoueePour !== jetonOuverture) {
      jaugeJoueePour = jetonOuverture;
      jaugeAffichee(jT);
    }
    if (optimiste) return;
    if (dernierAtteint !== null && e.actif && e.at > dernierAtteint) {
      signalJauge('palier_franchi', { de: dernierAtteint, a: e.at, base: e.base, periode: e.periode || '' });
    }
    dernierAtteint = e.at;
    /* Sur /cart, la jauge est dans la page : elle se remplit une fois, au
       premier panier lu (sa valeur est alors juste, hors euro compris). */
    if (!estTiroir && !pageJaugeJouee) {
      pageJaugeJouee = true;
      jaugeAffichee($('[data-cmk-jauge]', scene));
    }
  }

  /* ── LE SECOND ARGUMENT, VAGUE 13 LOT F (03/09) ────────────────────────
     `optimiste` vaut vrai quand le panier passe n'est pas celui du serveur mais
     celui que le § 5 vient d'ecrire au clic (`panierFictif`). Il change deux
     choses, et deux seulement :

       · AUCUN CODE N'EST POSE. `poseLeCode` ECRIT dans le panier Shopify ;
         l'ecrire a partir d'un panier suppose serait poser une remise pour un
         tapis qui n'est peut-etre pas entre. Le vrai `majOffre` s'en charge une
         demi-seconde plus tard, quand le serveur a repondu ;
       · AUCUN BLOC N'EST RETIRE. Un panier fictif ne peut qu'AJOUTER a ce qui
         est a l'ecran. S'il ne sait pas quoi montrer, il se tait et laisse en
         place ce que le serveur avait rendu.

     ET LA ZONE RESERVEE SE LIBERE ICI, au premier rendu reel : c'est le seul
     endroit par lequel passent les deux chemins (le bus `cart-update` et
     `cart:refresh`), y compris quand l'ajout a ete REFUSE. */
  function majOffre(cart, optimiste) {
    litOffre();
    if (!optimiste) {
      var hoteZone = hoteOffre();
      if (hoteZone) hoteZone.removeAttribute('data-cmk-off-attente');
    }
    if (!OFFRE) return;
    var meca = OFFRE.meca || 'article_n';
    var ouverte = offreOuverte();
    var etat = etatOffre(cart);
    /* LE CODE N'APPARTIENT QU'A `article_n`. Les deux autres mecaniques ne
       promettent pas une remise : l'une dit une distance, l'autre une date.
       Poser un code de reduction pour elles serait promettre en silence. */
    if (meca === 'article_n' && !optimiste) poseLeCode(ouverte ? etat.n : 0, cart);
    var seuil = OFFRE.seuil || 2;
    if (meca === 'article_n') {
      /* VAGUE 11 : LE BLOC NE DISPARAIT PLUS QUAND L'OFFRE EST ACQUISE. Il
         disait jusqu'ici « -20 % sur votre 2e tapis » puis se taisait des le
         second tapis. Avec une remise ILLIMITEE (point 3 de Raph), se taire
         serait cacher que le quatrieme tapis rapporte encore quelque chose :
         le bandeau reste, et sa ligne forte devient le compte reel des tapis
         remises et leur montant reel. */
      if (ouverte && etat.premier && etat.n >= 1) {
        poseLaRangee(etat.premier);
        /* VAGUE 13, LOT G : LE MEME JUGEMENT COMMANDE LES DEUX LIGNES. Tant
           qu'un autre code emporte la remise, la ligne forte reprend le titre
           (« -20 % sur votre 2e tapis », une promesse) au lieu du texte acquis
           (« -20 % applique... », une affirmation), et la ligne seconde dit
           pourquoi. Une seule variable pour les deux : elles ne peuvent pas se
           contredire. */
        var nc = nonCumulDe(cart, etat);
        majTete(etat, etat.n >= seuil && !nc);
        majSousTitre(nc);
        majPrixRail(etat);
      } else if (!optimiste) retireLeBloc();
    } else if (meca === 'paliers') {
      /* Casemira 28/10/2026 (offre de novembre), correctif de 17 h 54 : la
         rangée vit exactement comme le rail B du test panier. Elle s'accroche
         au premier tapis éligible (bloc du serveur, réserve de la page
         produit, bloc nu puis page produit, sans réinjection tant que le
         handle ne change pas) et sort quand il n'y en a plus. Puis la jauge
         et le bandeau sont recalculés avec la période du jour. */
      var oPal = window.CM_OFFRE;
      /* Retour de Raphaël du 29/10 (10 h 04) : un panier venu du site en ligne
         peut encore porter le code DUO20 posé par le bras B du test panier ;
         Shopify coupe alors la ligne en deux unités dont une « -20 % ». En
         `paliers`, le code duo n'est jamais dû : s'il est là, on le retire
         (`poseLeCode(0)` n'écrit que si le code est présent), et la ligne se
         recompose. Le reste de la liste des codes du client est conservé. */
      if (!optimiste) {
        poseLeCode(0, cart);
        poseCodeAcces(cart);
      }
      if (oPal && oPal.actif === false) {
        /* L'offre est finie (période `decembre` à l'heure de Paris) : plus de
           rangée, la jauge se cache dans `majPaliers`. */
        if (!optimiste) retireLeBloc();
      } else if (etat.premier && etat.n >= 1) {
        poseLaRangee(etat.premier);
      } else if (!optimiste) retireLeBloc();
      majPaliers(cart, optimiste);
    } else if (!cart.item_count && !optimiste) {
      /* Les deux autres mecaniques sont decidees par le serveur et le script
         n'a pas a les rejouer. Il ne connait qu'un cas qu'elles ne peuvent pas
         prevoir : le panier vide en cours de session. Une promesse sous un
         panier vide n'a personne a qui parler. */
      retireLeBloc();
    }
    majProgression(cart);
  }

  /* Le « + » d'une tuile : le CHEMIN D'AJOUT DE LA VAGUE 1, ligne provisoire
     puis reconciliation. La difference avec la fiche produit est qu'ici aucun
     formulaire du theme ne part a notre place : c'est ce code qui poste, et
     c'est le seul endroit du fichier qui ajoute quelque chose au panier. */
  var ajoutEnVol = false;

  function ajouteComplement(bouton) {
    if (ajoutEnVol) return;
    var vid = parseInt(bouton.getAttribute('data-cmk-off-add'), 10);
    if (!vid) return;
    var tuile = bouton.closest('.cmk__off-c');
    var img = tuile ? $('img', tuile) : null;
    var nomEl = tuile ? $('.cmk__off-n', tuile) : null;
    var prixEl = tuile ? $('.cmk__off-p', tuile) : null;
    /* VAGUE 13 : LA CARTE N'A PLUS DE NOM, ET L'ANNONCE VOCALE EN A BESOIN.
       Raph, 03/09 : « pas de nom de produit, ca rajoute du bruit ». Le bruit
       visuel, oui ; l'annonce « Sahel rond ajoute au panier » n'en est pas, et
       elle est la seule confirmation qu'un lecteur d'ecran recoit. Le titre
       ENTIER vit toujours dans l'attribut `title` du lien de la photo, la ou il
       ne coute aucun pixel : c'est lui qu'on lit quand la ligne du nom n'existe
       pas. Le repli final reste une chaine de la locale, jamais une phrase
       ecrite ici. */
    var lienEl = tuile ? $('.cmk__off-l', tuile) : null;
    var nom =
      (nomEl && (nomEl.getAttribute('title') || nomEl.textContent.trim())) ||
      (lienEl && lienEl.getAttribute('title')) ||
      S.ajoutDefaut ||
      'Ce tapis';
    /* § 8 : la mesure qui converge le plus vite. Le rang de la tuile part avec
       elle : c'est la seule chose que le pipeline de complements ne sait pas
       encore, et elle dira si le rang 1 vaut le rang 4. */
    var rang = tuile && tuile.parentNode
      ? Array.prototype.indexOf.call(tuile.parentNode.children, tuile) + 1
      : 0;
    /* VAGUE 6 : `rail_add` MESURE LE RAIL DE L'OFFRE, ET LUI SEUL. L'etat vide
       porte desormais des cartes du meme dessin, avec le meme « + » ; un ajout
       fait depuis un panier VIDE n'appartient pas au denominateur du test A/B,
       et le compter gonflerait le taux d'acceptation de l'offre d'un geste qui
       n'a rien a voir avec elle. Le rail de l'offre se reconnait a son ancetre
       `[data-cmk-off]`, que la rangee de l'etat vide n'a pas. */
    if (bouton.closest('[data-cmk-off]')) mesure('rail_add', { position: rang });
    ajoutEnVol = true;
    bouton.disabled = true;
    /* VAGUE 13, LOT F : LE HANDLE VOYAGE AVEC LA GRAINE. La carte du rail
       porte deja la VUE A PLAT (`image_url: width: 240` dans le snippet) : c'est
       exactement la photo que la vraie ligne voudra. La garder evite le
       telechargement de l'image de variante et le rectangle gris entre les deux
       (`CHRONO-V13.md` § 4). L'adresse est celle du lien de la photo, la seule
       source de handle qu'une carte porte. */
    var hrefEl = lienEl ? lienEl.getAttribute('href') || '' : '';
    var mh = /\/products\/([^/?#]+)/.exec(hrefEl);
    ligneProvisoire({
      titre: nom,
      img: img ? img.currentSrc || img.src : '',
      prix: prixEl ? prixEl.textContent.trim() : '',
      handle: mh ? decodeURIComponent(mh[1]) : '',
    });
    post(RACINE + 'cart/add.js', { id: vid, quantity: 1 })
      .then(rafraichis)
      .then(function () {
        dire(avec(S.ajoutDit || '[produit] ajouté au panier.', 'produit', nom));
      })
      .catch(function () {
        rafraichis();
        dire(S.ajoutEchec || 'Cet article n’a pas pu être ajouté. Vérifiez la disponibilité du format.');
      })
      .then(function () {
        ajoutEnVol = false;
      });
  }

  document.addEventListener('click', function (event) {
    var t = event.target;
    if (!t || typeof t.closest !== 'function') return;
    if (!scene || !scene.contains(t)) return;
    var plus = t.closest('[data-cmk-off-add]');
    if (!plus || plus.disabled) return;
    event.preventDefault();
    ajouteComplement(plus);
  });

  /* ══════════════════════════════════════════════════════════════════════
     § 8. LE TEST A/B ET LA MESURE
     ----------------------------------------------------------------------
     TROIS CHOSES, ET ELLES NE SE MELANGENT PAS.

     1. LE BRAS. Il vient du biscuit `cm_ab_panier`, tire une fois pour 180
        jours par `snippets/casemira-ab.liquid`, en ligne dans le `<head>` de
        TOUTES les pages. Ici, on ne le tire pas : on le LIT, et on n'agit que
        si la section dit que le test tourne (`test_actif`).

        ═══ VAGUE 13 (03/09) : LE TEST CHANGE DE QUESTION ═══════════════════

        CE QU'IL DEMANDAIT JUSQU'ICI : « le bloc d'offre sert-il a quelque
        chose ? ». Le bras A retirait TOUT - le bandeau, la configuration, le
        code de reduction - et le bras B avait l'offre entiere.

        CE QU'IL DEMANDE MAINTENANT, ET C'EST LA DECISION DE RAPH DU 03/09 :
        « le rail par piece sert-il a quelque chose ? »

          bras A   panier + bandeau « -20 % sur votre 2e tapis » SEUL ;
          bras B   panier + bandeau + rail par piece.

        LA REMISE ET LE BANDEAU SONT DANS LES DEUX BRAS, ET CE N'EST PAS UN
        CHOIX DE GOUT : la remise duo est une remise AUTOMATIQUE de Shopify,
        posee sur la commande par la collection `duo-eligibles`. On ne peut pas
        la retirer a la moitie des visiteurs sans creer deux prix pour le meme
        panier. Le bandeau, lui, dit la remise : le cacher a des gens qui
        l'obtiennent quand meme ferait du bras A une boutique qui remise en
        silence, ce qui n'est pas un bras de test, c'est un defaut.

        CE QUI CHANGE DANS LE CODE : le bras A ne perd plus que les
        SUGGESTIONS - l'intitule, la rangee de puces, les rails et leurs
        reserves. La configuration reste lue, le code duo reste pose, le
        bandeau reste rendu, et `offer_shown` continue de mesurer la meme chose
        des deux cotes : le bandeau vu. La difference mesuree devient donc
        exactement ce qu'on veut mesurer, le rail, et rien d'autre.

        LA FEUILLE DU `<head>` SUIT LA MEME REGLE (`casemira-ab.liquid`) : elle
        n'efface plus le bloc, elle efface ses trois parties de rail, avant la
        premiere image. Ce qui est fait ici l'est pour les blocs INJECTES
        ensuite, que le style seul ne suffirait pas a tenir : voir
        `accordeLeRail`, appele sur chaque bloc mis en place.

     2. L'ATTRIBUT DE PANIER. `attributes[ab_panier]`, pose une fois par
        panier, des qu'un panier existe. C'est lui, et lui seul, qui fait
        arriver le bras sur la COMMANDE : Shopify porte les attributs de
        panier jusqu'aux `customAttributes` de la commande, que la synchro du
        dashboard lit deja (`resolveAbPanier`). Il est pose AUX DEUX BRAS,
        evidemment : un test dont un seul bras est etiquete ne se lit pas.
        Il n'est JAMAIS ecrase : si le panier en porte deja un, il reste. Un
        visiteur qui a rempli son panier hier garde le bras d'hier, et sa
        commande est comparable a celle d'hier.

     3. LES QUATRE EVENEMENTS. Le contrat vit dans
        `casemira-dashboard/docs/mesure-c4-panier.md`, § 2, et il est court :

          drawer_open    le tiroir devient visible. LE DENOMINATEUR.
          offer_shown    le bloc d'offre est reellement A L'ECRAN, une seconde
                         pleine. Pas « rendu dans le DOM » : sur telephone, une
                         offre sous la ligne de flottaison n'existe pas.
          rail_add       le « + » d'une tuile de la rangee.
          checkout_click « Commander », ou un bouton de paiement express.
                         LE GARDE-FOU : si l'offre distrait, il baisse.

        `add_to_cart` et le passage au paiement ne sont PAS instrumentes :
        Shopify les donne mieux, par le tunnel nocturne. Chaque evenement de
        plus est une dette.

        UNE CHOSE A SAVOIR AVANT DE LIRE LES TAUX : SUR /cart, `offer_shown`
        PART SANS `drawer_open`. Il n'y a pas de tiroir sur cette page, le bloc
        est dans le flux du document, et il peut donc etre vu sans qu'aucun
        tiroir ne s'ouvre. Le taux « offre vue » (`offer_shown / drawer_open`)
        se lit donc HORS `page_type = 'cart'`, et le champ est justement la
        pour cela. L'autre sortie aurait ete de se taire sur /cart, ce qui
        aurait perdu une surface entiere pour arranger une division.

        AUCUNE DONNEE PERSONNELLE, ET C'EST CE QUI PERMET DE NE PAS ATTENDRE
        LE CONSENTEMENT. Un identifiant de session tire au sort et garde en
        `sessionStorage` (il meurt avec l'onglet), le bras, l'appareil, le
        nombre d'articles, le montant, le type de page. Ni courriel, ni
        identifiant de client, ni numero de commande, ni adresse IP (le
        collecteur la lit pour son debit et la jette). C'est la definition de
        l'exemption « mesure d'audience » ; attendre le consentement ferait
        perdre l'exemption ET la moitie du denominateur.

        L'ENVOI NE PEUT PAS FAIRE DE BRUIT. `events_url` vide : on ne part
        pas, et c'est un etat normal, pas une panne. Pas de `sendBeacon` dans
        le navigateur, reseau coupe, collecteur en panne : `sendBeacon` ne
        rend qu'un booleen, ne lance rien et ne se relit pas. Tout est dans un
        `try`. Un compteur qui casse un panier serait un compteur qui coute
        plus qu'il ne rapporte.

        LE MEME GESTE EST AUSSI UN TAG CLARITY, ET C'EST TROIS LIGNES. Clarity
        est charge en differe par `snippets/casemira-clarity-deferred.liquid` :
        avant son chargement, `window.clarity` n'existe pas. On pose donc la
        file d'attente officielle de Clarity (`clarity.q`), celle que le tag
        vide a son arrivee et que son propre amorceur garde s'il la trouve
        deja posee (`c[a] = c[a] || ...`). Resultat : des enregistrements de
        session filtrables sur ces quatre moments, donc le « pourquoi » que les
        compteurs ne donneront jamais.
     ══════════════════════════════════════════════════════════════════════ */

  var AB = { test: false, url: '', page: 'other', bras: '' };
  var abLu = false;

  function litAB() {
    if (abLu) return;
    abLu = true;
    var el = scene ? $('[data-cmk-mesure]', scene) : null;
    if (el) {
      try {
        var c = JSON.parse(el.textContent);
        AB.test = c.test === true;
        AB.url = String(c.url == null ? '' : c.url).trim();
        AB.page = c.page || 'other';
      } catch (e) {
        /* configuration illisible : ni test, ni envoi */
      }
    }
    AB.bras = brasDuBiscuit();
  }

  /* LE BRAS SE LIT D'ABORD DANS `window.CM_AB`, ET C'EST VOULU. Le script du
     `<head>` y range la valeur qu'il vient de tirer, MEME quand l'ecriture du
     biscuit a echoue (navigation privee verrouillee, biscuits refuses) : la
     page reste alors coherente avec ce qu'elle a affiche, au lieu de basculer
     d'un bras a l'autre entre le style et le script. Le biscuit est le repli,
     pour le jour ou ce fichier serait charge sans l'autre. */
  function brasDuBiscuit() {
    try {
      if (window.CM_AB && (window.CM_AB.bras === 'A' || window.CM_AB.bras === 'B')) return window.CM_AB.bras;
      var m = document.cookie.match(/(?:^|;\s*)cm_ab_panier=([AB])(?:\s*;|\s*$)/);
      return m ? m[1] : '';
    } catch (e) {
      return '';
    }
  }

  /* Le test tourne-t-il, et sur quel bras ? Hors test, la question ne se pose
     pas : c'est `offre_active` qui decide, comme a la vague 2. */
  function brasB() {
    return !AB.test || AB.bras === 'B';
  }

  /* ── LE BRAS A PERD LE RAIL, ET RIEN D'AUTRE ────────────────────────────
     VAGUE 13. Avant, cette fonction VIDAIT l'hote de l'offre et jetait les deux
     reserves : plus de bandeau, plus de configuration, donc plus de code duo.
     Le bras A doit maintenant garder tout cela et ne perdre que les
     suggestions. On epure donc, sur place, le bloc rendu par le serveur ET le
     contenu des deux `<template>` - le bandeau nu du bug 8 et la rangee du
     produit de la page - pour que ce qui sera injecte plus tard le soit deja
     sans rail. `accordeLeRail` refait le geste sur chaque bloc mis en place :
     ici on ferme le premier rendu, la-bas tous les suivants. */
  function effaceLeRail() {
    var hote = hoteOffre();
    if (hote) retireLesRails(hote);
    $$('[data-cmk-off-tpl], [data-cmk-off-nu]').forEach(function (t) {
      if (t.content) retireLesRails(t.content);
    });
  }

  /* ── L'attribut de panier ───────────────────────────────────────────────
     Une seule ecriture par page, et jamais par-dessus une valeur existante.
     `/cart/update.js` avec `attributes` ne touche a rien d'autre : le champ
     `discount` du § 7 et celui-ci vivent cote a cote sans se marcher dessus,
     ce qui est verifie par le controle de la vague. */
  var attributEnVol = false;
  var attributPose = false;

  function majAttributAB(cart) {
    if (!AB.test || attributPose || attributEnVol) return;
    if (!cart || !cart.item_count) return;
    var deja = (cart.attributes || {}).ab_panier;
    if (deja === 'A' || deja === 'B') {
      attributPose = true;
      return;
    }
    var bras = AB.bras === 'B' ? 'B' : 'A';
    attributEnVol = true;
    post(RACINE + 'cart/update.js', { attributes: { ab_panier: bras } })
      .then(function () {
        attributPose = true;
      })
      .catch(function () {
        /* Shopify a refuse : on retentera au prochain rendu, sans bruit. */
      })
      .then(function () {
        attributEnVol = false;
      });
  }

  /* ── L'identifiant de session ───────────────────────────────────────────
     En `sessionStorage`, JAMAIS en `localStorage` ni en biscuit : il doit
     mourir a la fermeture de l'onglet. Seize signes de [0-9a-z], donc dans les
     bornes du contrat (8 a 64 signes de `[A-Za-z0-9_-]`). */
  var SID = '';

  function sessionId() {
    if (SID) return SID;
    var neuf = (Date.now().toString(36) + Math.random().toString(36).slice(2, 10)).slice(0, 20);
    try {
      SID = sessionStorage.getItem('cm_sid') || '';
      if (!/^[A-Za-z0-9_-]{8,64}$/.test(SID)) {
        SID = neuf;
        sessionStorage.setItem('cm_sid', SID);
      }
    } catch (e) {
      SID = SID || neuf;
    }
    return SID;
  }

  /* Les trois valeurs du contrat, et rien d'autre. La frontiere de 1000 px est
     celle du fichier (`DESKTOP`) : au-dessus, le panier est un tiroir de
     480 px et l'appareil est un ordinateur. */
  function appareil() {
    var w = window.innerWidth || 0;
    if (w < 768) return 'mobile';
    if (w < DESKTOP) return 'tablet';
    return 'desktop';
  }

  var clarityPosee = false;

  function tagClarity(nom) {
    try {
      if (!window.clarity) {
        window.clarity = function () {
          (window.clarity.q = window.clarity.q || []).push(arguments);
        };
      }
      if (!clarityPosee && AB.test && (AB.bras === 'A' || AB.bras === 'B')) {
        clarityPosee = true;
        window.clarity('set', 'cm_ab_panier', AB.bras);
      }
      window.clarity('event', nom);
    } catch (e) {
      /* Clarity absent ou en erreur : ce n'est pas notre affaire */
    }
  }

  function mesure(nom, extra) {
    tagClarity(nom);
    if (!AB.url) return;
    try {
      if (!navigator.sendBeacon) return;
      var c = dernierPanier;
      var corps = {
        event: nom,
        session_id: sessionId(),
        /* Hors test, le bras ne veut rien dire : on n'en invente pas un. */
        ab_panier: AB.test && (AB.bras === 'A' || AB.bras === 'B') ? AB.bras : null,
        device: appareil(),
        items: c && typeof c.item_count === 'number' ? c.item_count : null,
        amount: c && typeof c.total_price === 'number' ? c.total_price : null,
        page_type: AB.page,
      };
      if (extra) corps.extra = extra;
      /* `text/plain` a dessein : c'est une requete SIMPLE, donc sans
         prevol, donc sans un aller-retour de plus au moment ou le client
         clique sur « Commander ». */
      navigator.sendBeacon(AB.url, new Blob([JSON.stringify(corps)], { type: 'text/plain' }));
    } catch (e) {
      /* Un compteur ne casse jamais un panier. */
    }
  }

  /* ── « L'offre a ete VUE » ──────────────────────────────────────────────
     Pas « rendue » : VUE, la moitie du bloc a l'ecran, une seconde pleine.
     Le tiroir ferme vit hors du cadre (translation), l'observateur ne le voit
     donc pas, et c'est exactement ce qu'on veut : un bloc rendu dans un
     tiroir que personne n'a ouvert n'a ete vu par personne.

     UNE FOIS PAR OUVERTURE, et pas une de plus : le drapeau retombe a chaque
     `ouvre()`. Sans cela, un client qui fait defiler le tiroir de haut en bas
     enverrait dix `offer_shown` pour un `drawer_open`, et le taux « offre
     vue » depasserait 100 %. */
  var vuEnvoye = false;
  var vuTimer = null;
  var vuObs = null;

  function surveilleLOffre() {
    if (typeof IntersectionObserver !== 'function') return;
    if (!vuObs) {
      vuObs = new IntersectionObserver(
        function (entrees) {
          entrees.forEach(function (e) {
            if (e.isIntersecting && e.intersectionRatio >= 0.5) {
              if (vuTimer || vuEnvoye) return;
              vuTimer = setTimeout(function () {
                vuTimer = null;
                if (vuEnvoye) return;
                vuEnvoye = true;
                mesure('offer_shown');
              }, 1000);
            } else if (vuTimer) {
              clearTimeout(vuTimer);
              vuTimer = null;
            }
          });
        },
        { threshold: [0, 0.5] }
      );
    }
    vuObs.disconnect();
    if (vuTimer) {
      clearTimeout(vuTimer);
      vuTimer = null;
    }
    var bloc = scene ? $('[data-cmk-off]', scene) : null;
    if (bloc) vuObs.observe(bloc);
  }

  /* ── Le clic vers le paiement ───────────────────────────────────────────
     EN CAPTURE, sur le document : le bouton « Commander » soumet un
     formulaire et la page part ; un ecouteur qui remonterait la chaine
     pourrait ne jamais etre appele.

     CE QUI EST HORS DE PORTEE, ET IL FAUT LE DIRE : PayPal rend son bouton
     dans un CADRE inter-origines, et un clic dans un cadre ne traverse
     jamais sa frontiere. Apple Pay et Shop Pay, eux, sont des elements du
     document (DOM fantome, evenements composes) et sont donc vus. Le
     garde-fou du test reste le bouton principal, qui porte la quasi-totalite
     des passages au paiement. */
  document.addEventListener(
    'click',
    function (event) {
      var t = event.target;
      if (!t || typeof t.closest !== 'function') return;
      if (!scene || !scene.contains(t)) return;
      if (t.closest('[data-cmk-cta]')) {
        mesure('checkout_click', { via: 'cta' });
        return;
      }
      if (t.closest('.cmk__wallets')) mesure('checkout_click', { via: 'express' });
    },
    true
  );

  /* ── 14/10/2026 · LA DATE DU PANIER PART AVEC LA COMMANDE ────────────────
     POUR QUI. Le mail de confirmation écrit « Livraison prévue le … » sans
     rien recalculer (commun/mails-shopify/maquettes-2026-10-13/NOTES.md § 8).
     La propriété de ligne posée sur la fiche dit ce que le client a vu à
     l'ajout ; un panier gardé deux jours, ou une heure limite passée entre
     l'ajout et le paiement, la rendent fausse. Au clic sur « Commander », on
     pose donc ce qui est vrai À CET INSTANT, en attributs de panier :
     `_livraison_promise`, `_livraison_expedie` (ISO) et `_livraison_pays`. Le
     souligné les cache au paiement ; Shopify les porte jusqu'à la commande.

     LE MÊME CALCUL QUE LA RANGÉE « Livraison » DU TIROIR (`calculeLivraison`) :
     `estimateCart` du moteur commun, le pays du marché, le même panier. Une
     seule différence, voulue : les pièces d'atelier (`semainesSurCommande`)
     sont écartées, la date ne vaut que pour ce qui part sous 24 à 48 h.
     Panier sans ligne datée : les trois attributs partent vides, ce qui efface
     la valeur d'un clic précédent.

     PAS DE REQUÊTE DE PLUS POUR « Commander ». Le bouton soumet déjà un POST
     vers `routes.cart_url` (racine de langue comprise), le point d'entrée de
     `/cart/update` : trois champs `attributes[…]` ajoutés à ce formulaire au
     moment du clic partent avec lui, et Shopify les enregistre avant de
     rediriger vers le paiement. Un `fetch` lancé ici ferait la course avec la
     navigation, ou retarderait le paiement du temps de `/cart/update.js`.
     Les portefeuilles ne soumettent pas ce formulaire : pour eux, un seul
     `POST /cart/update.js` au clic, en `keepalive`, sans rien attendre.
     PayPal rend son bouton dans un cadre et son clic n'est pas vu (voir la
     mesure ci-dessus) : le mail prend alors les propriétés de ligne. */
  function attributsLivraison() {
    var moteur = window.CasemiraDelivery;
    if (!moteur) return null;
    var panier = panierLivraisonProvisoire || dernierPanier;
    var items = (panier ? panier.items : CFG.deliveryItems) || [];
    if (items.some(function (item) { return item.key === 'cmk-optimiste' && !item.vendor; })) return null;
    var expedies = items.filter(function (item) { return !(semainesSurCommande([item]) > 0); });
    var pays = moteur.currentCountry();
    var estimation = moteur.estimateCart({ country: pays, items: expedies });
    if (!estimation) return { _livraison_promise: '', _livraison_expedie: '', _livraison_pays: '' };
    return {
      _livraison_promise: estimation.deliveryDate.toISOString().slice(0, 10),
      _livraison_expedie: estimation.dispatchDate.toISOString().slice(0, 10),
      _livraison_pays: pays,
    };
  }

  document.addEventListener(
    'click',
    function (event) {
      var t = event.target;
      if (!t || typeof t.closest !== 'function') return;
      if (!scene || !scene.contains(t)) return;
      var cta = t.closest('[data-cmk-cta]');
      if (!cta && !t.closest('.cmk__wallets')) return;
      var attributs;
      try {
        attributs = attributsLivraison();
      } catch (e) {
        attributs = null;
      }
      if (!attributs) return;
      if (cta) {
        var form = cta.form || cta.closest('form');
        if (!form) return;
        Object.keys(attributs).forEach(function (cle) {
          var nom = 'attributes[' + cle + ']';
          var champ = form.querySelector('input[name="' + nom + '"]');
          if (!champ) {
            champ = document.createElement('input');
            champ.type = 'hidden';
            champ.name = nom;
            form.appendChild(champ);
          }
          champ.value = attributs[cle];
        });
        return;
      }
      try {
        fetch(RACINE + 'cart/update.js', {
          method: 'POST',
          keepalive: true,
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ attributes: attributs }),
        }).catch(function () {
          /* le mail prend les propriétés de ligne, sans bruit */
        });
      } catch (e) {
        /* idem */
      }
    },
    true
  );

  /* ══════════════════════════════════════════════════════════════════════
     § 9. L'ELEMENT DE COMPATIBILITE, ET LE DEMARRAGE
     ----------------------------------------------------------------------
     `<cart-drawer>` garde son nom : `theme.js` (apres un ajout),
     `products-bundle-selection.js` et `casemira-couloir-calculator.js`
     appellent `document.querySelector('cart-drawer').show(...)`. Trois
     methodes suffisent a les servir, et elles tiennent en dix lignes.
     ══════════════════════════════════════════════════════════════════════ */

  if (!customElements.get('cart-drawer')) {
    customElements.define(
      'cart-drawer',
      class extends HTMLElement {
        get open() {
          return ouvert;
        }
        show(depuis) {
          ouvre(depuis || null);
        }
        hide() {
          ferme();
        }
      }
    );
  }

  function demarre() {
    scene = document.querySelector('[data-cmk-scene]');
    if (!scene) return;
    estTiroir = scene.classList.contains('cmk--drawer');
    /* L'ORDRE COMPTE, ET IL A CHANGE DE RAISON A LA VAGUE 13. Le bras se lit
       AVANT que les reserves ne soient memorisees : au bras A, l'intitule, les
       puces et les rails quittent le bloc rendu ET les deux `<template>`, donc
       ce que `memoriseLesRangees` gardera est deja sans rail. Le bandeau, la
       configuration et le code duo, eux, RESTENT dans les deux bras (voir la
       note du § 8). La feuille du `<head>` a deja empeche la premiere image. */
    litAB();
    if (!brasB()) effaceLeRail();
    memoriseLesPlats();
    litOffre();
    memoriseLesRangees();
    var s = sheet();
    if (s && estTiroir) s.setAttribute('inert', '');
    /* VAGUE 5 : la largeur de la barre de defilement, mesuree une fois ici et
       plus jamais sur le chemin du clic. Voir `mesureLaBarre()`. */
    mesureLaBarre();
    dateLivraison();
    // Actualise aussi un panier laissé ouvert pendant la coupure de 11h30.
    clearInterval(window.casemiraCartDeliveryTimer);
    window.casemiraCartDeliveryTimer = setInterval(dateLivraison, 30000);
    /* Sur /cart le bloc est dans le flux de la page : il peut etre vu sans
       qu'aucun tiroir ne s'ouvre. */
    surveilleLOffre();

    /* ★ LOT L : la photo que la ligne du panier montrera est chauffee pendant
       un temps mort, apres le chargement. Voir la note de
       `chauffeLaVignette`. */
    auCalme(chauffeLaVignette);

    /* La verite du panier, une fois, sans bloquer : `dernierPanier` sert a
       « Annuler » et aux codes. Aucun rendu n'est declenche si rien n'a
       change, pour ne pas repeindre une page qui vient d'etre servie. */
    panierFrais()
      .then(function (c) {
        dernierPanier = c;
        dateLivraison();
        var n = $$('[data-cmk-line]', scene).length;
        if (n !== c.items.length) rendu(c);
        else {
          majOffre(c);
          majAttributAB(c);
        }
      })
      .catch(function () {
        /* hors ligne : la page rendue par Liquid reste juste */
      });

    /* Le theme publie `cart-update` apres chaque ajout par `product-form` :
       c'est notre source de verite, et elle arrive sans requete de notre
       part. `cart:refresh` est le second chemin, celui des scripts Casemira
       (echantillons, couloir, sur mesure, sous-couche). */
    try {
      if (window.FoxTheme && FoxTheme.pubsub) {
        FoxTheme.pubsub.subscribe(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, function (data) {
          if (moiMeme) return;
          if (data && data.cart && typeof data.cart.item_count === 'number') rendu(data.cart);
        });
      }
    } catch (e) {
      /* pas de bus : `cart:refresh` suffit */
    }

    document.addEventListener('cart:refresh', function (event) {
      var d = event.detail || {};
      if (d.cart && typeof d.cart.item_count === 'number') rendu(d.cart);
      else rafraichis();
      if (d.open === true) ouvre();
    });

    /* Casemira 28/10/2026 (offre de novembre) : l'offre du jour arrive
       (`cm-offre-prete`) ou change à minuit, heure de Paris
       (`cm-offre-periode`) : la jauge, la rangée et la ligne de remise
       reprennent les montants et le nom de la période, sans animation. */
    function offreDuJour() {
      if (!dernierPanier) return;
      majPied(dernierPanier);
      majOffre(dernierPanier);
    }
    document.addEventListener('cm-offre-prete', offreDuJour);
    document.addEventListener('cm-offre-periode', offreDuJour);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', demarre);
  else demarre();
})();
